// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Roboto/Roboto-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Roboto/Roboto-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Roboto/Roboto-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Roboto/Roboto-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/Roboto/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/Roboto/Roboto-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/Roboto/Roboto-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/Roboto/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/Roboto/Roboto-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/Roboto/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/Roboto/Roboto-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/Roboto/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../images/loginbg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../images/rando3.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/gif;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../images/ui-icons_444444_256x240.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../images/ui-icons_555555_256x240.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../images/ui-icons_ffffff_256x240.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../images/ui-icons_777620_256x240.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../images/ui-icons_cc0000_256x240.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../images/ui-icons_777777_256x240.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: "Roboto-Thin";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
    font-family: "Roboto-ThinItalic";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
    font-family: "Roboto-Black";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
    font-family: "Roboto-BlackItalic";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
    font-family: "Roboto-Bold";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
@font-face {
    font-family: "Roboto-BoldItalic";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
@font-face {
    font-family: "Roboto-Italic";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
@font-face {
    font-family: "Roboto-Light";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
@font-face {
    font-family: "Roboto-LightItalic";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
@font-face {
    font-family: "Roboto-Medium";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
@font-face {
    font-family: "Roboto-MediumItalic";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
@font-face {
    font-family: "Roboto-Regular";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.page-wrapper .page-main-header{height:45px;}
.page-main-header .main-header-right .nav-right > ul > li {
padding:12px 0px;
}

.page-wrapper .page-body-wrapper .page-sidebar {
top:45px;
background: linear-gradient(#00182e, #000000) !important;
box-shadow:0 0 #000;
height:calc(100vh - 10px);

}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu a{color:#fff;}
.page-wrapper .page-body-wrapper .page-sidebar ~ .page-body{background-color: inherit;}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-header.Active{color:#fff;background: #053d7080;}
.page-wrapper .page-body-wrapper .page-body{
    /* background: linear-gradient(#00182e, #000000) !important; */
    /* background: linear-gradient(#053d70, #000000) !important; */
}

.input-medium{
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    font-size: 12px;
}
/* .form-group label{color:#ffffff;} */
.fbold{font-family: 'Roboto-Black';}
.f-600{
  font-weight: 600;
}
.fregular{font-family: 'Roboto-Regular';}
.fmedium{font-family: 'Roboto-Medium';}
.fthin{font-family: 'Roboto-Thin';}
.flight{font-family: 'Roboto-Light';}
.bg-primary{background-color: #0d6efd;color:#FFFFFF;}
.bg-secondary{background-color: #6c757d;color:#FFFFFF;}
.bg-success{background-color: #198754;color:#FFFFFF;}
.bg-danger{background-color: #dc3545;color:#FFFFFF;}
.bg-warning{background-color: #ffc107;color:#FFFFFF;}
.bg-info{background-color: #0dcaf0;color:#FFFFFF;}
.bg-dark{background-color: #212529;color:#FFFFFF;}
.bg-default{background-color: #f8f9fa;color:#FFFFFF;}
.cardBlock{padding:10px;align-items: center;text-align: center;}
.cardBlock h4{font-family: 'Roboto-Medium';font-size: 30px;padding:15px 0px 0px 0px;}
.cardBlock h5{font-family: 'Roboto-Regular';font-size: 20px;}
.ml-16per{margin-left:16%;}
.float-right {
    float: right !important;
}
.float-left {
    float: left !important;
}

.m1{margin:1%;}
.m2{margin:2%;}
.m3{margin:3%;}
.m4{margin:4%;}
.m5{margin:5%;}
.m6{margin:6%;}
.m7{margin:7%;}
.m8{margin:8%;}
.m9{margin:9%;}
.m10{margin:10%;}
.m15{margin:15%;}

.mt9{margin-top:9%;}


.mt-0p{margin-top:0px;}
.mt-5p{margin-top:5px;}
.mt-10p{margin-top:10px;}
.mt-15p{margin-top:15px;}
.mt-20p{margin-top:20px;}
.mt-25p{margin-top:25px;}
.mt-30p{margin-top:30px;}
.mt-35p{margin-top:35px;}
.mt-40p{margin-top:40px;}
.mt-45p{margin-top:45px;}
.mt-50p{margin-top:50px;}
.mt-55p{margin-top:55px;}
.mt-60p{margin-top:60px;}
.mt-65p{margin-top:65px;}
.mt-70p{margin-top:70px;}
.mt-75p{margin-top:75px;}
.mt-80p{margin-top:80px;}
.mt-85p{margin-top:85px;}
.mt-90p{margin-top:90px;}
.mt-95p{margin-top:95px;}
.mt-100p{margin-top:100px;}

.mb-0p{margin-bottom:0px;}
.mb-5p{margin-bottom:5px;}
.mb-10p{margin-bottom:10px;}
.mb-15p{margin-bottom:15px;}
.mb-20p{margin-bottom:20px;}
.mb-25p{margin-bottom:25px;}
.mb-30p{margin-bottom:30px;}
.mb-35p{margin-bottom:35px;}
.mb-40p{margin-bottom:40px;}
.mb-45p{margin-bottom:45px;}
.mb-50p{margin-bottom:50px;}
.mb-55p{margin-bottom:55px;}
.mb-60p{margin-bottom:60px;}
.mb-65p{margin-bottom:65px;}
.mb-70p{margin-bottom:70px;}
.mb-75p{margin-bottom:75px;}
.mb-80p{margin-bottom:80px;}
.mb-85p{margin-bottom:85px;}
.mb-90p{margin-bottom:90px;}
.mb-95p{margin-bottom:95px;}
.mb-100p{margin-bottom:100px;}


.mr-0p{margin-right:0px;}
.mr-5p{margin-right:5px;}
.mr-10p{margin-right:10px;}
.mr-15p{margin-right:15px;}
.mr-20p{margin-right:20px;}
.mr-25p{margin-right:25px;}
.mr-30p{margin-right:30px;}
.mr-35p{margin-right:35px;}
.mr-40p{margin-right:40px;}
.mr-45p{margin-right:45px;}
.mr-50p{margin-right:50px;}
.mr-55p{margin-right:55px;}
.mr-60p{margin-right:60px;}
.mr-65p{margin-right:65px;}
.mr-70p{margin-right:70px;}
.mr-75p{margin-right:75px;}
.mr-80p{margin-right:80px;}
.mr-85p{margin-right:85px;}
.mr-90p{margin-right:90px;}
.mr-95p{margin-right:95px;}
.mr-100p{margin-right:100px;}

.ml-0p{margin-left:0px;}
.ml-5p{margin-left:5px;}
.ml-10p{margin-left:10px;}
.ml-15p{margin-left:15px;}
.ml-20p{margin-left:20px;}
.ml-25p{margin-left:25px;}
.ml-30p{margin-left:30px;}
.ml-35p{margin-left:35px;}
.ml-40p{margin-left:40px;}
.ml-45p{margin-left:45px;}
.ml-50p{margin-left:50px;}
.ml-55p{margin-left:55px;}
.ml-60p{margin-left:60px;}
.ml-65p{margin-left:65px;}
.ml-70p{margin-left:70px;}
.ml-75p{margin-left:75px;}
.ml-80p{margin-left:80px;}
.ml-85p{margin-left:85px;}
.ml-90p{margin-left:90px;}
.ml-95p{margin-left:95px;}
.ml-100p{margin-left:100px;}


.m-0p{margin:0px;}
.m-5p{margin:5px;}
.m-10p{margin:10px;}
.m-15p{margin:15px;}
.m-20p{margin:20px;}
.m-25p{margin:25px;}
.m-30p{margin:30px;}
.m-35p{margin:35px;}
.m-40p{margin:40px;}
.m-45p{margin:45px;}
.m-50p{margin:50px;}
.m-55p{margin:55px;}
.m-60p{margin:60px;}
.m-65p{margin:65px;}
.m-70p{margin:70px;}
.m-75p{margin:75px;}
.m-80p{margin:80px;}
.m-85p{margin:85px;}
.m-90p{margin:90px;}
.m-95p{margin:95px;}
.m-100p{margin:100px;}
.box-shadow15p{box-shadow: 0 0 15px #ccc;}
.bxs15p{box-shadow: 0 0 15px #000;}
.f5{font-size: 5px;}
.f6{font-size: 6px;}
.f7{font-size: 7px;}
.f8{font-size: 8px;}
.f9{font-size: 9px;}
.f10{font-size: 10px;}
.f11{font-size: 11px;}
.f12{font-size: 12px;}
.f13{font-size: 13px;}
.f14{font-size: 14px;}
.f15{font-size: 15px;}
.f16{font-size: 16px;}
.f17{font-size: 17px;}
.f18{font-size: 18px;}
.f19{font-size: 19px;}
.f20{font-size: 20px;}
.f21{font-size: 21px;}
.f22{font-size: 22px;}
.f23{font-size: 23px;}
.f24{font-size: 24px;}
.f25{font-size: 25px;}
.f26{font-size: 26px;}
.f27{font-size: 27px;}
.f28{font-size: 28px;}
.f29{font-size: 29px;}
.f30{font-size: 30px;}
.f31{font-size: 31px;}
.f32{font-size: 32px;}
.f33{font-size: 33px;}
.f34{font-size: 34px;}
.f35{font-size: 35px;}
.f36{font-size: 36px;}
.f37{font-size: 37px;}
.f38{font-size: 38px;}
.f39{font-size: 39px;}
.f40{font-size: 40px;}
.f41{font-size: 41px;}
.f42{font-size: 42px;}
.f43{font-size: 43px;}
.f44{font-size: 44px;}
.f45{font-size: 45px;}
.f46{font-size: 46px;}
.f47{font-size: 47px;}
.f48{font-size: 48px;}
.f49{font-size: 49px;}
.f50{font-size: 50px;}
.f51{font-size: 51px;}
.f52{font-size: 52px;}
.f53{font-size: 53px;}
.f54{font-size: 54px;}
.f55{font-size: 55px;}
.f56{font-size: 56px;}
.f57{font-size: 517px;}
.f58{font-size: 58px;}
.f59{font-size: 59px;}
.f60{font-size: 60px;}
.p-0p{padding:0px;}
.p-1p{padding:1px;}
.p-2p{padding:2px;}
.p-3p{padding:3px;}
.p-4p{padding:4px;}
.p-5p{padding:5px;}
.p-9p{padding:9px;}
.p-10p{padding:10px;}
.p-15p{padding:15px;}
.p-20p{padding:20px;}
.p-25p{padding:25px;}
.p-30p{padding:30px;}
.pt-10p{padding-top: 10px !important;}
.pt-15p{padding-top: 15px !important;}
.pt-20p{padding-top: 20px !important;}
.pt-25p{padding-top: 25px !important;}
.pt-30p{padding-top: 30px !important;}
.pt-35p{padding-top: 35px !important;}
.pl-35p{padding-left: 35px !important;}
.pr-35p{padding-right: 35px !important;}
.pb-35p{padding-bottom: 35px !important;}
.p-relative{position: relative;}
.login-right-div{background-color: #d7eef4;}
.bg-white{background-color: #FFFFFF;}
.login-bg{height:100vh;padding:30px;}
.loginbg{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
    background-repeat: no-repeat;
    background-size: contain;
}
.lgh5P{
	color: #ffffff;
    font-size: 31px;
    /* background: #087474; */
    background: #030714;
    padding: 5px 10px;
}
.lgform{
    z-index: 11;
    position: absolute;
    left: 6%;
    top: 18%;
    width: 50vh;
    background: #3b8b8f;
    
  }
.imglogo{position:absolute;top:10%;left:13%;}
.btn-primary {
    background-color: #035044 !important;
    border-color: #035044 !important;
}
.clrfnt{color:#035044 !important;font-weight:bold;}
  .loverly{
	  position: absolute;
    top: 15%;
    left: 0%;
    width: 100%;
    height: 54vh;
    background: #000;
    opacity: 0.3;
    z-index: 10;
  }
.lgform .col-form-label, .lgform a{color:#ffffff;}
.lgbg{    position: fixed;
   top: 0%;
   left: 0%;
   z-index: 9;
   background:linear-gradient(#00182e,#000000)
}
.login-form{background-color: #fff;border-radius:50px;}
.btm-txt{font-size: 12px;text-decoration: none;color:#004bbb;}
.sidebarcls{
    width:0px !important;
}
.gm-style-iw {
    padding:0px !important;
    z-index:9;
    box-shadow: 10px 0px 45px 0px #333 !important;
      
}
.g-header{background:#fff; color:#333; font-size:20px;font-weight:600; padding:5px;
    font-family: "Roboto-Black";
}
.gm-ui-hover-effect{opacity:1 !important; padding:0px !important; top:0px !important; right:0px !important;height:34px !important; }
.gm-ui-hover-effect img{filter: invert(150%) !important;}
button.gm-ui-hover-effect{outline:none;}
.gm-style .gm-style-iw-c {
    position: absolute;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    top: 0;
    left: 0;
    height: 14em !important;
    transform: translate(-50%,-100%);
    background-color: white;
    border-radius: 0px !important;
    padding: 12px;
    box-shadow: 0 2px 7px 1px rgba(0,0,0,0.3);
}
.white{color:#fff;}
.hwhite{color:#afafaf;}
.fdeffect{
    opacity: 1;
    transition: all 1000ms linear 4s;
}
.beffect{
	opacity: 0;
	animation-name: bounceIn;
  animation-duration: 450ms;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}
.beffect:nth-child(2){animation-delay: 0.3s;}
.beffect:nth-child(3){animation-delay: 0.6s;}
.beffect:nth-child(4){animation-delay: 0.9s;}

@keyframes bounceIn{
    0%{
      opacity: 0;
      transform: scale(0.3) translate3d(0,0,0);
    }
    50%{
      opacity: 0.9;
      transform: scale(1.1);
    }
    80%{
      opacity: 1;
      transform: scale(0.89);
    }
    100%{
      opacity: 1;
      transform: scale(1) translate3d(0,0,0);
    }
  }
  
  .beffectFade{
      opacity: 0;
       animation: fadein 0.1s;
      -moz-animation: fadein 0.1s; /* Firefox */
      -webkit-animation: fadein 0.1s; /* Safari and Chrome */
      -o-animation: fadein 0.1s; /* Opera */
  }
  @keyframes fadein {
      from {
          opacity:0;
      }
      to {
          opacity:1;
      }
  }

  .slide{
    animation: slide 1s easy-in forwards;
  }

  @keyframes slide{
    0%{
        transform: translateX(0%);
    }
    100%{
        transform: translateX(100px);
    }
  }
.fade-enter{
opacity:0;
}
.fade-enter-active{
    opacity:1;
    transition: opacity 1000ms ease-out;
}
.fade-leave{
    opacity:1;
}
.fade-leave-active{
    opacity:0;
    transition: opacity 1000ms ease-out;
}
.fade-appear{
    opacity: 0;
}
.fade-appear-active{
    opacity: 1;
    transition: opacity 2000ms ease-out;
}
.collections{margin:0;padding: 0;}
.collection-item{
    padding:10px 5px;
    list-style-type: none;
    border-left:4px solid;
    margin-bottom:10px;
    box-shadow: 0 0 15px #ccc;
    font-size:12px;
    line-height:22px;
}
.clr979797{color:#979797;}
.overlay-block{position:fixed;width:100%;height:100%;top:0;left:0;background:#000;opacity:0.7;z-index:999;}
.sliderBlock{
    position:fixed;
    right:0px;
    top:0px;
    width:0;
    background:#fff;
    height:100%;
    box-shadow: 0 0 10px #333;
    z-index:1000;
    overflow-y:auto;
    padding-top:60px;
	box-shadow:0.5rem 0.5rem 2rem 1rem rgba(0, 0, 0, 0.2);	
    transition: 0.5s;
    transform: translateX(100%);
}
.sliderBlock2{
    position:fixed;
    right:0px;
    top:0px;
    width:0;
    background:#fff;
    height:100%;
    box-shadow: 0 0 10px #333;
    z-index:1000;
    overflow-y:auto;
	box-shadow:0.5rem 0.5rem 2rem 1rem rgba(0, 0, 0, 0.2);	
    transition: 0.5s;
    transform: translateX(100%);
}
.slide25{width:25% !important;transform: translateX(0%);}
.slide30{width:30% !important;transform: translateX(0%);}
.slide35{width:35% !important;transform: translateX(0%);}
.slide45{width:45% !important;transform: translateX(0%);}
.slide60{width:60% !important;transform: translateX(0%);}
.slide90{width:90% !important;transform: translateX(0%);}
.slide80{width:80% !important;transform: translateX(0%);}
.show-n{display:none;}
.show-m{display:block;}
.rclr{color:#ff0000;}
.crd-bg{background-color: #011128;color:#ffffff;font-weight:bold;}
.sweet-alert, .sweet-alert h2{font-size:12px;font-family: 'Roboto-Light' !important;}
.cursor{cursor: pointer;}
.lh30{line-height:30px;}
.gclr{color:#00a151;}
.mh180{min-height:150px;max-height:170px;}
.hanckr{
    font-size:12px;
    color:#FFFFFF;
    text-decoration: none;
    font-family: "Roboto-Bold";
}
.hanckr:hover{color:#000}
.mapdrg{position:absolute;top:10%;left:1%;width:300px;height:50vh;overflow-y:auto;background:#fff;z-index:999;padding:10px;box-shadow: 0 0 15px 0 #4d4d4d;}
.mapdrg h5{font-size:18px;padding:5px;}
.mapdrg ul{margin:0;padding:0;}
.mapdrg li{list-style-type:none;line-height:45px;border-bottom:1px solid #ccc;}
.settingic{position:absolute;top:0;right:0px;}

#dropzone {
overflow:hidden;  
}
.btn-default{background:#ffffff;color:#000;}
.border-rad-0{border-radius: 0px;}
.gm-style .gm-iw{padding:10px;line-height:20px;}

.logotext{color: #fff;
    font-size: 33px;
    text-shadow: 0 0 5px #000;margin-left:45px;}
.overlay{
    position: fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background-color: #000;
    opacity: 0.5;
    z-index: 1000;
  }
  .block{display: block !important;}
  .none{display: none !important;}
  .slider{
    display:none;
    position: fixed;
    right: 0px;
    top: 0px;width:0;
    overflow-y:auto;
    height:100%;
    background-color: #fff;
    z-index: 1001;
    transition: 0.5s;
    transform: translateX(100%);
  }
  .slider-25{
    width:25%;
    height:100%;
    transform: translateX(0%);
  }
  .slider-35{
    width:35%;
    height:100%;
    transform: translateX(0%);
  }
  
  .slider-45{
    width:45%;
    height:100%;
    transform: translateX(0%);
  }
  
  .slider-55{
    width:55%;
    height:100%;
    transform: translateX(0%);
  }
  
  .slider-65{
    width:65%;
    height:100%;
    transform: translateX(0%);
  }
  
  .slider-75{
    width:75%;
    height:100%;
    transform: translateX(0%);
  }
  
  .slider-85{
    width:85%;
    height:100%;
    transform: translateX(0%);
  }
  
  .slider-90{
    width:90%;
    height:100%;
    transform: translateX(0%);
  }
  .slider-95{
    width:95%;
    height:100%;
    transform: translateX(0%);
  }
  .slider-header{position: relative;}
  .slider-close{position: absolute;right:0px;top:0px;padding:8px 10px;color:#fff;}
  .slider-body{padding:15px;}
  .theme-list{
    margin:0;
    padding:0;
  }
  .theme-list li{display: inline-block;list-style-type: none;margin: 10px;}
  .login-logo{position: absolute;right:2%;top:3%;}
  
.highcharts-data-table thead tr,
.highcharts-data-table tr:nth-child(even) {
    background: #f8f8f8;
}

.highcharts-data-table tr:hover {
    background: #f1f7ff;
}
.highcharts-title{color:#ffffff !important;}
.page-wrapper .page-main-header{
    box-shadow: 0 0 0 #000;
    /* background-color: #012632; */
    background-color: #00182e;
    color:#ffffff;
}

.page-wrapper .page-main-header > a{color:#ffffff;}
.umg{filter:invert(1)}
.page-main-header .main-header-left{background-color: #00182e;}
.fclstxt {color:rgb(201, 201, 201) !important}
.fcls{background: linear-gradient(#00182e, #000000) !important;
    box-shadow: 0 0 20px #000;
    border: 1px solid yellow;}
.fcls-a{background: linear-gradient(#00182e, #000000) !important;
        box-shadow: 0 0 20px #000;
       }
    
.fcls-grid{background: linear-gradient(#00182e, #000000) !important;
    box-shadow: 0 0 20px #000;
    border: 1px solid #000;}
    
.filtr-s{
    position:absolute;
    top:2%;
    right:5%;
    width:300px;
}
.npimp{padding:0px !important;}
.mxheit{max-height:85vh;overflow-y: auto;}
.psabbtn{position: absolute;right:1.5%;top:-40px;z-index:9;}
.mpinf{
    position: absolute;
    top: 1%;
    width: 75%;
    left: 18%;
    height: 150px;
    z-index: 10;
    color: #000;
    padding:10px;
}
.mpinfbg{position:absolute;width:100%;height:100%;background:#fff;opacity:0.8;top:0;left:0;box-shadow:0 0 20px #000;}
.lodr{
    position:fixed;
    width:100%;
    height:100%;
    top:0;
    left:0;
    z-index:20;
    background:#000;
    opacity: 0.8;
}
.loaderdiv{
    position: fixed;
    width:100%;
    height: 100%;
    top:0;
    left:0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index:21;
  }
.ldrtext{
    position: fixed;
    width:100%;
    height: 100%;
    top:0;
    left:0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index:21;
    margin-top:5%;
    text-align: center;
    color:#fff;
    font-size:30px;
}
.loaderwave {
    width: 5px;
    height: 100px;
    background: linear-gradient(45deg, rgb(214, 218, 12), #fff);
    margin: 10px;
    animation: loaderwave 1s linear infinite;
    border-radius: 20px;
  }
  .loaderwave:nth-child(2) {
    animation-delay: 0.1s;
  }
  .loaderwave:nth-child(3) {
    animation-delay: 0.2s;
  }
  .loaderwave:nth-child(4) {
    animation-delay: 0.3s;
  }
  .loaderwave:nth-child(5) {
    animation-delay: 0.4s;
  }
  .loaderwave:nth-child(6) {
    animation-delay: 0.5s;
  }
  .loaderwave:nth-child(7) {
    animation-delay: 0.6s;
  }
  .loaderwave:nth-child(8) {
    animation-delay: 0.7s;
  }
  .loaderwave:nth-child(9) {
    animation-delay: 0.8s;
  }
  .loaderwave:nth-child(10) {
    animation-delay: 0.9s;
  }
  
  @keyframes loaderwave {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
.menuic{background:transparent;border:0px;color:#fff;font-size:25px;font-weight: 600;margin-right:10px;position: absolute;top:5px;}
.wrap {
	perspective: 800px;
	perspective-origin: 50% 100px;
}
.cube {
	position: relative;
	width: 200px;
	transform-style: preserve-3d;
}
.cube div {
	position: absolute;
	width: 200px;
	height: 200px;
}

.back {
	transform: translateZ(-100px) rotateY(180deg);
}
.right {
	transform: rotateY(-270deg) translateX(100px);
	transform-origin: top right;
}
.left {
	transform: rotateY(270deg) translateX(-100px);
	transform-origin: center left;
}
.top {
	transform: rotateX(-90deg) translateY(-100px);
	transform-origin: top center;
}
.bottom {
	transform: rotateX(90deg) translateY(100px);
	transform-origin: bottom center;
}
.front {
	transform: translateZ(100px);
}
.ctbl table tr td,.ctbl table tr th{padding: 0.45em;border:1px solid #4d4d4d; font-family: 'Roboto-Regular';}
.cutometheme-ico{
  position: fixed;
  bottom: 0;
  right: 0;
  width:60px;
  height: 60px;
  border: 1px solid red;
  cursor: pointer;
}
.fblack{color:#000;}
.animatenow{position:absolute;top:0;left:0;width:100%;height:100%;background-color:#fff;z-index:9;}
.pp-h{position:absolute;top:40px;left:35%;font-size:40px;}
.dinf{font-weight:700;}

.hovered {
  cursor: help;
}

.label {
  color: #fff;
  font-family: sans-serif;
  padding: 2px;
}
/* canvas{width:1300px !important;height:900px !important;position:absolute;top:17%;left:0;} */
.border1-white{font-family: "Roboto-Regular";border-right:1px solid #333;border-top:1px solid #333;padding:0px 15px 0px 15px;background:rgba(237,237,237,0.3);}



/*--====== Modal ======--*/
.modal {
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.2s ease;
}

/* when Modal has open class */
.modal.open {
  pointer-events: all;
  opacity: 1;
  visibility: visible;
}

.modal_wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1.5rem;
  min-height: calc(100% - 3rem);
}

@media (max-width: 575.98px) {
  .modal_wrapper {
      margin: 0.5rem;
      min-height: calc(100% - 1rem);
  }
}

.modal_content {
  position: relative;
  background-color: var(--bg-color);
  box-shadow: var(--shadow);
  width: 100vw;
  max-width: 800px;
  padding: 4rem;
  border-radius: 10px;
  text-align: center;
  overflow: hidden;
  transform: scale(0);
  transition: transform 0.4s ease;
}

/* when Modal is open then modal-content will... */
.modal.open .modal_content {
  transform: scale(1);
}

.modal_body {
  margin: 2rem 0 3rem;
}

.modal_body p {
  font-size: 1.2rem;
  line-height: 1.6;
  letter-spacing: 0.8px;
}

.close_btn {
  font-size: 1.2rem;
}

.card-color-0{
  background-color: #62bace !important;
  border-radius: 4px;
}
.card-color-1{
  background-color: #a19cc2 !important;
  border-radius: 4px;
}
.card-color-2{
  background-color: #b08ebc !important;
  border-radius: 4px;
}
.card-color-3{
  background-color: #6477b5 !important;
  border-radius: 4px;
}
.pickupdrop-modelClass{
  width: 80%;
  border-radius: 4px !important ;
  background: linear-gradient(#e2e3ee, #e2e3ee) !important;
}
label.c-lbl{margin-top:5px;font-size:0.9rem;}
.redColor{color:#FF0000;font-size:12px;}
.cancel-btn{
  width: 100px !important;
  margin-right: 10px;
  padding-top: .375rem;
  padding-bottom: .375rem;
  padding-left: 1.25rem;
  padding-right: 1.75rem;
  background-color: #ccc !important;
}
.save-btn{
  background-color: #20749b !important;
  color: whitesmoke !important;
  width: 100px !important;
}
.text-color{
  color: whitesmoke !important;
}
.react-timerange-picker__inputGroup__input{
  color: whitesmoke !important;
}
.react-timerange-picker__inputGroup__amPm option{
  color: #000 !important;
}
.control-padding{
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.control-padding-right{
  padding-right: 0px !important;
}

.number input::-webkit-outer-spin-button,
.number input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.font-bold{
  font-weight: bold;
}


.dropdown .ag-ltr .ag-select-list{
  height: 150px;
}

.vehicle-time .react-timerange-picker__inputGroup__input{
  color: #000 !important;
}

.vehicle-time .react-timerange-picker__wrapper{
  border: 0px !important;
}

.disable-field{
  background-color: #d5d5d5 !important;
  cursor:not-allowed;
}

.disable-field-time {
  background-color: white !important;
  cursor:not-allowed;
}
.d-tabs{padding-left:0;margin: 0;}
.d-tabs li{display: inline;border:1px solid #fff;}
.activet{background:#20749b !important;color:#fff !important;margin:0px;}
.lttabs{background:#ccc;padding:13px 4px 10px 4px; color:#333;}
.lttabs button{background:transparent;color:#333;font-weight: 600;}
.lttabs .btn.focus, .lttabs .btn:focus{box-shadow: none;}
.lttabs.activet button{color:#fff;}
.mt-20per{margin-top:2%}
.fw-600{font-weight: 600;}
.fw-800{font-weight: 800;}
.txt-center{text-align: center;}
.w-100{width:100%}
.theme-clr{color:#20749b !important}
.brd-right{border-right: 1px solid #ccc;}
.hr-dashed{
   margin:2% 0 2% 0;
   border-bottom:1px dotted #ccc;
}
.ml-2per{margin-left: 2%;}
.ml-3per{margin-left: 3%;}
.ml-6per{margin-left: 6%;}
.ml-9per{margin-left: 9%;}
input:disabled{cursor: not-allowed;background-color: #d5d5d5 !important;}
.react-timerange-picker--disabled{background-color:#f0f0f0 !important}
.pd-rt-6{padding-right: 6%;}
.bgn{position: fixed;
  top:67px;
  right: 0px;
  bottom: 0px;
  width: 100%;
  height: 100%;
  z-index: 0;
  /* opacity: 0.8; */
}
.bgi{background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) !important;    background-size: cover !important;background-repeat: no-repeat !important;background-position: right !important;}
.main-menu{
  position: fixed;
  height: 100%;
  width: 150px;
  top: 0;
  background: #f7f4fa;
  z-index: 1;
  transition: all .2s ease;
  box-shadow: rgb(0 0 0 / 22%) 0px 25.6px 57.6px 0px, rgb(0 0 0 / 18%) 0px 4.8px 14.4px 0px;
  animation-duration: .18s;
  animation-timing-function: ease;
}
.close-toggle{
  font-size: 20px;
  cursor: pointer;
}
.font-white{
  color:#fff;
}
#menu_toggle{
  cursor:pointer;
}
.pad-left-5per{padding-left:5%;}
.pad-left-10per{padding-left:10%;}
/* .m_content{
    position: relative;
    width: 100%;
    margin-bottom: 10px;
    padding: 10px 17px;
} */

#sceneAppend canvas{position: absolute;left:0;top:0;}

.pad-left{
  padding-left: 3px !important;
}

.react-timerange-picker__range-divider{
  color: #000 !important;
}
.react-time-picker__inputGroup__divider{
color: #000 !important;
}
.timer-width{
  width: 105% !important;
}
.dataLoadpage{position:absolute;top:0;left:0;width:100%;height:100%;background:#fff;z-index:10;opacity: 0.5;}
.overlay{position: fixed;width:100%;height:100%;top:0;left:0;z-index:7;background:#fff;opacity:0.5;}
.overlay-part{position: fixed;width:100%;height:100%;top:0;left:0;z-index:999999;background:#fff;opacity:0.5;}
.summaryDetailsTitle{
  color: #000;
  font-weight: 600;
  font-size: 17px;
}
.module-header-text{
  text-align: center;
  margin-top: 3%;
}

.react-timerange-picker__inputGroup__leadingZero{
  color: #000 !important;
}

.legend-height{
  height: 24px;
}
#legend {
  font-weight: 600;
  margin-right: 10px;
}

.hide {
  display: none;
}

.show-config-info:hover + .hide {
  display: block;
  color: red;
}

.vehiclepriority-modelClass{
  width: 50%;
  border-radius: 4px !important ;
  background: linear-gradient(#e2e3ee, #e2e3ee) !important;
}
.trucks-dropdown {
  background: white;
  height: 18em;
  width: 22.3em;
  position: absolute;
  overflow-y: scroll;
  left: 21px;
  z-index: 1000;
  top: 70px;
  border-radius: 5px;
  border: 0.1px solid cornflowerblue;
}
.trucks-dropdown>ul{
  padding-left: 0;
}
.trucks-dropdown>ul>li {
  padding: 10px;
  padding-left: 13px;
  list-style: none;
}
.trucks-dropdown>ul>li:hover {
  background: #e4e4e4;
}

.btn-index{
  position: relative;
  z-index: 1;
}

.num-color{
  color: #26B99A;
}
/* .border-color{
  border-color: #26B99A !important ;
} */
.cursorPointer{
  cursor: pointer;
}

.txt-black{color: #000000}

.txt-success-light{color: #00f0b5}
.txt-success-medium{color: #00dea7}
.txt-success-dark{color: #00d09c}

.txt-primary-light{color: #d8caf3}
.txt-primary-medium{color: #c6b1ed}
.txt-primary-dark{color: #b99fe8}

.txt-secondary-light{color: #a9e8f0}
.txt-secondary-medium{color: #67d7ef}
.txt-secondary-dark{color: #4dd0e1}

.txt-info-light{color: #c0ddff}
.txt-info-medium{color: #8dc2ff}
.txt-info-dark{color: #66adff}

.txt-warning-light{color: #fff28d}
.txt-warning-medium{color: #ffec50}
.txt-warning-dark{color: #ffe622}

.txt-grey-light{color: #bebebe}
.txt-grey-medium{color: #9f9f9f}
.txt-grey-dark{color: #888888}

.txt-pink-light{color: #f69ebd}
.txt-pink-medium{color: #f16696}
.txt-pink-dark{color: #ed3c7a}

.txt-danger-light{color: #ffb9c5}
.txt-danger-medium{color: #ff90a3}
.txt-danger-dark{color: #ff7289 !important}
.txt-orange-dark{color: orange}
.countertxt{font-weight:bold}
.countertxt-new{color:#000}
.crm-numbers{box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;border-top:3px solid #09c7ac;}



.cirlce-d{text-align: center;border-right:0px solid #ccc;}
.cirlce-d:last-child{border-right:0;}
.form-inputbox{border:1px solid #b5b5b5;font-size:0.9rem;border-radius:0px}
.forminp{
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 9px;
  border-radius:4px;
  border:1px solid #c5c5c5;
  font-size:16px !important;
  font-family: 'Roboto-Regular';
  width:100%;
  color:#000000 !important;
}

.bx-sh{
  background-color: white;
  /* box-shadow: 0 0 8px #ccc; */
  /* margin:10px; */
  text-align: center;
  padding:10px 0px;
  /* border-radius:15px; */
  border-right: 1px  solid #b2b1e1;
}

.redbg{background-color: #ff8fa3;}
.greenbg{background-color: #00dea8;}
.orangebg{background-color: #fdc958;}
.chat-discussion-module{position:fixed;right: 10px;bottom: 10px;z-index:999;}
.chat-box-users-layout{height:80vh;overflow-y: auto;position:relative;
  /* box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px; */
  box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;
  
}
.htClse{cursor: pointer;}
.closeChatUser{position: absolute;right:0;top:0;}
.chat-box{width:450px;height:100%;background-color: #fff;border: 0px solid #333;
  /* box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px; */
  /* box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px; */
  box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;
  /* background-image: url("../images/coming-soon-bg.jpg"); */
  background-size: cover;
  background-repeat: no-repeat;
}
.chat-box-header h4{background-color: #169F85;color:#ffffff;font-size:15px;padding:10px;}
.chat-box-body{height:50vh;max-height:50vh;overflow-y:auto;overflow-x:hidden; color:#000;font-size:12px;}
.chat-box-body img{width:30px;}
.chat-box-even{background-color: #e4ffd1; padding:10px 15px 20px 15px;margin:0;margin-top:10px;}
.chat-box-odd{background-color: #f8f8f8; padding:10px 15px 20px 15px;margin:0;margin-top:10px;}
.chat-box-input{padding:10px;font-size:12px;}
.chat-box-input button{border-radius:0px;font-size:12px; padding:10px 10px;}
.unread-cls{font-weight: bold;color:#000;}
.unread-cls h6{font-weight: bold;color:#000;}
.chat-box-textarea{border: 1px solid #bbb;}
.chat-item-current{text-align: right;}
.avatr-user{position:absolute;right:-27px;padding: 5px 5px;
  border-radius: 100%;
  font-size: 12px;
  border: 1px solid #ccc;
  font-weight: bold;}

.discussBox{
  width:80%;
  margin: 60px auto;
  background: #fff;
  padding: 0;
  border-radius: 7px;
}
.chatlist{background:#fff;height:90vh;overflow-y:auto;overflow-x:hidden;}
.chat-panel{min-height:70vh;max-height:70vh;overflow-y:auto;overflow-x:hidden;padding-bottom:60px;}
.chat-ps{position:absolute;bottom:0px;height:80px;width:100%;background:#eee;}
.chat-timer{color:#757575;font-size:11px;}
.luerpos{position:absolute;bottom: -15px; right:10px;}
.cuerpos{position:absolute;bottom: -15px; left:10px;}
.profile-image {
  width: 50px;
  height: 50px;
  border-radius: 40px;
}
.bshadow{box-shadow:0 0 10px #000;}
.settings-tray {
  background: #eee;
  padding: 10px 15px;
  border-radius: 0px;
}
.settings-tray .no-gutters {
  padding: 0;
}
.settings-tray--right {
  float: right;
}
.settings-tray--right i {
  margin-top: 10px;
  font-size: 25px;
  color: grey;
  margin-left: 14px;
  transition: 0.3s;
}
.settings-tray--right i:hover {
  color: #74b9ff;
  cursor: pointer;
}

.search-box {
  background: #fafafa;
  padding: 10px 13px;
}
.search-box .input-wrapper {
  background: #fff;
  border-radius: 40px;
}
.search-box .input-wrapper i {
  color: grey;
  margin-left: 7px;
  vertical-align: middle;
}

input.chatInp {
  border: none;
  border-radius: 0px;
  width: 80%;
}
input.chatInp::placeholder {
  color: #e3e3e3;
  font-weight: 300;
  margin-left: 20px;
}
input.chatInp:focus {
  outline: none;
}

.friend-drawer {
  padding: 10px 15px;
  display: flex;
  vertical-align: baseline;
  /* background: #fff; */
  transition: 0.3s ease;
  border-bottom:1px dotted #e3d4d4;
}
.friend-drawer--grey {
  background: #eee;
}
.friend-drawer .text {
  margin-left: 12px;
  width: 70%;
}
.friend-drawer .text h6 {
  margin-top: 6px;
  margin-bottom: 0;
  font-size:12px;
}
.friend-drawer .text p {
  margin: 0;
}
.friend-drawer .time {
  color: grey;
}
.friend-drawer--onhover:hover {
  background: #74b9ff;
  cursor: pointer;
}
.friend-drawer--onhover:hover p,
.friend-drawer--onhover:hover h6,
.friend-drawer--onhover:hover .time {
  color: #fff !important;
}

hr {
  margin: 5px auto;
  width: 60%;
}
.tc{margin:10px 15px;text-align:center;}
.chat-bubble {
  padding: 10px 14px;
  background: #eee;
  margin: 10px 30px 10px 10px;
  border-radius: 9px;
  position: relative;
  animation: fadeIn 1s ease-in;
}
.chat-bubble:after {
  content: "";
  position: absolute;
  top: 50%;
  width: 0;
  height: 0;
  border: 20px solid transparent;
  border-bottom: 0;
  margin-top: -10px;
}
.chat-bubble--left:after {
  left: 0;
  border-right-color: #eee;
  border-left: 0;
  margin-left: -20px;
}
.chat-bubble--right:after {
  right: 0;
  border-left-color: #74b9ff;
  border-right: 0;
  margin-right: -20px;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.offset-md-2 .chat-bubble {
  background: #74b9ff;
  color: #fff;
}

.chat-box-tray {
  background: #eee;
  display: flex;
  align-items: baseline;
  padding: 10px 15px;
  align-items: center;
  margin-top: 10px;
  bottom: 0;
}
.chat-box-tray input {
  margin: 0 10px;
  padding: 6px 15px;
  height:45px;
}
.chat-box-tray i {
  color: grey;
  font-size: 30px;
  vertical-align: middle;
}
.chat-box-tray i:last-of-type {
  margin-left: 25px;
}

.beffect{
	opacity: 0;
	animation-name: bounceIn;
  animation-duration: 450ms;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}
.beffect:nth-child(2){animation-delay: 0.3s;}
.beffect:nth-child(3){animation-delay: 0.6s;}
.beffect:nth-child(4){animation-delay: 0.9s;}
#counterCardBody{
  padding: 15px 16px;
}
.bfnt{font-size:25px;margin-top:50px;color:#000;}
.bfnt span{font-weight:bold;}
.chatlistBox{position:absolute;left:0;top:0;}

.sh-users{position:absolute;left:-9%;top:0%;}
.chatNowBtn{
    /* display: flex; */
    align-items: center;
    font-family: inherit;
    font-weight: 500;
    font-size: 16px;
    padding: 0.7em 1.4em 0.7em 1.1em;
    color: white;
    background: #ad5389;
    background: linear-gradient(0deg, rgba(20,167,62,1) 0%, rgba(102,247,113,1) 100%);
    border: none;
    box-shadow: 0 0.7em 1.5em -0.5em #14a73e98;
    letter-spacing: 0.05em;
    border-radius: 20em;
    cursor: pointer;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
  }
  
.chatNowBtn:hover {
    box-shadow: 0 0.5em 1.5em -0.5em #14a73e98;
    background: linear-gradient(0deg,  rgb(37, 180, 49) 0%, rgba(20,167,62,1) 100%);
    color:#fff;
  }
  
.chatNowBtn:active {
    box-shadow: 0 0.3em 1em -0.5em #14a73e98;
    color:#fff;
  }
.btn-chat-users{
  background: #006dff;
    color: #7c7a7a;
    background-image: linear-gradient(#f3f3f3, white, #e6e6e6);
    border-radius: 0;
    border: 1px solid #ccc;
}
.chat-users{
  position: absolute;
  left: 0px;
  z-index: 99;
  width: 0;
  transition: all 0.2s ease-in-out;
  transform: translateX(0 0);
  height: 45vh;
  background: #fff;
  top: 40px;
  /* box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px; */
  box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;
  border: 0px solid red;
  overflow-y: auto;
}
.chat-user-slide{width: 200px;transform: translateX(20%);left:-205px;}
.chat-users::-webkit-scrollbar, .chat-box-users-layout::-webkit-scrollbar {
  width: 5px;
}

/* Track */
.chat-users::-webkit-scrollbar-track, .chat-box-users-layout::-webkit-scrollbar-track {
  background: #cccccc; 
}
 
/* Handle */
.chat-users::-webkit-scrollbar-thumb, .chat-box-users-layout::-webkit-scrollbar-thumb {
  background: #7e7e7e; 
}

/* Handle on hover */
.chat-users::-webkit-scrollbar-thumb:hover, .chat-box-users-layout::-webkit-scrollbar-thumb {
  background: #7e7e7e; 
}
.unredCount{
  position: absolute;
    top: -19px;
    right: 9px;
    background: #001bec;
    color: #fff;
    width: auto;
    height: auto;
    border-radius: 100%;
    padding: 5px 10px;
    font-size: 10px;
    font-weight: bold;
}
.chartLoading{position: absolute;top:0px;left:0px;width:100%;height: 100%;background:#fff;opacity:1;z-index:1}
.loaderpos{position: absolute;top:30%;left:40%;z-index:2}
.loaderpos img{width:120px;}



/* Media query for 125% scaling and 1920x1080 resolution */
@media (min-resolution: 125dpi) and (min-width: 1536px) and (min-height: 700px) {
  .countertxt{font-size:11px !important;}
}
/* Media query for 125% scaling and 1920x1080 resolution */
@media (min-resolution: 125dpi) and (min-width: 1536px) and (min-height: 864px) {
  .countertxt{font-size:11px !important;}
}

/* Media query for 150% scaling and 1920x1080 resolution */
@media (min-resolution: 150dpi) and (min-width: 1280px) and (min-height: 720px) {
  .countertxt{font-size:11px !important;}
}

/* Media query for 200% scaling and 1920x1080 resolution */
@media (min-resolution: 200dpi) and (min-width: 960px) and (min-height: 540px) {
  .countertxt{font-size:11px !important;}
}

/* Media query for 100% scaling and 1366x768 resolution */
@media (max-resolution: 96dpi) and (max-width: 1366px) and (max-height: 768px) {
  .countertxt{font-size:11px !important;}
}

/* Media query for 125% scaling and 1366x768 resolution */
@media (max-resolution: 120dpi) and (max-width: 1093px) and (max-height: 615px) {
  .countertxt{font-size:11px !important;}
}

/* Media query for 150% scaling and 1366x768 resolution */
@media (max-resolution: 144dpi) and (max-width: 912px) and (max-height: 513px) {
  .countertxt{font-size:11px !important;}
}

/* 1. scale and layout setting at 100% */
@media (resolution: 1dppx) {
  
  @media screen and (min-width: 1440px) and (max-width: 1500px) and (min-height: 900px) {
    /* Your CSS styles and rules for 1440x900 resolution */
    #counterCardBody{
      /* min-height:125px; */
    }
    .cirlce-d{padding:7px;}
    .f13{font-size:12px;}
    .f30{font-size:26px;}
  }

}


/* 2. scale and layout setting at 125% */
@media (resolution: 1.25dppx) {
  .countertxt{font-size:10px !important;}

  
  @media screen and (min-width: 1440px) and (max-width: 1500px) and (min-height: 900px) {
    /* Your CSS styles and rules for 1440x900 resolution */
    #counterCardBody{
      /* min-height:125px; */
    }
    .cirlce-d{padding:7px;}
    .f13{font-size:12px;}
    .f30{font-size:26px;}
  }

}


/* 2. scale and layout setting at 110% */
@media (resolution: 1.1dppx) {
  .countertxt{font-size:12px !important;}

  
  @media screen and (min-width: 1440px) and (max-width: 1500px) and (min-height: 900px) {
    /* Your CSS styles and rules for 1440x900 resolution */
    #counterCardBody{
      /* min-height:125px; */
    }
    .cirlce-d{padding:7px;}
    .f13{font-size:12px;}
    .f30{font-size:26px;}
  }

}


/* 3. scale and layout setting at 150% */
@media (resolution: 1.5dppx) {
  .countertxt{font-size:8px !important;}
  .f30{font-size:20px;}
  body{font-size:10px;}
}


/* 4. scale and layout setting at 175% */
@media (resolution: 1.75dppx) {
  
}

.avator{
  padding: 5px 5px;
  border-radius: 100%;
  font-size: 12px;
  border: 1px solid #ccc;
  font-weight: bold;
  width:30px;
}
.even-txt{background:#e4ffd1}
.odd-txt{background:#f8f8f8}
.filterSelectI{position: absolute;right:10px;top:10px;z-index:999;}
.filterSelectII{position: absolute;right:17%;top:10px;z-index:999;}

.xtooltip {
  position: relative;
  left:100%;
  top:0%;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.xtooltip .xtooltiptext {
  display:  none;
  width: 140px;
  background-image : linear-gradient(#fdfdfd, #ededed, #ffffff);
  color: #000;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;
  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.xtooltip .xtooltiptextR {
  display:  none;
  width: 240px;
  background-image : linear-gradient(#fdfdfd, #ededed, #ffffff);
  color: #000;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  right:20px;
  top:2px;
  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.xtooltip:hover .xtooltiptext, .xtooltip:hover .xtooltiptextR {
  display: block;
}


.xatooltip {
  position: static;
  right:0%;
  top:0px;
  margin-left: 10px;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.xatooltip .xtooltiptext {
  display:  none;
  width: 300px;
  background-image : linear-gradient(#fdfdfd, #ededed, #ffffff);
  color: #333;
  text-align: justify;
  line-height:1.6em;
  border-radius: 6px;
  padding: 5px 5px;
  font-size:12px;
  font-weight:normal;
  /* Position the tooltip */
  box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;
  position: absolute;
  z-index: 1;
}

.xatooltip .xtooltiptextR {
  display:  none;
  width: 240px;
  background-image : linear-gradient(#fdfdfd, #ededed, #ffffff);
  color: #000;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  right:20px;
  top:2px;
  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.xatooltip:hover .xtooltiptext, .xatooltip:hover .xtooltiptextR {
  display: block;
}

.ytooltip {
  background-color: #ffaffc;
  border-radius: 10px;
  padding: 10px 15px;
  position: relative;
  margin: 15px;
  text-align: center;
}

.ytooltip::after {
  background-color: #333;
  border-radius: 10px;
  color: #b254ff;
  display: none;
  padding: 10px 15px;
  position: absolute;
  text-align: center;
  z-index: 999;
}

.ytooltip.top::after {
  content: 'top';
  top: 0;
  left: 50%;
  transform: translate(-50%, calc(-100% - 10px));
}

.ytooltip.bottom::after {
  content: 'bottom';
  bottom: 0;
  left: 50%;
  transform: translate(-50%, calc(100% + 10px));
}

.ytooltip.right::after {
  content: 'right';
  top: 0;
  right: 0;
  transform: translateX(calc(100% + 10px));
}

.ytooltip.left::after {
  content: 'left';
  top: 0;
  left: 0;
  transform: translateX(calc(-100% - 10px));
}

.ytooltip:hover::after {
  display: block;
}

.ytooltip::before {
  background-color: #333;
  content: ' ';
  display: none;
  position: absolute;
  width: 15px;
  height: 15px;
  z-index: 999;
}

.ytooltip:hover::before {
  display: block;
}

.ytooltip.top::before {
  top: 0;
  left: 50%;
  transform: translate(-50%, calc(-100% - 5px)) rotate(45deg);
}

.ytooltip.bottom::before {
  bottom: 0;
  left: 50%;
  transform: translate(-50%, calc(100% + 5px)) rotate(45deg);
}

.ytooltip.right::before {
  top: 50%;
  right: 0;
  transform: translate(calc(100% + 5px), -50%) rotate(45deg);
}

.ytooltip.left::before {
  top: 50%;
  left: 0;
  transform: translate(calc(-100% - 5px), -50%) rotate(45deg);
}
#webpack-dev-server-client-overlay{display:none !important;}


/* JQUery UI Sytles Start */

.ui-helper-hidden {
	display: none;
}
.ui-helper-hidden-accessible {
	border: 0;
	clip: rect(0 0 0 0);
	height: 1px;
	margin: -1px;
	overflow: hidden;
	padding: 0;
	position: absolute;
	width: 1px;
}
.ui-helper-reset {
	margin: 0;
	padding: 0;
	border: 0;
	outline: 0;
	line-height: 1.3;
	text-decoration: none;
	font-size: 100%;
	list-style: none;
}
.ui-helper-clearfix:before,
.ui-helper-clearfix:after {
	content: "";
	display: table;
	border-collapse: collapse;
}
.ui-helper-clearfix:after {
	clear: both;
}
.ui-helper-zfix {
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	position: absolute;
	opacity: 0;
	-ms-filter: "alpha(opacity=0)"; /* support: IE8 */
}

.ui-front {
	z-index: 100;
}


/* Interaction Cues
----------------------------------*/
.ui-state-disabled {
	cursor: default !important;
	pointer-events: none;
}


/* Icons
----------------------------------*/
.ui-icon {
	display: inline-block;
	vertical-align: middle;
	margin-top: -.25em;
	position: relative;
	text-indent: -99999px;
	overflow: hidden;
	background-repeat: no-repeat;
}

.ui-widget-icon-block {
	left: 50%;
	margin-left: -8px;
	display: block;
}

/* Misc visuals
----------------------------------*/

/* Overlays */
.ui-widget-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}
.ui-accordion .ui-accordion-header {
	display: block;
	cursor: pointer;
	position: relative;
	margin: 2px 0 0 0;
	padding: .5em .5em .5em .7em;
	font-size: 100%;
}
.ui-accordion .ui-accordion-content {
	padding: 1em 2.2em;
	border-top: 0;
	overflow: auto;
}
.ui-autocomplete {
	position: absolute;
	top: 0;
	left: 0;
	cursor: default;
}
.ui-menu {
	list-style: none;
	padding: 0;
	margin: 0;
	display: block;
	outline: 0;
}
.ui-menu .ui-menu {
	position: absolute;
}
.ui-menu .ui-menu-item {
	margin: 0;
	cursor: pointer;
	/* support: IE10, see #8844 */
	list-style-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}
.ui-menu .ui-menu-item-wrapper {
	position: relative;
	padding: 3px 1em 3px .4em;
}
.ui-menu .ui-menu-divider {
	margin: 5px 0;
	height: 0;
	font-size: 0;
	line-height: 0;
	border-width: 1px 0 0 0;
}
.ui-menu .ui-state-focus,
.ui-menu .ui-state-active {
	margin: -1px;
}

/* icon support */
.ui-menu-icons {
	position: relative;
}
.ui-menu-icons .ui-menu-item-wrapper {
	padding-left: 2em;
}

/* left-aligned */
.ui-menu .ui-icon {
	position: absolute;
	top: 0;
	bottom: 0;
	left: .2em;
	margin: auto 0;
}

/* right-aligned */
.ui-menu .ui-menu-icon {
	left: auto;
	right: 0;
}
.ui-button {
	padding: .4em 1em;
	display: inline-block;
	position: relative;
	line-height: normal;
	margin-right: .1em;
	cursor: pointer;
	vertical-align: middle;
	text-align: center;
	-webkit-user-select: none;
	user-select: none;

	/* Support: IE <= 11 */
	overflow: visible;
}

.ui-button,
.ui-button:link,
.ui-button:visited,
.ui-button:hover,
.ui-button:active {
	text-decoration: none;
}

/* to make room for the icon, a width needs to be set here */
.ui-button-icon-only {
	width: 2em;
	box-sizing: border-box;
	text-indent: -9999px;
	white-space: nowrap;
}

/* no icon support for input elements */
input.ui-button.ui-button-icon-only {
	text-indent: 0;
}

/* button icon element(s) */
.ui-button-icon-only .ui-icon {
	position: absolute;
	top: 50%;
	left: 50%;
	margin-top: -8px;
	margin-left: -8px;
}

.ui-button.ui-icon-notext .ui-icon {
	padding: 0;
	width: 2.1em;
	height: 2.1em;
	text-indent: -9999px;
	white-space: nowrap;

}

input.ui-button.ui-icon-notext .ui-icon {
	width: auto;
	height: auto;
	text-indent: 0;
	white-space: normal;
	padding: .4em 1em;
}

/* workarounds */
/* Support: Firefox 5 - 40 */
input.ui-button::-moz-focus-inner,
button.ui-button::-moz-focus-inner {
	border: 0;
	padding: 0;
}
.ui-controlgroup {
	vertical-align: middle;
	display: inline-block;
}
.ui-controlgroup > .ui-controlgroup-item {
	float: left;
	margin-left: 0;
	margin-right: 0;
}
.ui-controlgroup > .ui-controlgroup-item:focus,
.ui-controlgroup > .ui-controlgroup-item.ui-visual-focus {
	z-index: 9999;
}
.ui-controlgroup-vertical > .ui-controlgroup-item {
	display: block;
	float: none;
	width: 100%;
	margin-top: 0;
	margin-bottom: 0;
	text-align: left;
}
.ui-controlgroup-vertical .ui-controlgroup-item {
	box-sizing: border-box;
}
.ui-controlgroup .ui-controlgroup-label {
	padding: .4em 1em;
}
.ui-controlgroup .ui-controlgroup-label span {
	font-size: 80%;
}
.ui-controlgroup-horizontal .ui-controlgroup-label + .ui-controlgroup-item {
	border-left: none;
}
.ui-controlgroup-vertical .ui-controlgroup-label + .ui-controlgroup-item {
	border-top: none;
}
.ui-controlgroup-horizontal .ui-controlgroup-label.ui-widget-content {
	border-right: none;
}
.ui-controlgroup-vertical .ui-controlgroup-label.ui-widget-content {
	border-bottom: none;
}

/* Spinner specific style fixes */
.ui-controlgroup-vertical .ui-spinner-input {

	/* Support: IE8 only, Android < 4.4 only */
	width: 75%;
	width: calc( 100% - 2.4em );
}
.ui-controlgroup-vertical .ui-spinner .ui-spinner-up {
	border-top-style: solid;
}

.ui-checkboxradio-label .ui-icon-background {
	box-shadow: inset 1px 1px 1px #ccc;
	border-radius: .12em;
	border: none;
}
.ui-checkboxradio-radio-label .ui-icon-background {
	width: 16px;
	height: 16px;
	border-radius: 1em;
	overflow: visible;
	border: none;
}
.ui-checkboxradio-radio-label.ui-checkboxradio-checked .ui-icon,
.ui-checkboxradio-radio-label.ui-checkboxradio-checked:hover .ui-icon {
	background-image: none;
	width: 8px;
	height: 8px;
	border-width: 4px;
	border-style: solid;
}
.ui-checkboxradio-disabled {
	pointer-events: none;
}
.ui-datepicker {
	width: 17em;
	padding: .2em .2em 0;
	display: none;
}
.ui-datepicker .ui-datepicker-header {
	position: relative;
	padding: .2em 0;
}
.ui-datepicker .ui-datepicker-prev,
.ui-datepicker .ui-datepicker-next {
	position: absolute;
	top: 2px;
	width: 1.8em;
	height: 1.8em;
}
.ui-datepicker .ui-datepicker-prev-hover,
.ui-datepicker .ui-datepicker-next-hover {
	top: 1px;
}
.ui-datepicker .ui-datepicker-prev {
	left: 2px;
}
.ui-datepicker .ui-datepicker-next {
	right: 2px;
}
.ui-datepicker .ui-datepicker-prev-hover {
	left: 1px;
}
.ui-datepicker .ui-datepicker-next-hover {
	right: 1px;
}
.ui-datepicker .ui-datepicker-prev span,
.ui-datepicker .ui-datepicker-next span {
	display: block;
	position: absolute;
	left: 50%;
	margin-left: -8px;
	top: 50%;
	margin-top: -8px;
}
.ui-datepicker .ui-datepicker-title {
	margin: 0 2.3em;
	line-height: 1.8em;
	text-align: center;
}
.ui-datepicker .ui-datepicker-title select {
	font-size: 1em;
	margin: 1px 0;
}
.ui-datepicker select.ui-datepicker-month,
.ui-datepicker select.ui-datepicker-year {
	width: 45%;
}
.ui-datepicker table {
	width: 100%;
	font-size: .9em;
	border-collapse: collapse;
	margin: 0 0 .4em;
}
.ui-datepicker th {
	padding: .7em .3em;
	text-align: center;
	font-weight: bold;
	border: 0;
}
.ui-datepicker td {
	border: 0;
	padding: 1px;
}
.ui-datepicker td span,
.ui-datepicker td a {
	display: block;
	padding: .2em;
	text-align: right;
	text-decoration: none;
}
.ui-datepicker .ui-datepicker-buttonpane {
	background-image: none;
	margin: .7em 0 0 0;
	padding: 0 .2em;
	border-left: 0;
	border-right: 0;
	border-bottom: 0;
}
.ui-datepicker .ui-datepicker-buttonpane button {
	float: right;
	margin: .5em .2em .4em;
	cursor: pointer;
	padding: .2em .6em .3em .6em;
	width: auto;
	overflow: visible;
}
.ui-datepicker .ui-datepicker-buttonpane button.ui-datepicker-current {
	float: left;
}

/* with multiple calendars */
.ui-datepicker.ui-datepicker-multi {
	width: auto;
}
.ui-datepicker-multi .ui-datepicker-group {
	float: left;
}
.ui-datepicker-multi .ui-datepicker-group table {
	width: 95%;
	margin: 0 auto .4em;
}
.ui-datepicker-multi-2 .ui-datepicker-group {
	width: 50%;
}
.ui-datepicker-multi-3 .ui-datepicker-group {
	width: 33.3%;
}
.ui-datepicker-multi-4 .ui-datepicker-group {
	width: 25%;
}
.ui-datepicker-multi .ui-datepicker-group-last .ui-datepicker-header,
.ui-datepicker-multi .ui-datepicker-group-middle .ui-datepicker-header {
	border-left-width: 0;
}
.ui-datepicker-multi .ui-datepicker-buttonpane {
	clear: left;
}
.ui-datepicker-row-break {
	clear: both;
	width: 100%;
	font-size: 0;
}

/* RTL support */
.ui-datepicker-rtl {
	direction: rtl;
}
.ui-datepicker-rtl .ui-datepicker-prev {
	right: 2px;
	left: auto;
}
.ui-datepicker-rtl .ui-datepicker-next {
	left: 2px;
	right: auto;
}
.ui-datepicker-rtl .ui-datepicker-prev:hover {
	right: 1px;
	left: auto;
}
.ui-datepicker-rtl .ui-datepicker-next:hover {
	left: 1px;
	right: auto;
}
.ui-datepicker-rtl .ui-datepicker-buttonpane {
	clear: right;
}
.ui-datepicker-rtl .ui-datepicker-buttonpane button {
	float: left;
}
.ui-datepicker-rtl .ui-datepicker-buttonpane button.ui-datepicker-current,
.ui-datepicker-rtl .ui-datepicker-group {
	float: right;
}
.ui-datepicker-rtl .ui-datepicker-group-last .ui-datepicker-header,
.ui-datepicker-rtl .ui-datepicker-group-middle .ui-datepicker-header {
	border-right-width: 0;
	border-left-width: 1px;
}

/* Icons */
.ui-datepicker .ui-icon {
	display: block;
	text-indent: -99999px;
	overflow: hidden;
	background-repeat: no-repeat;
	left: .5em;
	top: .3em;
}
.ui-dialog {
	position: absolute;
	top: 0;
	left: 0;
	padding: .2em;
	outline: 0;
}
.ui-dialog .ui-dialog-titlebar {
	padding: .4em 1em;
	position: relative;
}
.ui-dialog .ui-dialog-title {
	float: left;
	margin: .1em 0;
	white-space: nowrap;
	width: 90%;
	overflow: hidden;
	text-overflow: ellipsis;
}
.ui-dialog .ui-dialog-titlebar-close {
	position: absolute;
	right: .3em;
	top: 50%;
	width: 20px;
	margin: -10px 0 0 0;
	padding: 1px;
	height: 20px;
}
.ui-dialog .ui-dialog-content {
	position: relative;
	border: 0;
	padding: .5em 1em;
	background: none;
	overflow: auto;
}
.ui-dialog .ui-dialog-buttonpane {
	text-align: left;
	border-width: 1px 0 0 0;
	background-image: none;
	margin-top: .5em;
	padding: .3em 1em .5em .4em;
}
.ui-dialog .ui-dialog-buttonpane .ui-dialog-buttonset {
	float: right;
}
.ui-dialog .ui-dialog-buttonpane button {
	margin: .5em .4em .5em 0;
	cursor: pointer;
}
.ui-dialog .ui-resizable-n {
	height: 2px;
	top: 0;
}
.ui-dialog .ui-resizable-e {
	width: 2px;
	right: 0;
}
.ui-dialog .ui-resizable-s {
	height: 2px;
	bottom: 0;
}
.ui-dialog .ui-resizable-w {
	width: 2px;
	left: 0;
}
.ui-dialog .ui-resizable-se,
.ui-dialog .ui-resizable-sw,
.ui-dialog .ui-resizable-ne,
.ui-dialog .ui-resizable-nw {
	width: 7px;
	height: 7px;
}
.ui-dialog .ui-resizable-se {
	right: 0;
	bottom: 0;
}
.ui-dialog .ui-resizable-sw {
	left: 0;
	bottom: 0;
}
.ui-dialog .ui-resizable-ne {
	right: 0;
	top: 0;
}
.ui-dialog .ui-resizable-nw {
	left: 0;
	top: 0;
}
.ui-draggable .ui-dialog-titlebar {
	cursor: move;
}
.ui-draggable-handle {
	touch-action: none;
}
.ui-resizable {
	position: relative;
}
.ui-resizable-handle {
	position: absolute;
	font-size: 0.1px;
	display: block;
	touch-action: none;
}
.ui-resizable-disabled .ui-resizable-handle,
.ui-resizable-autohide .ui-resizable-handle {
	display: none;
}
.ui-resizable-n {
	cursor: n-resize;
	height: 7px;
	width: 100%;
	top: -5px;
	left: 0;
}
.ui-resizable-s {
	cursor: s-resize;
	height: 7px;
	width: 100%;
	bottom: -5px;
	left: 0;
}
.ui-resizable-e {
	cursor: e-resize;
	width: 7px;
	right: -5px;
	top: 0;
	height: 100%;
}
.ui-resizable-w {
	cursor: w-resize;
	width: 7px;
	left: -5px;
	top: 0;
	height: 100%;
}
.ui-resizable-se {
	cursor: se-resize;
	width: 12px;
	height: 12px;
	right: 1px;
	bottom: 1px;
}
.ui-resizable-sw {
	cursor: sw-resize;
	width: 9px;
	height: 9px;
	left: -5px;
	bottom: -5px;
}
.ui-resizable-nw {
	cursor: nw-resize;
	width: 9px;
	height: 9px;
	left: -5px;
	top: -5px;
}
.ui-resizable-ne {
	cursor: ne-resize;
	width: 9px;
	height: 9px;
	right: -5px;
	top: -5px;
}
.ui-progressbar {
	height: 2em;
	text-align: left;
	overflow: hidden;
}
.ui-progressbar .ui-progressbar-value {
	margin: -1px;
	height: 100%;
}
.ui-progressbar .ui-progressbar-overlay {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
	height: 100%;
	-ms-filter: "alpha(opacity=25)"; /* support: IE8 */
	opacity: 0.25;
}
.ui-progressbar-indeterminate .ui-progressbar-value {
	background-image: none;
}
.ui-selectable {
	touch-action: none;
}
.ui-selectable-helper {
	position: absolute;
	z-index: 100;
	border: 1px dotted black;
}
.ui-selectmenu-menu {
	padding: 0;
	margin: 0;
	position: absolute;
	top: 0;
	left: 0;
	display: none;
}
.ui-selectmenu-menu .ui-menu {
	overflow: auto;
	overflow-x: hidden;
	padding-bottom: 1px;
}
.ui-selectmenu-menu .ui-menu .ui-selectmenu-optgroup {
	font-size: 1em;
	font-weight: bold;
	line-height: 1.5;
	padding: 2px 0.4em;
	margin: 0.5em 0 0 0;
	height: auto;
	border: 0;
}
.ui-selectmenu-open {
	display: block;
}
.ui-selectmenu-text {
	display: block;
	margin-right: 20px;
	overflow: hidden;
	text-overflow: ellipsis;
}
.ui-selectmenu-button.ui-button {
	text-align: left;
	white-space: nowrap;
	width: 14em;
}
.ui-selectmenu-icon.ui-icon {
	float: right;
	margin-top: 0;
}
.ui-slider {
	position: relative;
	text-align: left;
}
.ui-slider .ui-slider-handle {
	position: absolute;
	z-index: 2;
	width: 1.2em;
	height: 1.2em;
	cursor: pointer;
	touch-action: none;
}
.ui-slider .ui-slider-range {
	position: absolute;
	z-index: 1;
	font-size: .7em;
	display: block;
	border: 0;
	background-position: 0 0;
}

/* support: IE8 - See #6727 */
.ui-slider.ui-state-disabled .ui-slider-handle,
.ui-slider.ui-state-disabled .ui-slider-range {
	filter: inherit;
}

.ui-slider-horizontal {
	height: .8em;
}
.ui-slider-horizontal .ui-slider-handle {
	top: -.3em;
	margin-left: -.6em;
}
.ui-slider-horizontal .ui-slider-range {
	top: 0;
	height: 100%;
}
.ui-slider-horizontal .ui-slider-range-min {
	left: 0;
}
.ui-slider-horizontal .ui-slider-range-max {
	right: 0;
}

.ui-slider-vertical {
	width: .8em;
	height: 100px;
}
.ui-slider-vertical .ui-slider-handle {
	left: -.3em;
	margin-left: 0;
	margin-bottom: -.6em;
}
.ui-slider-vertical .ui-slider-range {
	left: 0;
	width: 100%;
}
.ui-slider-vertical .ui-slider-range-min {
	bottom: 0;
}
.ui-slider-vertical .ui-slider-range-max {
	top: 0;
}
.ui-sortable-handle {
	touch-action: none;
}
.ui-spinner {
	position: relative;
	display: inline-block;
	overflow: hidden;
	padding: 0;
	vertical-align: middle;
}
.ui-spinner-input {
	border: none;
	background: none;
	color: inherit;
	padding: .222em 0;
	margin: .2em 0;
	vertical-align: middle;
	margin-left: .4em;
	margin-right: 2em;
}
.ui-spinner-button {
	width: 1.6em;
	height: 50%;
	font-size: .5em;
	padding: 0;
	margin: 0;
	text-align: center;
	position: absolute;
	cursor: default;
	display: block;
	overflow: hidden;
	right: 0;
}
/* more specificity required here to override default borders */
.ui-spinner a.ui-spinner-button {
	border-top-style: none;
	border-bottom-style: none;
	border-right-style: none;
}
.ui-spinner-up {
	top: 0;
}
.ui-spinner-down {
	bottom: 0;
}
.ui-tabs {
	position: relative;/* position: relative prevents IE scroll bug (element with position: relative inside container with overflow: auto appear as "fixed") */
	padding: .2em;
}
.ui-tabs .ui-tabs-nav {
	margin: 0;
	padding: .2em .2em 0;
}
.ui-tabs .ui-tabs-nav li {
	list-style: none;
	float: left;
	position: relative;
	top: 0;
	margin: 1px .2em 0 0;
	border-bottom-width: 0;
	padding: 0;
	white-space: nowrap;
}
.ui-tabs .ui-tabs-nav .ui-tabs-anchor {
	float: left;
	padding: .5em 1em;
	text-decoration: none;
}
.ui-tabs .ui-tabs-nav li.ui-tabs-active {
	margin-bottom: -1px;
	padding-bottom: 1px;
}
.ui-tabs .ui-tabs-nav li.ui-tabs-active .ui-tabs-anchor,
.ui-tabs .ui-tabs-nav li.ui-state-disabled .ui-tabs-anchor,
.ui-tabs .ui-tabs-nav li.ui-tabs-loading .ui-tabs-anchor {
	cursor: text;
}
.ui-tabs-collapsible .ui-tabs-nav li.ui-tabs-active .ui-tabs-anchor {
	cursor: pointer;
}
.ui-tabs .ui-tabs-panel {
	display: block;
	border-width: 0;
	padding: 1em 1.4em;
	background: none;
}
.ui-tooltip {
	padding: 8px;
	position: absolute;
	z-index: 9999;
	max-width: 300px;
}
body .ui-tooltip {
	border-width: 2px;
}
/* Component containers
----------------------------------*/
.ui-widget {
	font-family: Arial,Helvetica,sans-serif;
	font-size: 1em;
}
.ui-widget .ui-widget {
	font-size: 1em;
}
.ui-widget input,
.ui-widget select,
.ui-widget textarea,
.ui-widget button {
	font-family: Arial,Helvetica,sans-serif;
	font-size: 1em;
}
.ui-widget.ui-widget-content {
	border: 1px solid #c5c5c5;
}
.ui-widget-content {
	border: 1px solid #dddddd;
	background: #ffffff;
	color: #333333;
}
.ui-widget-content a {
	color: #333333;
}
.ui-widget-header {
	border: 1px solid #dddddd;
	background: #e9e9e9;
	color: #333333;
	font-weight: bold;
}
.ui-widget-header a {
	color: #333333;
}

/* Interaction states
----------------------------------*/
.ui-state-default,
.ui-widget-content .ui-state-default,
.ui-widget-header .ui-state-default,
.ui-button,

/* We use html here because we need a greater specificity to make sure disabled
works properly when clicked or hovered */
html .ui-button.ui-state-disabled:hover,
html .ui-button.ui-state-disabled:active {
	border: 1px solid #c5c5c5;
	background: #f6f6f6;
	font-weight: normal;
	color: #454545;
}
.ui-state-default a,
.ui-state-default a:link,
.ui-state-default a:visited,
a.ui-button,
a:link.ui-button,
a:visited.ui-button,
.ui-button {
	color: #454545;
	text-decoration: none;
}
.ui-state-hover,
.ui-widget-content .ui-state-hover,
.ui-widget-header .ui-state-hover,
.ui-state-focus,
.ui-widget-content .ui-state-focus,
.ui-widget-header .ui-state-focus,
.ui-button:hover,
.ui-button:focus {
	border: 1px solid #cccccc;
	background: #ededed;
	font-weight: normal;
	color: #2b2b2b;
}
.ui-state-hover a,
.ui-state-hover a:hover,
.ui-state-hover a:link,
.ui-state-hover a:visited,
.ui-state-focus a,
.ui-state-focus a:hover,
.ui-state-focus a:link,
.ui-state-focus a:visited,
a.ui-button:hover,
a.ui-button:focus {
	color: #2b2b2b;
	text-decoration: none;
}

.ui-visual-focus {
	box-shadow: 0 0 3px 1px rgb(94, 158, 214);
}
.ui-state-active,
.ui-widget-content .ui-state-active,
.ui-widget-header .ui-state-active,
a.ui-button:active,
.ui-button:active,
.ui-button.ui-state-active:hover {
	border: 1px solid #003eff;
	background: #007fff;
	font-weight: normal;
	color: #ffffff;
}
.ui-icon-background,
.ui-state-active .ui-icon-background {
	border: #003eff;
	background-color: #ffffff;
}
.ui-state-active a,
.ui-state-active a:link,
.ui-state-active a:visited {
	color: #ffffff;
	text-decoration: none;
}

/* Interaction Cues
----------------------------------*/
.ui-state-highlight,
.ui-widget-content .ui-state-highlight,
.ui-widget-header .ui-state-highlight {
	border: 1px solid #dad55e;
	background: #fffa90;
	color: #777620;
}
.ui-state-checked {
	border: 1px solid #dad55e;
	background: #fffa90;
}
.ui-state-highlight a,
.ui-widget-content .ui-state-highlight a,
.ui-widget-header .ui-state-highlight a {
	color: #777620;
}
.ui-state-error,
.ui-widget-content .ui-state-error,
.ui-widget-header .ui-state-error {
	border: 1px solid #f1a899;
	background: #fddfdf;
	color: #5f3f3f;
}
.ui-state-error a,
.ui-widget-content .ui-state-error a,
.ui-widget-header .ui-state-error a {
	color: #5f3f3f;
}
.ui-state-error-text,
.ui-widget-content .ui-state-error-text,
.ui-widget-header .ui-state-error-text {
	color: #5f3f3f;
}
.ui-priority-primary,
.ui-widget-content .ui-priority-primary,
.ui-widget-header .ui-priority-primary {
	font-weight: bold;
}
.ui-priority-secondary,
.ui-widget-content .ui-priority-secondary,
.ui-widget-header .ui-priority-secondary {
	opacity: .7;
	-ms-filter: "alpha(opacity=70)"; /* support: IE8 */
	font-weight: normal;
}
.ui-state-disabled,
.ui-widget-content .ui-state-disabled,
.ui-widget-header .ui-state-disabled {
	opacity: .35;
	-ms-filter: "alpha(opacity=35)"; /* support: IE8 */
	background-image: none;
}
.ui-state-disabled .ui-icon {
	-ms-filter: "alpha(opacity=35)"; /* support: IE8 - See #6059 */
}

/* Icons
----------------------------------*/

/* states and images */
.ui-icon {
	width: 16px;
	height: 16px;
}
.ui-icon,
.ui-widget-content .ui-icon {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
.ui-widget-header .ui-icon {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
.ui-state-hover .ui-icon,
.ui-state-focus .ui-icon,
.ui-button:hover .ui-icon,
.ui-button:focus .ui-icon {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}
.ui-state-active .ui-icon,
.ui-button:active .ui-icon {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}
.ui-state-highlight .ui-icon,
.ui-button .ui-state-highlight.ui-icon {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.ui-state-error .ui-icon,
.ui-state-error-text .ui-icon {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
.ui-button .ui-icon {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}

/* positioning */
/* Three classes needed to override \`.ui-button:hover .ui-icon\` */
.ui-icon-blank.ui-icon-blank.ui-icon-blank {
	background-image: none;
}
.ui-icon-caret-1-n { background-position: 0 0; }
.ui-icon-caret-1-ne { background-position: -16px 0; }
.ui-icon-caret-1-e { background-position: -32px 0; }
.ui-icon-caret-1-se { background-position: -48px 0; }
.ui-icon-caret-1-s { background-position: -65px 0; }
.ui-icon-caret-1-sw { background-position: -80px 0; }
.ui-icon-caret-1-w { background-position: -96px 0; }
.ui-icon-caret-1-nw { background-position: -112px 0; }
.ui-icon-caret-2-n-s { background-position: -128px 0; }
.ui-icon-caret-2-e-w { background-position: -144px 0; }
.ui-icon-triangle-1-n { background-position: 0 -16px; }
.ui-icon-triangle-1-ne { background-position: -16px -16px; }
.ui-icon-triangle-1-e { background-position: -32px -16px; }
.ui-icon-triangle-1-se { background-position: -48px -16px; }
.ui-icon-triangle-1-s { background-position: -65px -16px; }
.ui-icon-triangle-1-sw { background-position: -80px -16px; }
.ui-icon-triangle-1-w { background-position: -96px -16px; }
.ui-icon-triangle-1-nw { background-position: -112px -16px; }
.ui-icon-triangle-2-n-s { background-position: -128px -16px; }
.ui-icon-triangle-2-e-w { background-position: -144px -16px; }
.ui-icon-arrow-1-n { background-position: 0 -32px; }
.ui-icon-arrow-1-ne { background-position: -16px -32px; }
.ui-icon-arrow-1-e { background-position: -32px -32px; }
.ui-icon-arrow-1-se { background-position: -48px -32px; }
.ui-icon-arrow-1-s { background-position: -65px -32px; }
.ui-icon-arrow-1-sw { background-position: -80px -32px; }
.ui-icon-arrow-1-w { background-position: -96px -32px; }
.ui-icon-arrow-1-nw { background-position: -112px -32px; }
.ui-icon-arrow-2-n-s { background-position: -128px -32px; }
.ui-icon-arrow-2-ne-sw { background-position: -144px -32px; }
.ui-icon-arrow-2-e-w { background-position: -160px -32px; }
.ui-icon-arrow-2-se-nw { background-position: -176px -32px; }
.ui-icon-arrowstop-1-n { background-position: -192px -32px; }
.ui-icon-arrowstop-1-e { background-position: -208px -32px; }
.ui-icon-arrowstop-1-s { background-position: -224px -32px; }
.ui-icon-arrowstop-1-w { background-position: -240px -32px; }
.ui-icon-arrowthick-1-n { background-position: 1px -48px; }
.ui-icon-arrowthick-1-ne { background-position: -16px -48px; }
.ui-icon-arrowthick-1-e { background-position: -32px -48px; }
.ui-icon-arrowthick-1-se { background-position: -48px -48px; }
.ui-icon-arrowthick-1-s { background-position: -64px -48px; }
.ui-icon-arrowthick-1-sw { background-position: -80px -48px; }
.ui-icon-arrowthick-1-w { background-position: -96px -48px; }
.ui-icon-arrowthick-1-nw { background-position: -112px -48px; }
.ui-icon-arrowthick-2-n-s { background-position: -128px -48px; }
.ui-icon-arrowthick-2-ne-sw { background-position: -144px -48px; }
.ui-icon-arrowthick-2-e-w { background-position: -160px -48px; }
.ui-icon-arrowthick-2-se-nw { background-position: -176px -48px; }
.ui-icon-arrowthickstop-1-n { background-position: -192px -48px; }
.ui-icon-arrowthickstop-1-e { background-position: -208px -48px; }
.ui-icon-arrowthickstop-1-s { background-position: -224px -48px; }
.ui-icon-arrowthickstop-1-w { background-position: -240px -48px; }
.ui-icon-arrowreturnthick-1-w { background-position: 0 -64px; }
.ui-icon-arrowreturnthick-1-n { background-position: -16px -64px; }
.ui-icon-arrowreturnthick-1-e { background-position: -32px -64px; }
.ui-icon-arrowreturnthick-1-s { background-position: -48px -64px; }
.ui-icon-arrowreturn-1-w { background-position: -64px -64px; }
.ui-icon-arrowreturn-1-n { background-position: -80px -64px; }
.ui-icon-arrowreturn-1-e { background-position: -96px -64px; }
.ui-icon-arrowreturn-1-s { background-position: -112px -64px; }
.ui-icon-arrowrefresh-1-w { background-position: -128px -64px; }
.ui-icon-arrowrefresh-1-n { background-position: -144px -64px; }
.ui-icon-arrowrefresh-1-e { background-position: -160px -64px; }
.ui-icon-arrowrefresh-1-s { background-position: -176px -64px; }
.ui-icon-arrow-4 { background-position: 0 -80px; }
.ui-icon-arrow-4-diag { background-position: -16px -80px; }
.ui-icon-extlink { background-position: -32px -80px; }
.ui-icon-newwin { background-position: -48px -80px; }
.ui-icon-refresh { background-position: -64px -80px; }
.ui-icon-shuffle { background-position: -80px -80px; }
.ui-icon-transfer-e-w { background-position: -96px -80px; }
.ui-icon-transferthick-e-w { background-position: -112px -80px; }
.ui-icon-folder-collapsed { background-position: 0 -96px; }
.ui-icon-folder-open { background-position: -16px -96px; }
.ui-icon-document { background-position: -32px -96px; }
.ui-icon-document-b { background-position: -48px -96px; }
.ui-icon-note { background-position: -64px -96px; }
.ui-icon-mail-closed { background-position: -80px -96px; }
.ui-icon-mail-open { background-position: -96px -96px; }
.ui-icon-suitcase { background-position: -112px -96px; }
.ui-icon-comment { background-position: -128px -96px; }
.ui-icon-person { background-position: -144px -96px; }
.ui-icon-print { background-position: -160px -96px; }
.ui-icon-trash { background-position: -176px -96px; }
.ui-icon-locked { background-position: -192px -96px; }
.ui-icon-unlocked { background-position: -208px -96px; }
.ui-icon-bookmark { background-position: -224px -96px; }
.ui-icon-tag { background-position: -240px -96px; }
.ui-icon-home { background-position: 0 -112px; }
.ui-icon-flag { background-position: -16px -112px; }
.ui-icon-calendar { background-position: -32px -112px; }
.ui-icon-cart { background-position: -48px -112px; }
.ui-icon-pencil { background-position: -64px -112px; }
.ui-icon-clock { background-position: -80px -112px; }
.ui-icon-disk { background-position: -96px -112px; }
.ui-icon-calculator { background-position: -112px -112px; }
.ui-icon-zoomin { background-position: -128px -112px; }
.ui-icon-zoomout { background-position: -144px -112px; }
.ui-icon-search { background-position: -160px -112px; }
.ui-icon-wrench { background-position: -176px -112px; }
.ui-icon-gear { background-position: -192px -112px; }
.ui-icon-heart { background-position: -208px -112px; }
.ui-icon-star { background-position: -224px -112px; }
.ui-icon-link { background-position: -240px -112px; }
.ui-icon-cancel { background-position: 0 -128px; }
.ui-icon-plus { background-position: -16px -128px; }
.ui-icon-plusthick { background-position: -32px -128px; }
.ui-icon-minus { background-position: -48px -128px; }
.ui-icon-minusthick { background-position: -64px -128px; }
.ui-icon-close { background-position: -80px -128px; }
.ui-icon-closethick { background-position: -96px -128px; }
.ui-icon-key { background-position: -112px -128px; }
.ui-icon-lightbulb { background-position: -128px -128px; }
.ui-icon-scissors { background-position: -144px -128px; }
.ui-icon-clipboard { background-position: -160px -128px; }
.ui-icon-copy { background-position: -176px -128px; }
.ui-icon-contact { background-position: -192px -128px; }
.ui-icon-image { background-position: -208px -128px; }
.ui-icon-video { background-position: -224px -128px; }
.ui-icon-script { background-position: -240px -128px; }
.ui-icon-alert { background-position: 0 -144px; }
.ui-icon-info { background-position: -16px -144px; }
.ui-icon-notice { background-position: -32px -144px; }
.ui-icon-help { background-position: -48px -144px; }
.ui-icon-check { background-position: -64px -144px; }
.ui-icon-bullet { background-position: -80px -144px; }
.ui-icon-radio-on { background-position: -96px -144px; }
.ui-icon-radio-off { background-position: -112px -144px; }
.ui-icon-pin-w { background-position: -128px -144px; }
.ui-icon-pin-s { background-position: -144px -144px; }
.ui-icon-play { background-position: 0 -160px; }
.ui-icon-pause { background-position: -16px -160px; }
.ui-icon-seek-next { background-position: -32px -160px; }
.ui-icon-seek-prev { background-position: -48px -160px; }
.ui-icon-seek-end { background-position: -64px -160px; }
.ui-icon-seek-start { background-position: -80px -160px; }
/* ui-icon-seek-first is deprecated, use ui-icon-seek-start instead */
.ui-icon-seek-first { background-position: -80px -160px; }
.ui-icon-stop { background-position: -96px -160px; }
.ui-icon-eject { background-position: -112px -160px; }
.ui-icon-volume-off { background-position: -128px -160px; }
.ui-icon-volume-on { background-position: -144px -160px; }
.ui-icon-power { background-position: 0 -176px; }
.ui-icon-signal-diag { background-position: -16px -176px; }
.ui-icon-signal { background-position: -32px -176px; }
.ui-icon-battery-0 { background-position: -48px -176px; }
.ui-icon-battery-1 { background-position: -64px -176px; }
.ui-icon-battery-2 { background-position: -80px -176px; }
.ui-icon-battery-3 { background-position: -96px -176px; }
.ui-icon-circle-plus { background-position: 0 -192px; }
.ui-icon-circle-minus { background-position: -16px -192px; }
.ui-icon-circle-close { background-position: -32px -192px; }
.ui-icon-circle-triangle-e { background-position: -48px -192px; }
.ui-icon-circle-triangle-s { background-position: -64px -192px; }
.ui-icon-circle-triangle-w { background-position: -80px -192px; }
.ui-icon-circle-triangle-n { background-position: -96px -192px; }
.ui-icon-circle-arrow-e { background-position: -112px -192px; }
.ui-icon-circle-arrow-s { background-position: -128px -192px; }
.ui-icon-circle-arrow-w { background-position: -144px -192px; }
.ui-icon-circle-arrow-n { background-position: -160px -192px; }
.ui-icon-circle-zoomin { background-position: -176px -192px; }
.ui-icon-circle-zoomout { background-position: -192px -192px; }
.ui-icon-circle-check { background-position: -208px -192px; }
.ui-icon-circlesmall-plus { background-position: 0 -208px; }
.ui-icon-circlesmall-minus { background-position: -16px -208px; }
.ui-icon-circlesmall-close { background-position: -32px -208px; }
.ui-icon-squaresmall-plus { background-position: -48px -208px; }
.ui-icon-squaresmall-minus { background-position: -64px -208px; }
.ui-icon-squaresmall-close { background-position: -80px -208px; }
.ui-icon-grip-dotted-vertical { background-position: 0 -224px; }
.ui-icon-grip-dotted-horizontal { background-position: -16px -224px; }
.ui-icon-grip-solid-vertical { background-position: -32px -224px; }
.ui-icon-grip-solid-horizontal { background-position: -48px -224px; }
.ui-icon-gripsmall-diagonal-se { background-position: -64px -224px; }
.ui-icon-grip-diagonal-se { background-position: -80px -224px; }


/* Misc visuals
----------------------------------*/

/* Corner radius */
.ui-corner-all,
.ui-corner-top,
.ui-corner-left,
.ui-corner-tl {
	border-top-left-radius: 3px;
}
.ui-corner-all,
.ui-corner-top,
.ui-corner-right,
.ui-corner-tr {
	border-top-right-radius: 3px;
}
.ui-corner-all,
.ui-corner-bottom,
.ui-corner-left,
.ui-corner-bl {
	border-bottom-left-radius: 3px;
}
.ui-corner-all,
.ui-corner-bottom,
.ui-corner-right,
.ui-corner-br {
	border-bottom-right-radius: 3px;
}

/* Overlays */
.ui-widget-overlay {
	background: #aaaaaa;
	opacity: .3;
	-ms-filter: Alpha(Opacity=30); /* support: IE8 */
}
.ui-widget-shadow {
	box-shadow: 0px 0px 5px #666666;
}

/* Jquery UI Styles End */

.getBtn{    margin: 30px 0 0 0;
  padding: 5px;
  height: 35px;
}
.getBtn38{    
  margin: 38px 0 0 0;
  padding: 5px;
  height: 35px;
}
.headerColorForGrid {
  background-color: #cb7f66;
  color: #000000;
  font-weight: bold;
  font-size: 14px;
}

.ag-center-header .ag-header-cell-label {
  justify-content: center;
  padding-left: 14px;
}
.ag-header-cell.headerColorForGrid:hover {
  background-color: transparent !important; /* Set to transparent or your preferred color */
}
.legend-container{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.color-indicator-box{
  display: flex;
  align-items: center;
  margin-right: 30px;
}
.color-box{
  width: 15px;
  height: 15px;
  margin-right: 5px;
  border-radius: 7.5px;
}
.exact{
  background-color:rgb(37, 180, 49)
}
.excess{
  background-color: orange;
}
.under{
  background-color: rosybrown;
}
.logout-icon {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.popup {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #F5F5F5;
  border: 1px solid #ccc;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
  width: 200px;
  padding: 10px;
  border-radius: 10px;
}

.popup ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.popup li {
  padding: 5px;
  text-decoration: none;
  color: #070000;
  display: block;
  font-weight: bold
}

.popup li a {
  text-decoration: none;
  color: #070000;
  display: block;
  font-weight: bold
}

.popup li a:hover {
  color: green;
}
.popup li:hover {
  color: green;
}
.password-input{
  margin-bottom: 10px;
}
.password-label{
  margin: 0px;
}
.err-msg{
  color: red;
}
.loader-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.loader-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #3498db; /* Blue color for the spinner */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loader-label {
  margin-top: 10px;
  font-size: 16px;
  color: #333;
}
.app {
  text-align: center;
  margin-top: 50px;
}

.delete-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999; /* Ensure it's on top */
}

.delete-content {
  background-color: white;
  width: 400px;
  padding: 30px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  text-align: center; /* Center the content */
}

.popup-buttons {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

/* Style for close (X) button */
.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
#testGrid .ag-header.ag-pivot-off{
  /* background:#c86544; */
  color:"#000000";
  font-weight: bold;
  cursor: default !important;
}
#testGrid .ag-header-cell:hover {
  background-color: #c86544!important; /* or any specific color you want */
  /* Add any other styles you want to modify on hover */
}
.ag-cell.no-pointer {
  cursor: default !important; /* Use the default arrow cursor */
}
#testGrid .ag-cell-value:hover{
  cursor: pointer;
}
.your-row-class:hover {
  background-color: #bcc3c0 !important;
  z-index: 1; /* Change this to your desired background color */
}
#myGrid1 .ag-header.ag-pivot-off{
background:#beddeb;
color:black;
font-weight: bolder;
font-size: 14px;
}
.nsaibg{
background-color: #809fff
}
.pobg{
  background-color: #00cccc
}
.s-aibg{
  background-color: #66ff99
}
.etpbg{
  background-color: #66ff99
}
.espbg{
  background-color: #ff8fa3
}
.upbg{
  background-color: #fdc958
}
.ag-theme-balham .ag-header.row {
  background-color: "blue" !important;
}
.counter-header-color{
  color: black;
}
.counter-card-plate{
  /* background-color: blue; */
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  color: black;
  padding: 0px;
  border-right: 1px solid #9a8c98;
}
.counter-pointer{
  cursor: pointer;
}

.column-header-style{
  font-weight: bold;
  color: black;
}
.info-icon {
  position: absolute;
  top: -20px; /* Adjust top position as needed */
  right: 3px; /* Adjust right position as needed */
  cursor: pointer;
}


/* Tooltip Styling (Initially Hidden) */
.info-tooltip {
  position: absolute;
  top: 20px;
  
  right: 50%; /* Adjust as needed to position the tooltip correctly */
  background-color: #f9f9f9;
  opacity: 0.9;
  color: black;;
  padding: 10px;
  border-radius: 5px;
  display: none;
  width: 300px;
  font-weight: bold;
  z-index: 9999;
}
.info-tooltip-new {
  position: absolute;
  top: 20px;
  left: 50%;
  right: 50%; /* Adjust as needed to position the tooltip correctly */
  background-color: #f9f9f9;
  opacity: 0.9;
  color: black;
  padding: 10px;
  border-radius: 5px;
  display: none;
  width: 300px;
  font-weight: bold;
  z-index: 9999;
}

/* Tooltip Appearance on Hover */
.info-icon:hover .info-tooltip {
  display: block;
}
.info-icon:hover .info-tooltip-new {
  display: block;
}
.no-margin{
  margin: 0px;
}

:root {
  --bar-color: #168aad;
  --ball-color: #80ed99;
  --bg-color: rgb(68, 206, 125);
}

#loader {
  position: fixed;
  top: 50%;
  left: 53%;
  transform: translate(-50%, -50%);
  width: 150px;
  height: 100px;
}

.loader__bar {
  position: absolute;
  bottom: 0;
  width: 13px;
  height: 59%;
  background: var(--bar-color); /* Replace with your desired color value */
  transform-origin: center bottom;
  box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);
}

/* Generate .loader__bar styles and animations */
.loader__bar:nth-child(1) {
  left: 0;
  transform: scale(1, 0.2);
  animation: barUp1 4s infinite;
}

.loader__bar:nth-child(2) {
  left: 15px;
  transform: scale(1, 0.4);
  animation: barUp2 4s infinite;
}

.loader__bar:nth-child(3) {
  left: 30px;
  transform: scale(1, 0.6);
}

.loader__bar:nth-child(4) {
  left: 45px;
  transform: scale(1, 0.8);
  animation: barUp4 4s infinite;
}

.loader__bar:nth-child(5) {
  left: 60px;
  transform: scale(1, 1);
  animation: barUp5 4s infinite;
}

.loader__ball {
  position: absolute;
  bottom: 10px;
  left: 0;
  width: 13px;
  height: 13px;
  background: var(--ball-color); /* Replace with your desired color value */
  border-radius: 50%;
  animation: ball 4s infinite;
}
@keyframes ball {
  0% {
    transform: translate(0, 0);
  }
  5% {
    transform: translate(8px, -14px);
  }
  10% {
    transform: translate(15px, -10px)
  }
  17% {
    transform: translate(23px, -24px)
  }
  20% {
    transform: translate(30px, -20px)
  }
  27% {
    transform: translate(38px, -34px)
  }
  30% {
    transform: translate(45px, -30px)
  }
  37% {
    transform: translate(53px, -44px)
  }
  40% {
    transform: translate(60px, -40px)
  }
  50% {
    transform: translate(60px, 0)
  }
  57% {
    transform: translate(53px, -14px)
  }
  60% {
    transform: translate(45px, -10px)
  }
  67% {
    transform: translate(37px, -24px)
  }
  70% {
    transform: translate(30px, -20px)
  }
  77% {
    transform: translate(22px, -34px)
  }
  80% {
    transform: translate(15px, -30px)
  }
  87% {
    transform: translate(7px, -44px)
  }
  90% {
    transform: translate(0, -40px)
  }
  100% {
    transform: translate(0, 0);
  }
}

@keyframes barUp1 { 
  0% {
    transform: scale(1, .2);
  }
  40%{
    transform: scale(1, .2);
  }
  50% {
    transform: scale(1, 1);
  }
  90% {
    transform: scale(1,1);
  }
  100% {
    transform: scale(1,.2);
  }
}
@keyframes barUp2 { 
  0% {
    transform: scale(1, .4);
  }
  40% {
    transform: scale(1, .4);
  }
  50% {
    transform: scale(1, .8);
  }
  90% {
    transform: scale(1, .8);
  }
  100% {
    transform: scale(1, .4);
  }
}
@keyframes barUp3 { 
  0% {
    transform: scale(1, .6);
  }
  100% {
    transform: scale(1, .6);
  }
}
@keyframes barUp4 { 
  0% {
    transform: scale(1, .8);
  }
  40% {
    transform: scale(1, .8);
  }
  50% {
    transform: scale(1, .4);
  }
  90% {
    transform: scale(1, .4);
  }
  100% {
    transform: scale(1, .8);
  }
}
@keyframes barUp5 { 
  0% {
    transform: scale(1, 1);
  }
  40% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1, .2);
  }
  90% {
    transform: scale(1, .2);
  }
  100% {
    transform: scale(1, 1);
  }
}

.new-loader {
  top: 48%;
  left: 51%;
  transform: translate(-50%, -50%);
  position: absolute;
}
.bar {
  width: 20px;
  height: 90px;
  /* background: #fff; */
  display: inline-block;
  transform-origin: bottom center;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  /*   box-shadow:5px 10px 20px inset rgba(255,23,25.2); */
  animation: loader 1.2s linear infinite;
}
.bar1 {
  animation-delay: 0.1s;
}
.bar2 {
  animation-delay: 0.2s;
}
.bar3 {
  animation-delay: 0.3s;
}
.bar4 {
  animation-delay: 0.4s;
}
.bar5 {
  animation-delay: 0.5s;
}
.bar6 {
  animation-delay: 0.6s;
}
.bar7 {
  animation-delay: 0.7s;
}
.bar8 {
  animation-delay: 0.8s;
}

@keyframes loader {
  0% {
    transform: scaleY(0.1);
    background: #168aad;
  }
  50% {
    transform: scaleY(1);
    background: #80ed99;
  }
  100% {
    transform: scaleY(0.1);
    background: blueviolet;
  }
}
#sidebar {
  height: 100%;
  position: fixed;
  top: 0;
}
#top-navbar {
  height: 100%;
  position: sticky;
  top: 0;
  /* z-index: 10000; */
}
.slider-z-index{
  z-index: 10001;
}

.sliderbg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Adjust the last value (0.7) for opacity */
  z-index: 10003; /* Ensure the overlay is on top of other content */
}
.result-summary-table{
  width: 100%;
  height: 277px;
  font-size: 13px!important;
  font-weight: bold;
}
.result-summary-html-table{
  font-size: 15px;
  color: black;
}
.sidebar-txt{
  font-size: 10px!important;
}
@media screen and (min-width: 1920px) {
  /* Your styles for screens with a width of at least 1920 pixels go here */
  .f14{font-size: 17px;}
  .f15{font-size: 19px;}
  .f17{font-size: 20px;}
  .f19{font-size: 23px;}
  .f20{font-size: 25px;}
  .f35{font-size: 40px;}
  .f23{font-size: 27px;}
  .counter-card-plate{
    /* background-color: blue; */
    height: 150px;
  }
  .info-icon{
    font-size: 15px;
  }
  .info-tooltip{
    width: 400px;
    font-size: 17px;
    padding-bottom: 0px;
  }
  .mt-5p{
    margin-top: 10px;
  }
  .custom-col {
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
  .headerColorForGrid {
    font-size: 17px;
  }
  .result-summary-table{
    width: 100%;
    height: 277px;
    font-size: 15px!important;
    font-weight: bold;
  }
  .result-summary-html-table{
    font-size: 17px;
  }
  .sidebar-txt{
    font-size: 13px!important;
  }
  #myGrid1{
    font-size: 14px!important;
  }
}
.new-popup-bg-container{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000; /* Ensure it's on top */
}
.new-popup-container{
  background-color: #f9f9f9;
  padding: 20px;
  width: 400px;
  border-radius: 10px;
  text-align: center;
}
.new-loader-container{
position: absolute;
z-index: 1001;
}
.new-overlay {
  position: absolute;
  background: rgba(255, 255, 255, 0.7); /* Semi-transparent white overlay */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000; /* Adjust as needed to make sure it's above other elements */
}
.new-label{
  font-size: 15px;
  color: #555;
  font-weight: bold;
  margin-bottom: 0px;
}


`, "",{"version":3,"sources":["webpack://./src/assets/css/venjos.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,4CAA2C;AAC/C;AACA;IACI,gCAAgC;IAChC,4CAAiD;AACrD;AACA;IACI,2BAA2B;IAC3B,4CAA4C;AAChD;AACA;IACI,iCAAiC;IACjC,4CAAkD;AACtD;AACA;IACI,0BAA0B;IAC1B,4CAA2C;AAC/C;AACA;IACI,gCAAgC;IAChC,4CAAiD;AACrD;AACA;IACI,4BAA4B;IAC5B,4CAA6C;AACjD;AACA;IACI,2BAA2B;IAC3B,4CAA4C;AAChD;AACA;IACI,iCAAiC;IACjC,4CAAkD;AACtD;AACA;IACI,4BAA4B;IAC5B,4CAA6C;AACjD;AACA;IACI,kCAAkC;IAClC,6CAAmD;AACvD;AACA;IACI,6BAA6B;IAC7B,6CAA8C;AAClD;AACA,gCAAgC,WAAW,CAAC;AAC5C;AACA,gBAAgB;AAChB;;AAEA;AACA,QAAQ;AACR,wDAAwD;AACxD,mBAAmB;AACnB,yBAAyB;;AAEzB;AACA,+DAA+D,UAAU,CAAC;AAC1E,4DAA4D,yBAAyB,CAAC;AACtF,oFAAoF,UAAU,CAAC,qBAAqB,CAAC;AACrH;IACI,8DAA8D;IAC9D,8DAA8D;AAClE;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB,mBAAmB;IACnB,qEAAqE;IACrE,eAAe;AACnB;AACA,sCAAsC;AACtC,OAAO,2BAA2B,CAAC;AACnC;EACE,gBAAgB;AAClB;AACA,UAAU,6BAA6B,CAAC;AACxC,SAAS,4BAA4B,CAAC;AACtC,OAAO,0BAA0B,CAAC;AAClC,QAAQ,2BAA2B,CAAC;AACpC,YAAY,yBAAyB,CAAC,aAAa,CAAC;AACpD,cAAc,yBAAyB,CAAC,aAAa,CAAC;AACtD,YAAY,yBAAyB,CAAC,aAAa,CAAC;AACpD,WAAW,yBAAyB,CAAC,aAAa,CAAC;AACnD,YAAY,yBAAyB,CAAC,aAAa,CAAC;AACpD,SAAS,yBAAyB,CAAC,aAAa,CAAC;AACjD,SAAS,yBAAyB,CAAC,aAAa,CAAC;AACjD,YAAY,yBAAyB,CAAC,aAAa,CAAC;AACpD,WAAW,YAAY,CAAC,mBAAmB,CAAC,kBAAkB,CAAC;AAC/D,cAAc,4BAA4B,CAAC,eAAe,CAAC,wBAAwB,CAAC;AACpF,cAAc,6BAA6B,CAAC,eAAe,CAAC;AAC5D,UAAU,eAAe,CAAC;AAC1B;IACI,uBAAuB;AAC3B;AACA;IACI,sBAAsB;AAC1B;;AAEA,IAAI,SAAS,CAAC;AACd,IAAI,SAAS,CAAC;AACd,IAAI,SAAS,CAAC;AACd,IAAI,SAAS,CAAC;AACd,IAAI,SAAS,CAAC;AACd,IAAI,SAAS,CAAC;AACd,IAAI,SAAS,CAAC;AACd,IAAI,SAAS,CAAC;AACd,IAAI,SAAS,CAAC;AACd,KAAK,UAAU,CAAC;AAChB,KAAK,UAAU,CAAC;;AAEhB,KAAK,aAAa,CAAC;;;AAGnB,OAAO,cAAc,CAAC;AACtB,OAAO,cAAc,CAAC;AACtB,QAAQ,eAAe,CAAC;AACxB,QAAQ,eAAe,CAAC;AACxB,QAAQ,eAAe,CAAC;AACxB,QAAQ,eAAe,CAAC;AACxB,QAAQ,eAAe,CAAC;AACxB,QAAQ,eAAe,CAAC;AACxB,QAAQ,eAAe,CAAC;AACxB,QAAQ,eAAe,CAAC;AACxB,QAAQ,eAAe,CAAC;AACxB,QAAQ,eAAe,CAAC;AACxB,QAAQ,eAAe,CAAC;AACxB,QAAQ,eAAe,CAAC;AACxB,QAAQ,eAAe,CAAC;AACxB,QAAQ,eAAe,CAAC;AACxB,QAAQ,eAAe,CAAC;AACxB,QAAQ,eAAe,CAAC;AACxB,QAAQ,eAAe,CAAC;AACxB,QAAQ,eAAe,CAAC;AACxB,SAAS,gBAAgB,CAAC;;AAE1B,OAAO,iBAAiB,CAAC;AACzB,OAAO,iBAAiB,CAAC;AACzB,QAAQ,kBAAkB,CAAC;AAC3B,QAAQ,kBAAkB,CAAC;AAC3B,QAAQ,kBAAkB,CAAC;AAC3B,QAAQ,kBAAkB,CAAC;AAC3B,QAAQ,kBAAkB,CAAC;AAC3B,QAAQ,kBAAkB,CAAC;AAC3B,QAAQ,kBAAkB,CAAC;AAC3B,QAAQ,kBAAkB,CAAC;AAC3B,QAAQ,kBAAkB,CAAC;AAC3B,QAAQ,kBAAkB,CAAC;AAC3B,QAAQ,kBAAkB,CAAC;AAC3B,QAAQ,kBAAkB,CAAC;AAC3B,QAAQ,kBAAkB,CAAC;AAC3B,QAAQ,kBAAkB,CAAC;AAC3B,QAAQ,kBAAkB,CAAC;AAC3B,QAAQ,kBAAkB,CAAC;AAC3B,QAAQ,kBAAkB,CAAC;AAC3B,QAAQ,kBAAkB,CAAC;AAC3B,SAAS,mBAAmB,CAAC;;;AAG7B,OAAO,gBAAgB,CAAC;AACxB,OAAO,gBAAgB,CAAC;AACxB,QAAQ,iBAAiB,CAAC;AAC1B,QAAQ,iBAAiB,CAAC;AAC1B,QAAQ,iBAAiB,CAAC;AAC1B,QAAQ,iBAAiB,CAAC;AAC1B,QAAQ,iBAAiB,CAAC;AAC1B,QAAQ,iBAAiB,CAAC;AAC1B,QAAQ,iBAAiB,CAAC;AAC1B,QAAQ,iBAAiB,CAAC;AAC1B,QAAQ,iBAAiB,CAAC;AAC1B,QAAQ,iBAAiB,CAAC;AAC1B,QAAQ,iBAAiB,CAAC;AAC1B,QAAQ,iBAAiB,CAAC;AAC1B,QAAQ,iBAAiB,CAAC;AAC1B,QAAQ,iBAAiB,CAAC;AAC1B,QAAQ,iBAAiB,CAAC;AAC1B,QAAQ,iBAAiB,CAAC;AAC1B,QAAQ,iBAAiB,CAAC;AAC1B,QAAQ,iBAAiB,CAAC;AAC1B,SAAS,kBAAkB,CAAC;;AAE5B,OAAO,eAAe,CAAC;AACvB,OAAO,eAAe,CAAC;AACvB,QAAQ,gBAAgB,CAAC;AACzB,QAAQ,gBAAgB,CAAC;AACzB,QAAQ,gBAAgB,CAAC;AACzB,QAAQ,gBAAgB,CAAC;AACzB,QAAQ,gBAAgB,CAAC;AACzB,QAAQ,gBAAgB,CAAC;AACzB,QAAQ,gBAAgB,CAAC;AACzB,QAAQ,gBAAgB,CAAC;AACzB,QAAQ,gBAAgB,CAAC;AACzB,QAAQ,gBAAgB,CAAC;AACzB,QAAQ,gBAAgB,CAAC;AACzB,QAAQ,gBAAgB,CAAC;AACzB,QAAQ,gBAAgB,CAAC;AACzB,QAAQ,gBAAgB,CAAC;AACzB,QAAQ,gBAAgB,CAAC;AACzB,QAAQ,gBAAgB,CAAC;AACzB,QAAQ,gBAAgB,CAAC;AACzB,QAAQ,gBAAgB,CAAC;AACzB,SAAS,iBAAiB,CAAC;;;AAG3B,MAAM,UAAU,CAAC;AACjB,MAAM,UAAU,CAAC;AACjB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,QAAQ,YAAY,CAAC;AACrB,eAAe,yBAAyB,CAAC;AACzC,QAAQ,yBAAyB,CAAC;AAClC,IAAI,cAAc,CAAC;AACnB,IAAI,cAAc,CAAC;AACnB,IAAI,cAAc,CAAC;AACnB,IAAI,cAAc,CAAC;AACnB,IAAI,cAAc,CAAC;AACnB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,gBAAgB,CAAC;AACtB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,KAAK,eAAe,CAAC;AACrB,MAAM,WAAW,CAAC;AAClB,MAAM,WAAW,CAAC;AAClB,MAAM,WAAW,CAAC;AAClB,MAAM,WAAW,CAAC;AAClB,MAAM,WAAW,CAAC;AAClB,MAAM,WAAW,CAAC;AAClB,MAAM,WAAW,CAAC;AAClB,OAAO,YAAY,CAAC;AACpB,OAAO,YAAY,CAAC;AACpB,OAAO,YAAY,CAAC;AACpB,OAAO,YAAY,CAAC;AACpB,OAAO,YAAY,CAAC;AACpB,QAAQ,4BAA4B,CAAC;AACrC,QAAQ,4BAA4B,CAAC;AACrC,QAAQ,4BAA4B,CAAC;AACrC,QAAQ,4BAA4B,CAAC;AACrC,QAAQ,4BAA4B,CAAC;AACrC,QAAQ,4BAA4B,CAAC;AACrC,QAAQ,6BAA6B,CAAC;AACtC,QAAQ,8BAA8B,CAAC;AACvC,QAAQ,+BAA+B,CAAC;AACxC,YAAY,kBAAkB,CAAC;AAC/B,iBAAiB,yBAAyB,CAAC;AAC3C,UAAU,yBAAyB,CAAC;AACpC,UAAU,YAAY,CAAC,YAAY,CAAC;AACpC;IACI,0DAA8C;IAC9C,4BAA4B;IAC5B,wBAAwB;AAC5B;AACA;CACC,cAAc;IACX,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,WAAW;IACX,mBAAmB;;EAErB;AACF,SAAS,iBAAiB,CAAC,OAAO,CAAC,QAAQ,CAAC;AAC5C;IACI,oCAAoC;IACpC,gCAAgC;AACpC;AACA,QAAQ,wBAAwB,CAAC,gBAAgB,CAAC;EAChD;GACC,kBAAkB;IACjB,QAAQ;IACR,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;AACF,mCAAmC,aAAa,CAAC;AACjD,UAAU,eAAe;GACtB,OAAO;GACP,QAAQ;GACR,UAAU;GACV;AACH;AACA,YAAY,sBAAsB,CAAC,kBAAkB,CAAC;AACtD,SAAS,eAAe,CAAC,qBAAqB,CAAC,aAAa,CAAC;AAC7D;IACI,oBAAoB;AACxB;AACA;IACI,sBAAsB;IACtB,SAAS;IACT,6CAA6C;;AAEjD;AACA,UAAU,eAAe,EAAE,UAAU,EAAE,cAAc,CAAC,eAAe,EAAE,WAAW;IAC9E,2BAA2B;AAC/B;AACA,oBAAoB,oBAAoB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE,oBAAoB,CAAC,sBAAsB,EAAE;AACnI,wBAAwB,+BAA+B,CAAC;AACxD,0BAA0B,YAAY,CAAC;AACvC;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,uBAAuB;IACvB,gCAAgC;IAChC,uBAAuB;IACvB,6BAA6B;IAC7B,aAAa;IACb,yCAAyC;AAC7C;AACA,OAAO,UAAU,CAAC;AAClB,QAAQ,aAAa,CAAC;AACtB;IACI,UAAU;IACV,gCAAgC;AACpC;AACA;CACC,UAAU;CACV,wBAAwB;EACvB,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;AAC/B;AACA,sBAAsB,qBAAqB,CAAC;AAC5C,sBAAsB,qBAAqB,CAAC;AAC5C,sBAAsB,qBAAqB,CAAC;;AAE5C;IACI;MACE,UAAU;MACV,wCAAwC;IAC1C;IACA;MACE,YAAY;MACZ,qBAAqB;IACvB;IACA;MACE,UAAU;MACV,sBAAsB;IACxB;IACA;MACE,UAAU;MACV,sCAAsC;IACxC;EACF;;EAEA;MACI,UAAU;OACT,sBAAsB;MACvB,2BAA2B,EAAE,YAAY;MACzC,8BAA8B,EAAE,sBAAsB;MACtD,yBAAyB,EAAE,UAAU;EACzC;EACA;MACI;UACI,SAAS;MACb;MACA;UACI,SAAS;MACb;EACJ;;EA0BA;IACE,oCAAoC;EACtC;;EAEA;IACE;QACI,yBAAyB;IAC7B;IACA;QACI,4BAA4B;IAChC;EACF;AACF;AACA,SAAS;AACT;AACA;IACI,SAAS;IACT,mCAAmC;AACvC;AACA;IACI,SAAS;AACb;AACA;IACI,SAAS;IACT,mCAAmC;AACvC;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;IACV,mCAAmC;AACvC;AACA,aAAa,QAAQ,CAAC,UAAU,CAAC;AACjC;IACI,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;AACA,WAAW,aAAa,CAAC;AACzB,eAAe,cAAc,CAAC,UAAU,CAAC,WAAW,CAAC,KAAK,CAAC,MAAM,CAAC,eAAe,CAAC,WAAW,CAAC,WAAW,CAAC;AAC1G;IACI,cAAc;IACd,SAAS;IACT,OAAO;IACP,OAAO;IACP,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,gBAAgB;CACnB,qDAAqD;IAClD,gBAAgB;IAEhB,2BAA2B;AAC/B;AACA;IACI,cAAc;IACd,SAAS;IACT,OAAO;IACP,OAAO;IACP,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,eAAe;CAClB,qDAAqD;IAClD,gBAAgB;IAEhB,2BAA2B;AAC/B;AACA,SAAS,oBAAoB,CAAC,yBAAyB,CAAC;AACxD,SAAS,oBAAoB,CAAC,yBAAyB,CAAC;AACxD,SAAS,oBAAoB,CAAC,yBAAyB,CAAC;AACxD,SAAS,oBAAoB,CAAC,yBAAyB,CAAC;AACxD,SAAS,oBAAoB,CAAC,yBAAyB,CAAC;AACxD,SAAS,oBAAoB,CAAC,yBAAyB,CAAC;AACxD,SAAS,oBAAoB,CAAC,yBAAyB,CAAC;AACxD,QAAQ,YAAY,CAAC;AACrB,QAAQ,aAAa,CAAC;AACtB,MAAM,aAAa,CAAC;AACpB,QAAQ,yBAAyB,CAAC,aAAa,CAAC,gBAAgB,CAAC;AACjE,8BAA8B,cAAc,CAAC,sCAAsC,CAAC;AACpF,QAAQ,eAAe,CAAC;AACxB,MAAM,gBAAgB,CAAC;AACvB,MAAM,aAAa,CAAC;AACpB,OAAO,gBAAgB,CAAC,gBAAgB,CAAC;AACzC;IACI,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,0BAA0B;AAC9B;AACA,cAAc,UAAU;AACxB,QAAQ,iBAAiB,CAAC,OAAO,CAAC,OAAO,CAAC,WAAW,CAAC,WAAW,CAAC,eAAe,CAAC,eAAe,CAAC,WAAW,CAAC,YAAY,CAAC,8BAA8B,CAAC;AAC1J,WAAW,cAAc,CAAC,WAAW,CAAC;AACtC,WAAW,QAAQ,CAAC,SAAS,CAAC;AAC9B,WAAW,oBAAoB,CAAC,gBAAgB,CAAC,4BAA4B,CAAC;AAC9E,WAAW,iBAAiB,CAAC,KAAK,CAAC,SAAS,CAAC;;AAE7C;AACA,eAAe;AACf;AACA,aAAa,kBAAkB,CAAC,UAAU,CAAC;AAC3C,cAAc,kBAAkB,CAAC;AACjC,iBAAiB,YAAY,CAAC,gBAAgB,CAAC;;AAE/C,UAAU,WAAW;IACjB,eAAe;IACf,yBAAyB,CAAC,gBAAgB,CAAC;AAC/C;IACI,eAAe;IACf,KAAK;IACL,MAAM;IACN,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,aAAa;EACf;EACA,OAAO,yBAAyB,CAAC;EACjC,MAAM,wBAAwB,CAAC;EAC/B;IACE,YAAY;IACZ,eAAe;IACf,UAAU;IACV,QAAQ,CAAC,OAAO;IAChB,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAEhB,2BAA2B;EAC7B;EACA;IACE,SAAS;IACT,WAAW;IACX,yBAAyB;EAC3B;EACA;IACE,SAAS;IACT,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,SAAS;IACT,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,SAAS;IACT,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,SAAS;IACT,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,SAAS;IACT,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,SAAS;IACT,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,SAAS;IACT,WAAW;IACX,yBAAyB;EAC3B;EACA;IACE,SAAS;IACT,WAAW;IACX,yBAAyB;EAC3B;EACA,eAAe,kBAAkB,CAAC;EAClC,cAAc,kBAAkB,CAAC,SAAS,CAAC,OAAO,CAAC,gBAAgB,CAAC,UAAU,CAAC;EAC/E,aAAa,YAAY,CAAC;EAC1B;IACE,QAAQ;IACR,SAAS;EACX;EACA,eAAe,qBAAqB,CAAC,qBAAqB,CAAC,YAAY,CAAC;EACxE,YAAY,kBAAkB,CAAC,QAAQ,CAAC,MAAM,CAAC;;AAEjD;;IAEI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;AACA,kBAAkB,wBAAwB,CAAC;AAC3C;IACI,sBAAsB;IACtB,+BAA+B;IAC/B,yBAAyB;IACzB,aAAa;AACjB;;AAEA,oCAAoC,aAAa,CAAC;AAClD,KAAK,gBAAgB;AACrB,oCAAoC,yBAAyB,CAAC;AAC9D,UAAU,mCAAmC;AAC7C,MAAM,wDAAwD;IAC1D,yBAAyB;IACzB,wBAAwB,CAAC;AAC7B,QAAQ,wDAAwD;QACxD,yBAAyB;OAC1B;;AAEP,WAAW,wDAAwD;IAC/D,yBAAyB;IACzB,sBAAsB,CAAC;;AAE3B;IACI,iBAAiB;IACjB,MAAM;IACN,QAAQ;IACR,WAAW;AACf;AACA,OAAO,sBAAsB,CAAC;AAC9B,QAAQ,eAAe,CAAC,gBAAgB,CAAC;AACzC,SAAS,kBAAkB,CAAC,UAAU,CAAC,SAAS,CAAC,SAAS,CAAC;AAC3D;IACI,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,SAAS;IACT,aAAa;IACb,WAAW;IACX,WAAW;IACX,YAAY;AAChB;AACA,SAAS,iBAAiB,CAAC,UAAU,CAAC,WAAW,CAAC,eAAe,CAAC,WAAW,CAAC,KAAK,CAAC,MAAM,CAAC,wBAAwB,CAAC;AACpH;IACI,cAAc;IACd,UAAU;IACV,WAAW;IACX,KAAK;IACL,MAAM;IACN,UAAU;IACV,eAAe;IACf,YAAY;AAChB;AACA;IACI,eAAe;IACf,UAAU;IACV,YAAY;IACZ,KAAK;IACL,MAAM;IACN,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;EACZ;AACF;IACI,eAAe;IACf,UAAU;IACV,YAAY;IACZ,KAAK;IACL,MAAM;IACN,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,cAAc;AAClB;AACA;IACI,UAAU;IACV,aAAa;IACb,2DAA2D;IAC3D,YAAY;IACZ,wCAAwC;IACxC,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;;EAEA;IACE;MACE,mBAAmB;IACrB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,mBAAmB;IACrB;EACF;AACF,QAAQ,sBAAsB,CAAC,UAAU,CAAC,UAAU,CAAC,cAAc,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,OAAO,CAAC;AAClI;CACC,kBAAkB;CAClB,6BAA6B;AAC9B;AACA;CACC,kBAAkB;CAClB,YAAY;CACZ,4BAA4B;AAC7B;AACA;CACC,kBAAkB;CAClB,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,6CAA6C;AAC9C;AACA;CACC,6CAA6C;CAC7C,2BAA2B;AAC5B;AACA;CACC,6CAA6C;CAC7C,6BAA6B;AAC9B;AACA;CACC,6CAA6C;CAC7C,4BAA4B;AAC7B;AACA;CACC,2CAA2C;CAC3C,+BAA+B;AAChC;AACA;CACC,4BAA4B;AAC7B;AACA,oCAAoC,eAAe,CAAC,wBAAwB,EAAE,6BAA6B,CAAC;AAC5G;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;AACA,QAAQ,UAAU,CAAC;AACnB,YAAY,iBAAiB,CAAC,KAAK,CAAC,MAAM,CAAC,UAAU,CAAC,WAAW,CAAC,qBAAqB,CAAC,SAAS,CAAC;AAClG,MAAM,iBAAiB,CAAC,QAAQ,CAAC,QAAQ,CAAC,cAAc,CAAC;AACzD,MAAM,eAAe,CAAC;;AAEtB;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;AACd;AACA,8FAA8F;AAC9F,eAAe,6BAA6B,CAAC,2BAA2B,CAAC,yBAAyB,CAAC,yBAAyB,CAAC,gCAAgC,CAAC;;;;AAI9J,0BAA0B;AAC1B;EACE,oCAAoC;EACpC,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE;MACI,cAAc;MACd,6BAA6B;EACjC;AACF;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA,kDAAkD;AAClD;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,8BAA8B;EAC9B,wDAAwD;AAC1D;AACA,YAAY,cAAc,CAAC,gBAAgB,CAAC;AAC5C,UAAU,aAAa,CAAC,cAAc,CAAC;AACvC;EACE,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,iCAAiC;AACnC;AACA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;AACA,QAAQ,cAAc,CAAC,SAAS,CAAC;AACjC,WAAW,eAAe,CAAC,qBAAqB,CAAC;AACjD,SAAS,6BAA6B,CAAC,qBAAqB,CAAC,UAAU,CAAC;AACxE,QAAQ,eAAe,CAAC,yBAAyB,EAAE,UAAU,CAAC;AAC9D,eAAe,sBAAsB,CAAC,UAAU,CAAC,gBAAgB,CAAC;AAClE,uCAAuC,gBAAgB,CAAC;AACxD,uBAAuB,UAAU,CAAC;AAClC,UAAU,aAAa;AACvB,QAAQ,gBAAgB,CAAC;AACzB,QAAQ,gBAAgB,CAAC;AACzB,YAAY,kBAAkB,CAAC;AAC/B,OAAO,UAAU;AACjB,WAAW,wBAAwB;AACnC,WAAW,4BAA4B,CAAC;AACxC;GACG,gBAAgB;GAChB,6BAA6B;AAChC;AACA,SAAS,eAAe,CAAC;AACzB,SAAS,eAAe,CAAC;AACzB,SAAS,eAAe,CAAC;AACzB,SAAS,eAAe,CAAC;AACzB,eAAe,mBAAmB,CAAC,oCAAoC,CAAC;AACxE,kCAAkC,mCAAmC;AACrE,SAAS,iBAAiB,CAAC;AAC3B,KAAK,eAAe;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;AACA,KAAK,qEAAwD,KAAK,iCAAiC,CAAC,uCAAuC,CAAC,qCAAqC,CAAC;AAClL;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,MAAM;EACN,mBAAmB;EACnB,UAAU;EACV,wBAAwB;EACxB,yFAAyF;EAEzF,wBAAwB;EAExB,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA,eAAe,eAAe,CAAC;AAC/B,gBAAgB,gBAAgB,CAAC;AACjC;;;;;GAKG;;AAEH,oBAAoB,kBAAkB,CAAC,MAAM,CAAC,KAAK,CAAC;;AAEpD;EACE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;AACA;AACA,sBAAsB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA,cAAc,iBAAiB,CAAC,KAAK,CAAC,MAAM,CAAC,UAAU,CAAC,WAAW,CAAC,eAAe,CAAC,UAAU,CAAC,YAAY,CAAC;AAC5G,SAAS,eAAe,CAAC,UAAU,CAAC,WAAW,CAAC,KAAK,CAAC,MAAM,CAAC,SAAS,CAAC,eAAe,CAAC,WAAW,CAAC;AACnG,cAAc,eAAe,CAAC,UAAU,CAAC,WAAW,CAAC,KAAK,CAAC,MAAM,CAAC,cAAc,CAAC,eAAe,CAAC,WAAW,CAAC;AAC7G;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,8BAA8B;EAC9B,wDAAwD;AAC1D;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;AACA;;GAEG;AACH;EACE,eAAe;AACjB;;AAEA,WAAW,cAAc;;AAEzB,mBAAmB,cAAc;AACjC,oBAAoB,cAAc;AAClC,kBAAkB,cAAc;;AAEhC,mBAAmB,cAAc;AACjC,oBAAoB,cAAc;AAClC,kBAAkB,cAAc;;AAEhC,qBAAqB,cAAc;AACnC,sBAAsB,cAAc;AACpC,oBAAoB,cAAc;;AAElC,gBAAgB,cAAc;AAC9B,iBAAiB,cAAc;AAC/B,eAAe,cAAc;;AAE7B,mBAAmB,cAAc;AACjC,oBAAoB,cAAc;AAClC,kBAAkB,cAAc;;AAEhC,gBAAgB,cAAc;AAC9B,iBAAiB,cAAc;AAC/B,eAAe,cAAc;;AAE7B,gBAAgB,cAAc;AAC9B,iBAAiB,cAAc;AAC/B,eAAe,cAAc;;AAE7B,kBAAkB,cAAc;AAChC,mBAAmB,cAAc;AACjC,iBAAiB,yBAAyB;AAC1C,iBAAiB,aAAa;AAC9B,YAAY,gBAAgB;AAC5B,gBAAgB,UAAU;AAC1B,aAAa,qDAAqD,CAAC,4BAA4B,CAAC;;;;AAIhG,UAAU,kBAAkB,CAAC,2BAA2B,CAAC;AACzD,qBAAqB,cAAc,CAAC;AACpC,eAAe,wBAAwB,CAAC,gBAAgB,CAAC,iBAAiB;AAC1E;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,6BAA6B;EAC7B,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA,OAAO,yBAAyB,CAAC;AACjC,SAAS,yBAAyB,CAAC;AACnC,UAAU,yBAAyB,CAAC;AACpC,wBAAwB,cAAc,CAAC,WAAW,CAAC,YAAY,CAAC,WAAW,CAAC;AAC5E,uBAAuB,WAAW,CAAC,gBAAgB,CAAC,iBAAiB;EACnE,+FAA+F;EAC/F,qIAAqI;;AAEvI;AACA,QAAQ,eAAe,CAAC;AACxB,eAAe,kBAAkB,CAAC,OAAO,CAAC,KAAK,CAAC;AAChD,UAAU,WAAW,CAAC,WAAW,CAAC,sBAAsB,CAAC,sBAAsB;EAC7E,8FAA8F;EAC9F,+FAA+F;EAC/F,qIAAqI;EACrI,2DAA2D;EAC3D,sBAAsB;EACtB,4BAA4B;AAC9B;AACA,oBAAoB,yBAAyB,CAAC,aAAa,CAAC,cAAc,CAAC,YAAY,CAAC;AACxF,eAAe,WAAW,CAAC,eAAe,CAAC,eAAe,CAAC,iBAAiB,EAAE,UAAU,CAAC,cAAc,CAAC;AACxG,mBAAmB,UAAU,CAAC;AAC9B,eAAe,yBAAyB,EAAE,2BAA2B,CAAC,QAAQ,CAAC,eAAe,CAAC;AAC/F,cAAc,yBAAyB,EAAE,2BAA2B,CAAC,QAAQ,CAAC,eAAe,CAAC;AAC9F,gBAAgB,YAAY,CAAC,cAAc,CAAC;AAC5C,uBAAuB,iBAAiB,CAAC,cAAc,EAAE,iBAAiB,CAAC;AAC3E,YAAY,iBAAiB,CAAC,UAAU,CAAC;AACzC,eAAe,iBAAiB,CAAC,UAAU,CAAC;AAC5C,mBAAmB,sBAAsB,CAAC;AAC1C,mBAAmB,iBAAiB,CAAC;AACrC,YAAY,iBAAiB,CAAC,WAAW,CAAC,gBAAgB;EACxD,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,iBAAiB,CAAC;;AAEpB;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;AACA,UAAU,eAAe,CAAC,WAAW,CAAC,eAAe,CAAC,iBAAiB,CAAC;AACxE,YAAY,eAAe,CAAC,eAAe,CAAC,eAAe,CAAC,iBAAiB,CAAC,mBAAmB,CAAC;AAClG,SAAS,iBAAiB,CAAC,UAAU,CAAC,WAAW,CAAC,UAAU,CAAC,eAAe,CAAC;AAC7E,YAAY,aAAa,CAAC,cAAc,CAAC;AACzC,SAAS,iBAAiB,CAAC,aAAa,EAAE,UAAU,CAAC;AACrD,SAAS,iBAAiB,CAAC,aAAa,EAAE,SAAS,CAAC;AACpD;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA,SAAS,wBAAwB,CAAC;AAClC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA,IAAI,gBAAgB,CAAC,iBAAiB,CAAC;AACvC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,OAAO;EACP,wBAAwB;EACxB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,QAAQ;EACR,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;;AAEA;CACC,UAAU;CACV,wBAAwB;EACvB,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;AAC/B;AACA,sBAAsB,qBAAqB,CAAC;AAC5C,sBAAsB,qBAAqB,CAAC;AAC5C,sBAAsB,qBAAqB,CAAC;AAC5C;EACE,kBAAkB;AACpB;AACA,MAAM,cAAc,CAAC,eAAe,CAAC,UAAU,CAAC;AAChD,WAAW,gBAAgB,CAAC;AAC5B,aAAa,iBAAiB,CAAC,MAAM,CAAC,KAAK,CAAC;;AAE5C,UAAU,iBAAiB,CAAC,QAAQ,CAAC,MAAM,CAAC;AAC5C;IACI,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,mBAAmB;IACnB,iFAAiF;IACjF,YAAY;IACZ,0CAA0C;IAC1C,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,0BAA0B;EAC5B;;AAEF;IACI,0CAA0C;IAC1C,+EAA+E;IAC/E,UAAU;EACZ;;AAEF;IACI,wCAAwC;IACxC,UAAU;EACZ;AACF;EACE,mBAAmB;IACjB,cAAc;IACd,0DAA0D;IAC1D,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,QAAQ;EACR,gCAAgC;EAChC,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,8FAA8F;EAC9F,qIAAqI;EACrI,qBAAqB;EACrB,gBAAgB;AAClB;AACA,iBAAiB,YAAY,CAAC,0BAA0B,CAAC,WAAW,CAAC;AACrE;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;IAChB,UAAU;IACV,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;AACrB;AACA,cAAc,kBAAkB,CAAC,OAAO,CAAC,QAAQ,CAAC,UAAU,CAAC,YAAY,CAAC,eAAe,CAAC,SAAS,CAAC,SAAS;AAC7G,WAAW,kBAAkB,CAAC,OAAO,CAAC,QAAQ,CAAC,SAAS;AACxD,eAAe,WAAW,CAAC;;;;AAI3B,0DAA0D;AAC1D;EACE,YAAY,yBAAyB,CAAC;AACxC;AACA,0DAA0D;AAC1D;EACE,YAAY,yBAAyB,CAAC;AACxC;;AAEA,0DAA0D;AAC1D;EACE,YAAY,yBAAyB,CAAC;AACxC;;AAEA,0DAA0D;AAC1D;EACE,YAAY,yBAAyB,CAAC;AACxC;;AAEA,yDAAyD;AACzD;EACE,YAAY,yBAAyB,CAAC;AACxC;;AAEA,yDAAyD;AACzD;EACE,YAAY,yBAAyB,CAAC;AACxC;;AAEA,yDAAyD;AACzD;EACE,YAAY,yBAAyB,CAAC;AACxC;;AAEA,wCAAwC;AACxC;;EAEE;IACE,sDAAsD;IACtD;MACE,sBAAsB;IACxB;IACA,UAAU,WAAW,CAAC;IACtB,KAAK,cAAc,CAAC;IACpB,KAAK,cAAc,CAAC;EACtB;;AAEF;;;AAGA,wCAAwC;AACxC;EACE,YAAY,yBAAyB,CAAC;;;EAGtC;IACE,sDAAsD;IACtD;MACE,sBAAsB;IACxB;IACA,UAAU,WAAW,CAAC;IACtB,KAAK,cAAc,CAAC;IACpB,KAAK,cAAc,CAAC;EACtB;;AAEF;;;AAGA,wCAAwC;AACxC;EACE,YAAY,yBAAyB,CAAC;;;EAGtC;IACE,sDAAsD;IACtD;MACE,sBAAsB;IACxB;IACA,UAAU,WAAW,CAAC;IACtB,KAAK,cAAc,CAAC;IACpB,KAAK,cAAc,CAAC;EACtB;;AAEF;;;AAGA,wCAAwC;AACxC;EACE,YAAY,wBAAwB,CAAC;EACrC,KAAK,cAAc,CAAC;EACpB,KAAK,cAAc,CAAC;AACtB;;;AAGA,wCAAwC;AACxC;;AAEA;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,UAAU;AACZ;AACA,UAAU,kBAAkB;AAC5B,SAAS,kBAAkB;AAC3B,eAAe,kBAAkB,CAAC,UAAU,CAAC,QAAQ,CAAC,WAAW,CAAC;AAClE,gBAAgB,kBAAkB,CAAC,SAAS,CAAC,QAAQ,CAAC,WAAW,CAAC;;AAElE;EACE,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,6DAA6D;EAC7D,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,qIAAqI;EACrI,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,6DAA6D;EAC7D,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,OAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,gBAAgB;EAChB,QAAQ;EACR,OAAO;EACP,iBAAiB;EACjB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,6DAA6D;EAC7D,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qIAAqI;EACrI,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,6DAA6D;EAC7D,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,OAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,MAAM;EACN,SAAS;EACT,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,SAAS;EACT,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,QAAQ;EACR,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,MAAM;EACN,SAAS;EACT,2DAA2D;AAC7D;;AAEA;EACE,SAAS;EACT,SAAS;EACT,0DAA0D;AAC5D;;AAEA;EACE,QAAQ;EACR,QAAQ;EACR,0DAA0D;AAC5D;;AAEA;EACE,QAAQ;EACR,OAAO;EACP,2DAA2D;AAC7D;AACA,mCAAmC,uBAAuB,CAAC;;;AAG3D,2BAA2B;;AAE3B;CACC,aAAa;AACd;AACA;CACC,SAAS;CACT,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,UAAU;CACV,kBAAkB;CAClB,UAAU;AACX;AACA;CACC,SAAS;CACT,UAAU;CACV,SAAS;CACT,UAAU;CACV,gBAAgB;CAChB,qBAAqB;CACrB,eAAe;CACf,gBAAgB;AACjB;AACA;;CAEC,WAAW;CACX,cAAc;CACd,yBAAyB;AAC1B;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;CACX,YAAY;CACZ,MAAM;CACN,OAAO;CACP,kBAAkB;CAClB,UAAU;CACV,8BAA8B,EAAE,iBAAiB;AAClD;;AAEA;CACC,YAAY;AACb;;;AAGA;mCACmC;AACnC;CACC,0BAA0B;CAC1B,oBAAoB;AACrB;;;AAGA;mCACmC;AACnC;CACC,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;CAChB,4BAA4B;AAC7B;;AAEA;CACC,SAAS;CACT,iBAAiB;CACjB,cAAc;AACf;;AAEA;mCACmC;;AAEnC,aAAa;AACb;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;AACb;AACA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,iBAAiB;CACjB,4BAA4B;CAC5B,eAAe;AAChB;AACA;CACC,kBAAkB;CAClB,aAAa;CACb,cAAc;AACf;AACA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,eAAe;AAChB;AACA;CACC,gBAAgB;CAChB,UAAU;CACV,SAAS;CACT,cAAc;CACd,UAAU;AACX;AACA;CACC,kBAAkB;AACnB;AACA;CACC,SAAS;CACT,eAAe;CACf,6BAA6B;CAC7B,0DAAuG;AACxG;AACA;CACC,kBAAkB;CAClB,yBAAyB;AAC1B;AACA;CACC,aAAa;CACb,SAAS;CACT,YAAY;CACZ,cAAc;CACd,uBAAuB;AACxB;AACA;;CAEC,YAAY;AACb;;AAEA,iBAAiB;AACjB;CACC,kBAAkB;AACnB;AACA;CACC,iBAAiB;AAClB;;AAEA,iBAAiB;AACjB;CACC,kBAAkB;CAClB,MAAM;CACN,SAAS;CACT,UAAU;CACV,cAAc;AACf;;AAEA,kBAAkB;AAClB;CACC,UAAU;CACV,QAAQ;AACT;AACA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf,sBAAsB;CACtB,kBAAkB;CAClB,yBAAyB;CAGzB,iBAAiB;;CAEjB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;;;;;CAKC,qBAAqB;AACtB;;AAEA,4DAA4D;AAC5D;CACC,UAAU;CACV,sBAAsB;CACtB,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA,uCAAuC;AACvC;CACC,cAAc;AACf;;AAEA,2BAA2B;AAC3B;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,aAAa;CACb,oBAAoB;CACpB,mBAAmB;;AAEpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;CACd,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA,gBAAgB;AAChB,4BAA4B;AAC5B;;CAEC,SAAS;CACT,UAAU;AACX;AACA;CACC,sBAAsB;CACtB,qBAAqB;AACtB;AACA;CACC,WAAW;CACX,cAAc;CACd,eAAe;AAChB;AACA;;CAEC,aAAa;AACd;AACA;CACC,cAAc;CACd,WAAW;CACX,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,cAAc;AACf;AACA;CACC,iBAAiB;AAClB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;;AAEA,iCAAiC;AACjC;;CAEC,0CAA0C;CAC1C,UAAU;CACV,2BAA2B;AAC5B;AACA;CACC,uBAAuB;AACxB;;AAEA;CACC,kCAAkC;CAClC,oBAAoB;CACpB,YAAY;AACb;AACA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,iBAAiB;CACjB,YAAY;AACb;AACA;;CAEC,sBAAsB;CACtB,UAAU;CACV,WAAW;CACX,iBAAiB;CACjB,mBAAmB;AACpB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,WAAW;CACX,oBAAoB;CACpB,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,eAAe;AAChB;AACA;;CAEC,kBAAkB;CAClB,QAAQ;CACR,YAAY;CACZ,aAAa;AACd;AACA;;CAEC,QAAQ;AACT;AACA;CACC,SAAS;AACV;AACA;CACC,UAAU;AACX;AACA;CACC,SAAS;AACV;AACA;CACC,UAAU;AACX;AACA;;CAEC,cAAc;CACd,kBAAkB;CAClB,SAAS;CACT,iBAAiB;CACjB,QAAQ;CACR,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,kBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,cAAc;CACd,aAAa;AACd;AACA;;CAEC,UAAU;AACX;AACA;CACC,WAAW;CACX,eAAe;CACf,yBAAyB;CACzB,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,SAAS;AACV;AACA;CACC,SAAS;CACT,YAAY;AACb;AACA;;CAEC,cAAc;CACd,aAAa;CACb,iBAAiB;CACjB,qBAAqB;AACtB;AACA;CACC,sBAAsB;CACtB,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,YAAY;CACZ,sBAAsB;CACtB,eAAe;CACf,4BAA4B;CAC5B,WAAW;CACX,iBAAiB;AAClB;AACA;CACC,WAAW;AACZ;;AAEA,4BAA4B;AAC5B;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,UAAU;CACV,mBAAmB;AACpB;AACA;CACC,UAAU;AACX;AACA;CACC,YAAY;AACb;AACA;CACC,UAAU;AACX;AACA;;CAEC,oBAAoB;AACrB;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;CACX,WAAW;CACX,YAAY;AACb;;AAEA,gBAAgB;AAChB;CACC,cAAc;AACf;AACA;CACC,UAAU;CACV,UAAU;AACX;AACA;CACC,SAAS;CACT,WAAW;AACZ;AACA;CACC,UAAU;CACV,UAAU;AACX;AACA;CACC,SAAS;CACT,WAAW;AACZ;AACA;CACC,YAAY;AACb;AACA;CACC,WAAW;AACZ;AACA;;CAEC,YAAY;AACb;AACA;;CAEC,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA,UAAU;AACV;CACC,cAAc;CACd,qBAAqB;CACrB,gBAAgB;CAChB,4BAA4B;CAC5B,UAAU;CACV,SAAS;AACV;AACA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,aAAa;CACb,UAAU;AACX;AACA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,cAAc;CACd,mBAAmB;CACnB,UAAU;CACV,gBAAgB;CAChB,uBAAuB;AACxB;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,WAAW;CACX,mBAAmB;CACnB,YAAY;CACZ,YAAY;AACb;AACA;CACC,kBAAkB;CAClB,SAAS;CACT,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;AACA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,sBAAsB;CACtB,gBAAgB;CAChB,2BAA2B;AAC5B;AACA;CACC,YAAY;AACb;AACA;CACC,wBAAwB;CACxB,eAAe;AAChB;AACA;CACC,WAAW;CACX,MAAM;AACP;AACA;CACC,UAAU;CACV,QAAQ;AACT;AACA;CACC,WAAW;CACX,SAAS;AACV;AACA;CACC,UAAU;CACV,OAAO;AACR;AACA;;;;CAIC,UAAU;CACV,WAAW;AACZ;AACA;CACC,QAAQ;CACR,SAAS;AACV;AACA;CACC,OAAO;CACP,SAAS;AACV;AACA;CACC,QAAQ;CACR,MAAM;AACP;AACA;CACC,OAAO;CACP,MAAM;AACP;AACA;CACC,YAAY;AACb;AACA;CAEC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;CAEd,kBAAkB;AACnB;AACA;;CAEC,aAAa;AACd;AACA;CACC,gBAAgB;CAChB,WAAW;CACX,WAAW;CACX,SAAS;CACT,OAAO;AACR;AACA;CACC,gBAAgB;CAChB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,OAAO;AACR;AACA;CACC,gBAAgB;CAChB,UAAU;CACV,WAAW;CACX,MAAM;CACN,YAAY;AACb;AACA;CACC,gBAAgB;CAChB,UAAU;CACV,UAAU;CACV,MAAM;CACN,YAAY;AACb;AACA;CACC,iBAAiB;CACjB,WAAW;CACX,YAAY;CACZ,UAAU;CACV,WAAW;AACZ;AACA;CACC,iBAAiB;CACjB,UAAU;CACV,WAAW;CACX,UAAU;CACV,YAAY;AACb;AACA;CACC,iBAAiB;CACjB,UAAU;CACV,WAAW;CACX,UAAU;CACV,SAAS;AACV;AACA;CACC,iBAAiB;CACjB,UAAU;CACV,WAAW;CACX,WAAW;CACX,SAAS;AACV;AACA;CACC,WAAW;CACX,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,YAAY;CACZ,YAAY;AACb;AACA;CACC,oDAAyzE;CACzzE,YAAY;CACZ,+BAA+B,EAAE,iBAAiB;CAClD,aAAa;AACd;AACA;CACC,sBAAsB;AACvB;AACA;CAEC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,YAAY;CACZ,wBAAwB;AACzB;AACA;CACC,UAAU;CACV,SAAS;CACT,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,aAAa;AACd;AACA;CACC,cAAc;CACd,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,cAAc;CACd,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,YAAY;CACZ,SAAS;AACV;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,uBAAuB;AACxB;AACA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,WAAW;AACZ;AACA;CACC,YAAY;CACZ,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,aAAa;CACb,eAAe;CAEf,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,eAAe;CACf,cAAc;CACd,SAAS;CACT,wBAAwB;AACzB;;AAEA,6BAA6B;AAC7B;;CAEC,eAAe;AAChB;;AAEA;CACC,YAAY;AACb;AACA;CACC,UAAU;CACV,kBAAkB;AACnB;AACA;CACC,MAAM;CACN,YAAY;AACb;AACA;CACC,OAAO;AACR;AACA;CACC,QAAQ;AACT;;AAEA;CACC,WAAW;CACX,aAAa;AACd;AACA;CACC,WAAW;CACX,cAAc;CACd,oBAAoB;AACrB;AACA;CACC,OAAO;CACP,WAAW;AACZ;AACA;CACC,SAAS;AACV;AACA;CACC,MAAM;AACP;AACA;CAEC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;CAChB,UAAU;CACV,sBAAsB;AACvB;AACA;CACC,YAAY;CACZ,gBAAgB;CAChB,cAAc;CACd,iBAAiB;CACjB,cAAc;CACd,sBAAsB;CACtB,iBAAiB;CACjB,iBAAiB;AAClB;AACA;CACC,YAAY;CACZ,WAAW;CACX,eAAe;CACf,UAAU;CACV,SAAS;CACT,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,QAAQ;AACT;AACA,+DAA+D;AAC/D;CACC,sBAAsB;CACtB,yBAAyB;CACzB,wBAAwB;AACzB;AACA;CACC,MAAM;AACP;AACA;CACC,SAAS;AACV;AACA;CACC,kBAAkB,CAAC,uIAAuI;CAC1J,aAAa;AACd;AACA;CACC,SAAS;CACT,oBAAoB;AACrB;AACA;CACC,gBAAgB;CAChB,WAAW;CACX,kBAAkB;CAClB,MAAM;CACN,oBAAoB;CACpB,sBAAsB;CACtB,UAAU;CACV,mBAAmB;AACpB;AACA;CACC,WAAW;CACX,iBAAiB;CACjB,qBAAqB;AACtB;AACA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;AACA;;;CAGC,YAAY;AACb;AACA;CACC,eAAe;AAChB;AACA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;AACA;mCACmC;AACnC;CACC,uCAAuC;CACvC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;;;;CAIC,uCAAuC;CACvC,cAAc;AACf;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,cAAc;CACd,iBAAiB;AAClB;AACA;CACC,cAAc;AACf;;AAEA;mCACmC;AACnC;;;;;;;;;CASC,yBAAyB;CACzB,mBAAmB;CACnB,mBAAmB;CACnB,cAAc;AACf;AACA;;;;;;;CAOC,cAAc;CACd,qBAAqB;AACtB;AACA;;;;;;;;CAQC,yBAAyB;CACzB,mBAAmB;CACnB,mBAAmB;CACnB,cAAc;AACf;AACA;;;;;;;;;;CAUC,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,yCAAyC;AAC1C;AACA;;;;;;CAMC,yBAAyB;CACzB,mBAAmB;CACnB,mBAAmB;CACnB,cAAc;AACf;AACA;;CAEC,eAAe;CACf,yBAAyB;AAC1B;AACA;;;CAGC,cAAc;CACd,qBAAqB;AACtB;;AAEA;mCACmC;AACnC;;;CAGC,yBAAyB;CACzB,mBAAmB;CACnB,cAAc;AACf;AACA;CACC,yBAAyB;CACzB,mBAAmB;AACpB;AACA;;;CAGC,cAAc;AACf;AACA;;;CAGC,yBAAyB;CACzB,mBAAmB;CACnB,cAAc;AACf;AACA;;;CAGC,cAAc;AACf;AACA;;;CAGC,cAAc;AACf;AACA;;;CAGC,iBAAiB;AAClB;AACA;;;CAGC,WAAW;CACX,+BAA+B,EAAE,iBAAiB;CAClD,mBAAmB;AACpB;AACA;;;CAGC,YAAY;CACZ,+BAA+B,EAAE,iBAAiB;CAClD,sBAAsB;AACvB;AACA;CACC,+BAA+B,EAAE,6BAA6B;AAC/D;;AAEA;mCACmC;;AAEnC,sBAAsB;AACtB;CACC,WAAW;CACX,YAAY;AACb;AACA;;CAEC,0DAA8D;AAC/D;AACA;CACC,0DAA8D;AAC/D;AACA;;;;CAIC,0DAA8D;AAC/D;AACA;;CAEC,0DAA8D;AAC/D;AACA;;CAEC,0DAA8D;AAC/D;AACA;;CAEC,0DAA8D;AAC/D;AACA;CACC,0DAA8D;AAC/D;;AAEA,gBAAgB;AAChB,iEAAiE;AACjE;CACC,sBAAsB;AACvB;AACA,qBAAqB,wBAAwB,EAAE;AAC/C,sBAAsB,4BAA4B,EAAE;AACpD,qBAAqB,4BAA4B,EAAE;AACnD,sBAAsB,4BAA4B,EAAE;AACpD,qBAAqB,4BAA4B,EAAE;AACnD,sBAAsB,4BAA4B,EAAE;AACpD,qBAAqB,4BAA4B,EAAE;AACnD,sBAAsB,6BAA6B,EAAE;AACrD,uBAAuB,6BAA6B,EAAE;AACtD,uBAAuB,6BAA6B,EAAE;AACtD,wBAAwB,4BAA4B,EAAE;AACtD,yBAAyB,gCAAgC,EAAE;AAC3D,wBAAwB,gCAAgC,EAAE;AAC1D,yBAAyB,gCAAgC,EAAE;AAC3D,wBAAwB,gCAAgC,EAAE;AAC1D,yBAAyB,gCAAgC,EAAE;AAC3D,wBAAwB,gCAAgC,EAAE;AAC1D,yBAAyB,iCAAiC,EAAE;AAC5D,0BAA0B,iCAAiC,EAAE;AAC7D,0BAA0B,iCAAiC,EAAE;AAC7D,qBAAqB,4BAA4B,EAAE;AACnD,sBAAsB,gCAAgC,EAAE;AACxD,qBAAqB,gCAAgC,EAAE;AACvD,sBAAsB,gCAAgC,EAAE;AACxD,qBAAqB,gCAAgC,EAAE;AACvD,sBAAsB,gCAAgC,EAAE;AACxD,qBAAqB,gCAAgC,EAAE;AACvD,sBAAsB,iCAAiC,EAAE;AACzD,uBAAuB,iCAAiC,EAAE;AAC1D,yBAAyB,iCAAiC,EAAE;AAC5D,uBAAuB,iCAAiC,EAAE;AAC1D,yBAAyB,iCAAiC,EAAE;AAC5D,yBAAyB,iCAAiC,EAAE;AAC5D,yBAAyB,iCAAiC,EAAE;AAC5D,yBAAyB,iCAAiC,EAAE;AAC5D,yBAAyB,iCAAiC,EAAE;AAC5D,0BAA0B,8BAA8B,EAAE;AAC1D,2BAA2B,gCAAgC,EAAE;AAC7D,0BAA0B,gCAAgC,EAAE;AAC5D,2BAA2B,gCAAgC,EAAE;AAC7D,0BAA0B,gCAAgC,EAAE;AAC5D,2BAA2B,gCAAgC,EAAE;AAC7D,0BAA0B,gCAAgC,EAAE;AAC5D,2BAA2B,iCAAiC,EAAE;AAC9D,4BAA4B,iCAAiC,EAAE;AAC/D,8BAA8B,iCAAiC,EAAE;AACjE,4BAA4B,iCAAiC,EAAE;AAC/D,8BAA8B,iCAAiC,EAAE;AACjE,8BAA8B,iCAAiC,EAAE;AACjE,8BAA8B,iCAAiC,EAAE;AACjE,8BAA8B,iCAAiC,EAAE;AACjE,8BAA8B,iCAAiC,EAAE;AACjE,gCAAgC,4BAA4B,EAAE;AAC9D,gCAAgC,gCAAgC,EAAE;AAClE,gCAAgC,gCAAgC,EAAE;AAClE,gCAAgC,gCAAgC,EAAE;AAClE,2BAA2B,gCAAgC,EAAE;AAC7D,2BAA2B,gCAAgC,EAAE;AAC7D,2BAA2B,gCAAgC,EAAE;AAC7D,2BAA2B,iCAAiC,EAAE;AAC9D,4BAA4B,iCAAiC,EAAE;AAC/D,4BAA4B,iCAAiC,EAAE;AAC/D,4BAA4B,iCAAiC,EAAE;AAC/D,4BAA4B,iCAAiC,EAAE;AAC/D,mBAAmB,4BAA4B,EAAE;AACjD,wBAAwB,gCAAgC,EAAE;AAC1D,mBAAmB,gCAAgC,EAAE;AACrD,kBAAkB,gCAAgC,EAAE;AACpD,mBAAmB,gCAAgC,EAAE;AACrD,mBAAmB,gCAAgC,EAAE;AACrD,wBAAwB,gCAAgC,EAAE;AAC1D,6BAA6B,iCAAiC,EAAE;AAChE,4BAA4B,4BAA4B,EAAE;AAC1D,uBAAuB,gCAAgC,EAAE;AACzD,oBAAoB,gCAAgC,EAAE;AACtD,sBAAsB,gCAAgC,EAAE;AACxD,gBAAgB,gCAAgC,EAAE;AAClD,uBAAuB,gCAAgC,EAAE;AACzD,qBAAqB,gCAAgC,EAAE;AACvD,oBAAoB,iCAAiC,EAAE;AACvD,mBAAmB,iCAAiC,EAAE;AACtD,kBAAkB,iCAAiC,EAAE;AACrD,iBAAiB,iCAAiC,EAAE;AACpD,iBAAiB,iCAAiC,EAAE;AACpD,kBAAkB,iCAAiC,EAAE;AACrD,oBAAoB,iCAAiC,EAAE;AACvD,oBAAoB,iCAAiC,EAAE;AACvD,eAAe,iCAAiC,EAAE;AAClD,gBAAgB,6BAA6B,EAAE;AAC/C,gBAAgB,iCAAiC,EAAE;AACnD,oBAAoB,iCAAiC,EAAE;AACvD,gBAAgB,iCAAiC,EAAE;AACnD,kBAAkB,iCAAiC,EAAE;AACrD,iBAAiB,iCAAiC,EAAE;AACpD,gBAAgB,iCAAiC,EAAE;AACnD,sBAAsB,kCAAkC,EAAE;AAC1D,kBAAkB,kCAAkC,EAAE;AACtD,mBAAmB,kCAAkC,EAAE;AACvD,kBAAkB,kCAAkC,EAAE;AACtD,kBAAkB,kCAAkC,EAAE;AACtD,gBAAgB,kCAAkC,EAAE;AACpD,iBAAiB,kCAAkC,EAAE;AACrD,gBAAgB,kCAAkC,EAAE;AACpD,gBAAgB,kCAAkC,EAAE;AACpD,kBAAkB,6BAA6B,EAAE;AACjD,gBAAgB,iCAAiC,EAAE;AACnD,qBAAqB,iCAAiC,EAAE;AACxD,iBAAiB,iCAAiC,EAAE;AACpD,sBAAsB,iCAAiC,EAAE;AACzD,iBAAiB,iCAAiC,EAAE;AACpD,sBAAsB,iCAAiC,EAAE;AACzD,eAAe,kCAAkC,EAAE;AACnD,qBAAqB,kCAAkC,EAAE;AACzD,oBAAoB,kCAAkC,EAAE;AACxD,qBAAqB,kCAAkC,EAAE;AACzD,gBAAgB,kCAAkC,EAAE;AACpD,mBAAmB,kCAAkC,EAAE;AACvD,iBAAiB,kCAAkC,EAAE;AACrD,iBAAiB,kCAAkC,EAAE;AACrD,kBAAkB,kCAAkC,EAAE;AACtD,iBAAiB,6BAA6B,EAAE;AAChD,gBAAgB,iCAAiC,EAAE;AACnD,kBAAkB,iCAAiC,EAAE;AACrD,gBAAgB,iCAAiC,EAAE;AACnD,iBAAiB,iCAAiC,EAAE;AACpD,kBAAkB,iCAAiC,EAAE;AACrD,oBAAoB,iCAAiC,EAAE;AACvD,qBAAqB,kCAAkC,EAAE;AACzD,iBAAiB,kCAAkC,EAAE;AACrD,iBAAiB,kCAAkC,EAAE;AACrD,gBAAgB,6BAA6B,EAAE;AAC/C,iBAAiB,iCAAiC,EAAE;AACpD,qBAAqB,iCAAiC,EAAE;AACxD,qBAAqB,iCAAiC,EAAE;AACxD,oBAAoB,iCAAiC,EAAE;AACvD,sBAAsB,iCAAiC,EAAE;AACzD,qEAAqE;AACrE,sBAAsB,iCAAiC,EAAE;AACzD,gBAAgB,iCAAiC,EAAE;AACnD,iBAAiB,kCAAkC,EAAE;AACrD,sBAAsB,kCAAkC,EAAE;AAC1D,qBAAqB,kCAAkC,EAAE;AACzD,iBAAiB,6BAA6B,EAAE;AAChD,uBAAuB,iCAAiC,EAAE;AAC1D,kBAAkB,iCAAiC,EAAE;AACrD,qBAAqB,iCAAiC,EAAE;AACxD,qBAAqB,iCAAiC,EAAE;AACxD,qBAAqB,iCAAiC,EAAE;AACxD,qBAAqB,iCAAiC,EAAE;AACxD,uBAAuB,6BAA6B,EAAE;AACtD,wBAAwB,iCAAiC,EAAE;AAC3D,wBAAwB,iCAAiC,EAAE;AAC3D,6BAA6B,iCAAiC,EAAE;AAChE,6BAA6B,iCAAiC,EAAE;AAChE,6BAA6B,iCAAiC,EAAE;AAChE,6BAA6B,iCAAiC,EAAE;AAChE,0BAA0B,kCAAkC,EAAE;AAC9D,0BAA0B,kCAAkC,EAAE;AAC9D,0BAA0B,kCAAkC,EAAE;AAC9D,0BAA0B,kCAAkC,EAAE;AAC9D,yBAAyB,kCAAkC,EAAE;AAC7D,0BAA0B,kCAAkC,EAAE;AAC9D,wBAAwB,kCAAkC,EAAE;AAC5D,4BAA4B,6BAA6B,EAAE;AAC3D,6BAA6B,iCAAiC,EAAE;AAChE,6BAA6B,iCAAiC,EAAE;AAChE,4BAA4B,iCAAiC,EAAE;AAC/D,6BAA6B,iCAAiC,EAAE;AAChE,6BAA6B,iCAAiC,EAAE;AAChE,gCAAgC,6BAA6B,EAAE;AAC/D,kCAAkC,iCAAiC,EAAE;AACrE,+BAA+B,iCAAiC,EAAE;AAClE,iCAAiC,iCAAiC,EAAE;AACpE,iCAAiC,iCAAiC,EAAE;AACpE,4BAA4B,iCAAiC,EAAE;;;AAG/D;mCACmC;;AAEnC,kBAAkB;AAClB;;;;CAIC,2BAA2B;AAC5B;AACA;;;;CAIC,4BAA4B;AAC7B;AACA;;;;CAIC,8BAA8B;AAC/B;AACA;;;;CAIC,+BAA+B;AAChC;;AAEA,aAAa;AACb;CACC,mBAAmB;CACnB,WAAW;CACX,6BAA6B,EAAE,iBAAiB;AACjD;AACA;CAEC,+BAA+B;AAChC;;AAEA,yBAAyB;;AAEzB,YAAY,kBAAkB;EAC5B,YAAY;EACZ,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,wCAAwC,EAAE,+CAA+C;AAC3F;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE;AACF;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,yBAAyB;EACzB,sBAAsB;EACtB,4CAA4C;EAC5C,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd;AACF;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd;AACF;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,6BAA6B,EAAE,+BAA+B;EAC9D,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,YAAY,EAAE,uBAAuB;AACvC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB,EAAE,uBAAuB;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,mCAAmC,EAAE,mCAAmC;EACxE,qDAAqD;AACvD;AACA;EACE,0BAA0B,EAAE,iCAAiC;AAC/D;AACA;EACE,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,UAAU,EAAE,iDAAiD;AAC/D;AACA;AACA,kBAAkB;AAClB,WAAW;AACX,mBAAmB;AACnB,eAAe;AACf;AACA;AACA;AACA;AACA;EACE;AACF;AACA;EACE;AACF;AACA;EACE;AACF;AACA;EACE;AACF;AACA;EACE;AACF;AACA;EACE,mCAAmC;AACrC;AACA;EACE,YAAY;AACd;AACA;EACE,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU,EAAE,kCAAkC;EAC9C,UAAU,EAAE,oCAAoC;EAChD,eAAe;AACjB;;;AAGA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,SAAS;;EAET,UAAU,EAAE,uDAAuD;EACnE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU,EAAE,uDAAuD;EACnE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;;AAEA,gCAAgC;AAChC;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,4BAA4B,EAAE,0CAA0C;EACxE,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA,gDAAgD;AAChD;EACE,OAAO;EACP,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,YAAY;EACZ,6BAA6B,EAAE,0CAA0C;EACzE,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE;EACF;EACA;IACE;EACF;EACA;IACE;EACF;EACA;IACE;EACF;EACA;IACE;EACF;EACA;IACE;EACF;EACA;IACE;EACF;EACA;IACE;EACF;EACA;IACE;EACF;EACA;IACE;EACF;EACA;IACE;EACF;EACA;IACE;EACF;EACA;IACE;EACF;EACA;IACE;EACF;EACA;IACE;EACF;EACA;IACE;EACF;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,wDAAwD;EACxD,sCAAsC;AACxC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;AACF;AACA;EACE,YAAY;EACZ,eAAe;EACf,MAAM;AACR;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,MAAM;EACN,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,4CAA4C;EAClF,cAAc,EAAE,kDAAkD;AACpE;AACA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yEAAyE;EACzE,KAAK,eAAe,CAAC;EACrB,KAAK,eAAe,CAAC;EACrB,KAAK,eAAe,CAAC;EACrB,KAAK,eAAe,CAAC;EACrB,KAAK,eAAe,CAAC;EACrB,KAAK,eAAe,CAAC;EACrB,KAAK,eAAe,CAAC;EACrB;IACE,4BAA4B;IAC5B,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,cAAc,EAAE,uBAAuB;AACzC;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;AACA,kBAAkB;AAClB,aAAa;AACb;AACA;EACE,kBAAkB;EAClB,oCAAoC,EAAE,mCAAmC;EACzE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAE,4DAA4D;AAC7E;AACA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["@font-face {\n    font-family: \"Roboto-Thin\";\n    src: url(\"../fonts/Roboto/Roboto-Thin.ttf\");\n}\n@font-face {\n    font-family: \"Roboto-ThinItalic\";\n    src: url(\"../fonts/Roboto/Roboto-ThinItalic.ttf\");\n}\n@font-face {\n    font-family: \"Roboto-Black\";\n    src: url(\"../fonts/Roboto/Roboto-Black.ttf\");\n}\n@font-face {\n    font-family: \"Roboto-BlackItalic\";\n    src: url(\"../fonts/Roboto/Roboto-BlackItalic.ttf\");\n}\n@font-face {\n    font-family: \"Roboto-Bold\";\n    src: url(\"../fonts/Roboto/Roboto-Bold.ttf\");\n}\n@font-face {\n    font-family: \"Roboto-BoldItalic\";\n    src: url(\"../fonts/Roboto/Roboto-BoldItalic.ttf\");\n}\n@font-face {\n    font-family: \"Roboto-Italic\";\n    src: url(\"../fonts/Roboto/Roboto-Italic.ttf\");\n}\n@font-face {\n    font-family: \"Roboto-Light\";\n    src: url(\"../fonts/Roboto/Roboto-Light.ttf\");\n}\n@font-face {\n    font-family: \"Roboto-LightItalic\";\n    src: url(\"../fonts/Roboto/Roboto-LightItalic.ttf\");\n}\n@font-face {\n    font-family: \"Roboto-Medium\";\n    src: url(\"../fonts/Roboto/Roboto-Medium.ttf\");\n}\n@font-face {\n    font-family: \"Roboto-MediumItalic\";\n    src: url(\"../fonts/Roboto/Roboto-MediumItalic.ttf\");\n}\n@font-face {\n    font-family: \"Roboto-Regular\";\n    src: url(\"../fonts/Roboto/Roboto-Regular.ttf\");\n}\n.page-wrapper .page-main-header{height:45px;}\n.page-main-header .main-header-right .nav-right > ul > li {\npadding:12px 0px;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar {\ntop:45px;\nbackground: linear-gradient(#00182e, #000000) !important;\nbox-shadow:0 0 #000;\nheight:calc(100vh - 10px);\n\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu a{color:#fff;}\n.page-wrapper .page-body-wrapper .page-sidebar ~ .page-body{background-color: inherit;}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-header.Active{color:#fff;background: #053d7080;}\n.page-wrapper .page-body-wrapper .page-body{\n    /* background: linear-gradient(#00182e, #000000) !important; */\n    /* background: linear-gradient(#053d70, #000000) !important; */\n}\n\n.input-medium{\n    padding: 0.375rem 0.75rem;\n    font-size: 1rem;\n    line-height: 1.5;\n    color: #495057;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #ced4da;\n    border-radius: 0rem;\n    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n    font-size: 12px;\n}\n/* .form-group label{color:#ffffff;} */\n.fbold{font-family: 'Roboto-Black';}\n.f-600{\n  font-weight: 600;\n}\n.fregular{font-family: 'Roboto-Regular';}\n.fmedium{font-family: 'Roboto-Medium';}\n.fthin{font-family: 'Roboto-Thin';}\n.flight{font-family: 'Roboto-Light';}\n.bg-primary{background-color: #0d6efd;color:#FFFFFF;}\n.bg-secondary{background-color: #6c757d;color:#FFFFFF;}\n.bg-success{background-color: #198754;color:#FFFFFF;}\n.bg-danger{background-color: #dc3545;color:#FFFFFF;}\n.bg-warning{background-color: #ffc107;color:#FFFFFF;}\n.bg-info{background-color: #0dcaf0;color:#FFFFFF;}\n.bg-dark{background-color: #212529;color:#FFFFFF;}\n.bg-default{background-color: #f8f9fa;color:#FFFFFF;}\n.cardBlock{padding:10px;align-items: center;text-align: center;}\n.cardBlock h4{font-family: 'Roboto-Medium';font-size: 30px;padding:15px 0px 0px 0px;}\n.cardBlock h5{font-family: 'Roboto-Regular';font-size: 20px;}\n.ml-16per{margin-left:16%;}\n.float-right {\n    float: right !important;\n}\n.float-left {\n    float: left !important;\n}\n\n.m1{margin:1%;}\n.m2{margin:2%;}\n.m3{margin:3%;}\n.m4{margin:4%;}\n.m5{margin:5%;}\n.m6{margin:6%;}\n.m7{margin:7%;}\n.m8{margin:8%;}\n.m9{margin:9%;}\n.m10{margin:10%;}\n.m15{margin:15%;}\n\n.mt9{margin-top:9%;}\n\n\n.mt-0p{margin-top:0px;}\n.mt-5p{margin-top:5px;}\n.mt-10p{margin-top:10px;}\n.mt-15p{margin-top:15px;}\n.mt-20p{margin-top:20px;}\n.mt-25p{margin-top:25px;}\n.mt-30p{margin-top:30px;}\n.mt-35p{margin-top:35px;}\n.mt-40p{margin-top:40px;}\n.mt-45p{margin-top:45px;}\n.mt-50p{margin-top:50px;}\n.mt-55p{margin-top:55px;}\n.mt-60p{margin-top:60px;}\n.mt-65p{margin-top:65px;}\n.mt-70p{margin-top:70px;}\n.mt-75p{margin-top:75px;}\n.mt-80p{margin-top:80px;}\n.mt-85p{margin-top:85px;}\n.mt-90p{margin-top:90px;}\n.mt-95p{margin-top:95px;}\n.mt-100p{margin-top:100px;}\n\n.mb-0p{margin-bottom:0px;}\n.mb-5p{margin-bottom:5px;}\n.mb-10p{margin-bottom:10px;}\n.mb-15p{margin-bottom:15px;}\n.mb-20p{margin-bottom:20px;}\n.mb-25p{margin-bottom:25px;}\n.mb-30p{margin-bottom:30px;}\n.mb-35p{margin-bottom:35px;}\n.mb-40p{margin-bottom:40px;}\n.mb-45p{margin-bottom:45px;}\n.mb-50p{margin-bottom:50px;}\n.mb-55p{margin-bottom:55px;}\n.mb-60p{margin-bottom:60px;}\n.mb-65p{margin-bottom:65px;}\n.mb-70p{margin-bottom:70px;}\n.mb-75p{margin-bottom:75px;}\n.mb-80p{margin-bottom:80px;}\n.mb-85p{margin-bottom:85px;}\n.mb-90p{margin-bottom:90px;}\n.mb-95p{margin-bottom:95px;}\n.mb-100p{margin-bottom:100px;}\n\n\n.mr-0p{margin-right:0px;}\n.mr-5p{margin-right:5px;}\n.mr-10p{margin-right:10px;}\n.mr-15p{margin-right:15px;}\n.mr-20p{margin-right:20px;}\n.mr-25p{margin-right:25px;}\n.mr-30p{margin-right:30px;}\n.mr-35p{margin-right:35px;}\n.mr-40p{margin-right:40px;}\n.mr-45p{margin-right:45px;}\n.mr-50p{margin-right:50px;}\n.mr-55p{margin-right:55px;}\n.mr-60p{margin-right:60px;}\n.mr-65p{margin-right:65px;}\n.mr-70p{margin-right:70px;}\n.mr-75p{margin-right:75px;}\n.mr-80p{margin-right:80px;}\n.mr-85p{margin-right:85px;}\n.mr-90p{margin-right:90px;}\n.mr-95p{margin-right:95px;}\n.mr-100p{margin-right:100px;}\n\n.ml-0p{margin-left:0px;}\n.ml-5p{margin-left:5px;}\n.ml-10p{margin-left:10px;}\n.ml-15p{margin-left:15px;}\n.ml-20p{margin-left:20px;}\n.ml-25p{margin-left:25px;}\n.ml-30p{margin-left:30px;}\n.ml-35p{margin-left:35px;}\n.ml-40p{margin-left:40px;}\n.ml-45p{margin-left:45px;}\n.ml-50p{margin-left:50px;}\n.ml-55p{margin-left:55px;}\n.ml-60p{margin-left:60px;}\n.ml-65p{margin-left:65px;}\n.ml-70p{margin-left:70px;}\n.ml-75p{margin-left:75px;}\n.ml-80p{margin-left:80px;}\n.ml-85p{margin-left:85px;}\n.ml-90p{margin-left:90px;}\n.ml-95p{margin-left:95px;}\n.ml-100p{margin-left:100px;}\n\n\n.m-0p{margin:0px;}\n.m-5p{margin:5px;}\n.m-10p{margin:10px;}\n.m-15p{margin:15px;}\n.m-20p{margin:20px;}\n.m-25p{margin:25px;}\n.m-30p{margin:30px;}\n.m-35p{margin:35px;}\n.m-40p{margin:40px;}\n.m-45p{margin:45px;}\n.m-50p{margin:50px;}\n.m-55p{margin:55px;}\n.m-60p{margin:60px;}\n.m-65p{margin:65px;}\n.m-70p{margin:70px;}\n.m-75p{margin:75px;}\n.m-80p{margin:80px;}\n.m-85p{margin:85px;}\n.m-90p{margin:90px;}\n.m-95p{margin:95px;}\n.m-100p{margin:100px;}\n.box-shadow15p{box-shadow: 0 0 15px #ccc;}\n.bxs15p{box-shadow: 0 0 15px #000;}\n.f5{font-size: 5px;}\n.f6{font-size: 6px;}\n.f7{font-size: 7px;}\n.f8{font-size: 8px;}\n.f9{font-size: 9px;}\n.f10{font-size: 10px;}\n.f11{font-size: 11px;}\n.f12{font-size: 12px;}\n.f13{font-size: 13px;}\n.f14{font-size: 14px;}\n.f15{font-size: 15px;}\n.f16{font-size: 16px;}\n.f17{font-size: 17px;}\n.f18{font-size: 18px;}\n.f19{font-size: 19px;}\n.f20{font-size: 20px;}\n.f21{font-size: 21px;}\n.f22{font-size: 22px;}\n.f23{font-size: 23px;}\n.f24{font-size: 24px;}\n.f25{font-size: 25px;}\n.f26{font-size: 26px;}\n.f27{font-size: 27px;}\n.f28{font-size: 28px;}\n.f29{font-size: 29px;}\n.f30{font-size: 30px;}\n.f31{font-size: 31px;}\n.f32{font-size: 32px;}\n.f33{font-size: 33px;}\n.f34{font-size: 34px;}\n.f35{font-size: 35px;}\n.f36{font-size: 36px;}\n.f37{font-size: 37px;}\n.f38{font-size: 38px;}\n.f39{font-size: 39px;}\n.f40{font-size: 40px;}\n.f41{font-size: 41px;}\n.f42{font-size: 42px;}\n.f43{font-size: 43px;}\n.f44{font-size: 44px;}\n.f45{font-size: 45px;}\n.f46{font-size: 46px;}\n.f47{font-size: 47px;}\n.f48{font-size: 48px;}\n.f49{font-size: 49px;}\n.f50{font-size: 50px;}\n.f51{font-size: 51px;}\n.f52{font-size: 52px;}\n.f53{font-size: 53px;}\n.f54{font-size: 54px;}\n.f55{font-size: 55px;}\n.f56{font-size: 56px;}\n.f57{font-size: 517px;}\n.f58{font-size: 58px;}\n.f59{font-size: 59px;}\n.f60{font-size: 60px;}\n.p-0p{padding:0px;}\n.p-1p{padding:1px;}\n.p-2p{padding:2px;}\n.p-3p{padding:3px;}\n.p-4p{padding:4px;}\n.p-5p{padding:5px;}\n.p-9p{padding:9px;}\n.p-10p{padding:10px;}\n.p-15p{padding:15px;}\n.p-20p{padding:20px;}\n.p-25p{padding:25px;}\n.p-30p{padding:30px;}\n.pt-10p{padding-top: 10px !important;}\n.pt-15p{padding-top: 15px !important;}\n.pt-20p{padding-top: 20px !important;}\n.pt-25p{padding-top: 25px !important;}\n.pt-30p{padding-top: 30px !important;}\n.pt-35p{padding-top: 35px !important;}\n.pl-35p{padding-left: 35px !important;}\n.pr-35p{padding-right: 35px !important;}\n.pb-35p{padding-bottom: 35px !important;}\n.p-relative{position: relative;}\n.login-right-div{background-color: #d7eef4;}\n.bg-white{background-color: #FFFFFF;}\n.login-bg{height:100vh;padding:30px;}\n.loginbg{\n    background-image: url(\"../images/loginbg.png\");\n    background-repeat: no-repeat;\n    background-size: contain;\n}\n.lgh5P{\n\tcolor: #ffffff;\n    font-size: 31px;\n    /* background: #087474; */\n    background: #030714;\n    padding: 5px 10px;\n}\n.lgform{\n    z-index: 11;\n    position: absolute;\n    left: 6%;\n    top: 18%;\n    width: 50vh;\n    background: #3b8b8f;\n    \n  }\n.imglogo{position:absolute;top:10%;left:13%;}\n.btn-primary {\n    background-color: #035044 !important;\n    border-color: #035044 !important;\n}\n.clrfnt{color:#035044 !important;font-weight:bold;}\n  .loverly{\n\t  position: absolute;\n    top: 15%;\n    left: 0%;\n    width: 100%;\n    height: 54vh;\n    background: #000;\n    opacity: 0.3;\n    z-index: 10;\n  }\n.lgform .col-form-label, .lgform a{color:#ffffff;}\n.lgbg{    position: fixed;\n   top: 0%;\n   left: 0%;\n   z-index: 9;\n   background:linear-gradient(#00182e,#000000)\n}\n.login-form{background-color: #fff;border-radius:50px;}\n.btm-txt{font-size: 12px;text-decoration: none;color:#004bbb;}\n.sidebarcls{\n    width:0px !important;\n}\n.gm-style-iw {\n    padding:0px !important;\n    z-index:9;\n    box-shadow: 10px 0px 45px 0px #333 !important;\n      \n}\n.g-header{background:#fff; color:#333; font-size:20px;font-weight:600; padding:5px;\n    font-family: \"Roboto-Black\";\n}\n.gm-ui-hover-effect{opacity:1 !important; padding:0px !important; top:0px !important; right:0px !important;height:34px !important; }\n.gm-ui-hover-effect img{filter: invert(150%) !important;}\nbutton.gm-ui-hover-effect{outline:none;}\n.gm-style .gm-style-iw-c {\n    position: absolute;\n    box-sizing: border-box;\n    overflow-y: auto;\n    overflow-x: hidden;\n    top: 0;\n    left: 0;\n    height: 14em !important;\n    transform: translate(-50%,-100%);\n    background-color: white;\n    border-radius: 0px !important;\n    padding: 12px;\n    box-shadow: 0 2px 7px 1px rgba(0,0,0,0.3);\n}\n.white{color:#fff;}\n.hwhite{color:#afafaf;}\n.fdeffect{\n    opacity: 1;\n    transition: all 1000ms linear 4s;\n}\n.beffect{\n\topacity: 0;\n\tanimation-name: bounceIn;\n  animation-duration: 450ms;\n  animation-timing-function: linear;\n  animation-fill-mode: forwards;\n}\n.beffect:nth-child(2){animation-delay: 0.3s;}\n.beffect:nth-child(3){animation-delay: 0.6s;}\n.beffect:nth-child(4){animation-delay: 0.9s;}\n\n@keyframes bounceIn{\n    0%{\n      opacity: 0;\n      transform: scale(0.3) translate3d(0,0,0);\n    }\n    50%{\n      opacity: 0.9;\n      transform: scale(1.1);\n    }\n    80%{\n      opacity: 1;\n      transform: scale(0.89);\n    }\n    100%{\n      opacity: 1;\n      transform: scale(1) translate3d(0,0,0);\n    }\n  }\n  \n  .beffectFade{\n      opacity: 0;\n       animation: fadein 0.1s;\n      -moz-animation: fadein 0.1s; /* Firefox */\n      -webkit-animation: fadein 0.1s; /* Safari and Chrome */\n      -o-animation: fadein 0.1s; /* Opera */\n  }\n  @keyframes fadein {\n      from {\n          opacity:0;\n      }\n      to {\n          opacity:1;\n      }\n  }\n  @-moz-keyframes fadein { /* Firefox */\n      from {\n          opacity:0;\n      }\n      to {\n          opacity:1;\n      }\n  }\n  @-webkit-keyframes fadein { /* Safari and Chrome */\n      from {\n          opacity:0;\n      }\n      to {\n          opacity:1;\n      }\n  }\n  @-o-keyframes fadein { /* Opera */\n      from {\n          opacity:0;\n      }\n      to {\n          opacity: 1;\n      }\n  }\n\n  .slide{\n    animation: slide 1s easy-in forwards;\n  }\n\n  @keyframes slide{\n    0%{\n        transform: translateX(0%);\n    }\n    100%{\n        transform: translateX(100px);\n    }\n  }\n.fade-enter{\nopacity:0;\n}\n.fade-enter-active{\n    opacity:1;\n    transition: opacity 1000ms ease-out;\n}\n.fade-leave{\n    opacity:1;\n}\n.fade-leave-active{\n    opacity:0;\n    transition: opacity 1000ms ease-out;\n}\n.fade-appear{\n    opacity: 0;\n}\n.fade-appear-active{\n    opacity: 1;\n    transition: opacity 2000ms ease-out;\n}\n.collections{margin:0;padding: 0;}\n.collection-item{\n    padding:10px 5px;\n    list-style-type: none;\n    border-left:4px solid;\n    margin-bottom:10px;\n    box-shadow: 0 0 15px #ccc;\n    font-size:12px;\n    line-height:22px;\n}\n.clr979797{color:#979797;}\n.overlay-block{position:fixed;width:100%;height:100%;top:0;left:0;background:#000;opacity:0.7;z-index:999;}\n.sliderBlock{\n    position:fixed;\n    right:0px;\n    top:0px;\n    width:0;\n    background:#fff;\n    height:100%;\n    box-shadow: 0 0 10px #333;\n    z-index:1000;\n    overflow-y:auto;\n    padding-top:60px;\n\tbox-shadow:0.5rem 0.5rem 2rem 1rem rgba(0, 0, 0, 0.2);\t\n    transition: 0.5s;\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%);\n}\n.sliderBlock2{\n    position:fixed;\n    right:0px;\n    top:0px;\n    width:0;\n    background:#fff;\n    height:100%;\n    box-shadow: 0 0 10px #333;\n    z-index:1000;\n    overflow-y:auto;\n\tbox-shadow:0.5rem 0.5rem 2rem 1rem rgba(0, 0, 0, 0.2);\t\n    transition: 0.5s;\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%);\n}\n.slide25{width:25% !important;transform: translateX(0%);}\n.slide30{width:30% !important;transform: translateX(0%);}\n.slide35{width:35% !important;transform: translateX(0%);}\n.slide45{width:45% !important;transform: translateX(0%);}\n.slide60{width:60% !important;transform: translateX(0%);}\n.slide90{width:90% !important;transform: translateX(0%);}\n.slide80{width:80% !important;transform: translateX(0%);}\n.show-n{display:none;}\n.show-m{display:block;}\n.rclr{color:#ff0000;}\n.crd-bg{background-color: #011128;color:#ffffff;font-weight:bold;}\n.sweet-alert, .sweet-alert h2{font-size:12px;font-family: 'Roboto-Light' !important;}\n.cursor{cursor: pointer;}\n.lh30{line-height:30px;}\n.gclr{color:#00a151;}\n.mh180{min-height:150px;max-height:170px;}\n.hanckr{\n    font-size:12px;\n    color:#FFFFFF;\n    text-decoration: none;\n    font-family: \"Roboto-Bold\";\n}\n.hanckr:hover{color:#000}\n.mapdrg{position:absolute;top:10%;left:1%;width:300px;height:50vh;overflow-y:auto;background:#fff;z-index:999;padding:10px;box-shadow: 0 0 15px 0 #4d4d4d;}\n.mapdrg h5{font-size:18px;padding:5px;}\n.mapdrg ul{margin:0;padding:0;}\n.mapdrg li{list-style-type:none;line-height:45px;border-bottom:1px solid #ccc;}\n.settingic{position:absolute;top:0;right:0px;}\n\n#dropzone {\noverflow:hidden;  \n}\n.btn-default{background:#ffffff;color:#000;}\n.border-rad-0{border-radius: 0px;}\n.gm-style .gm-iw{padding:10px;line-height:20px;}\n\n.logotext{color: #fff;\n    font-size: 33px;\n    text-shadow: 0 0 5px #000;margin-left:45px;}\n.overlay{\n    position: fixed;\n    top:0;\n    left:0;\n    width:100%;\n    height:100%;\n    background-color: #000;\n    opacity: 0.5;\n    z-index: 1000;\n  }\n  .block{display: block !important;}\n  .none{display: none !important;}\n  .slider{\n    display:none;\n    position: fixed;\n    right: 0px;\n    top: 0px;width:0;\n    overflow-y:auto;\n    height:100%;\n    background-color: #fff;\n    z-index: 1001;\n    transition: 0.5s;\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%);\n  }\n  .slider-25{\n    width:25%;\n    height:100%;\n    transform: translateX(0%);\n  }\n  .slider-35{\n    width:35%;\n    height:100%;\n    transform: translateX(0%);\n  }\n  \n  .slider-45{\n    width:45%;\n    height:100%;\n    transform: translateX(0%);\n  }\n  \n  .slider-55{\n    width:55%;\n    height:100%;\n    transform: translateX(0%);\n  }\n  \n  .slider-65{\n    width:65%;\n    height:100%;\n    transform: translateX(0%);\n  }\n  \n  .slider-75{\n    width:75%;\n    height:100%;\n    transform: translateX(0%);\n  }\n  \n  .slider-85{\n    width:85%;\n    height:100%;\n    transform: translateX(0%);\n  }\n  \n  .slider-90{\n    width:90%;\n    height:100%;\n    transform: translateX(0%);\n  }\n  .slider-95{\n    width:95%;\n    height:100%;\n    transform: translateX(0%);\n  }\n  .slider-header{position: relative;}\n  .slider-close{position: absolute;right:0px;top:0px;padding:8px 10px;color:#fff;}\n  .slider-body{padding:15px;}\n  .theme-list{\n    margin:0;\n    padding:0;\n  }\n  .theme-list li{display: inline-block;list-style-type: none;margin: 10px;}\n  .login-logo{position: absolute;right:2%;top:3%;}\n  \n.highcharts-data-table thead tr,\n.highcharts-data-table tr:nth-child(even) {\n    background: #f8f8f8;\n}\n\n.highcharts-data-table tr:hover {\n    background: #f1f7ff;\n}\n.highcharts-title{color:#ffffff !important;}\n.page-wrapper .page-main-header{\n    box-shadow: 0 0 0 #000;\n    /* background-color: #012632; */\n    background-color: #00182e;\n    color:#ffffff;\n}\n\n.page-wrapper .page-main-header > a{color:#ffffff;}\n.umg{filter:invert(1)}\n.page-main-header .main-header-left{background-color: #00182e;}\n.fclstxt {color:rgb(201, 201, 201) !important}\n.fcls{background: linear-gradient(#00182e, #000000) !important;\n    box-shadow: 0 0 20px #000;\n    border: 1px solid yellow;}\n.fcls-a{background: linear-gradient(#00182e, #000000) !important;\n        box-shadow: 0 0 20px #000;\n       }\n    \n.fcls-grid{background: linear-gradient(#00182e, #000000) !important;\n    box-shadow: 0 0 20px #000;\n    border: 1px solid #000;}\n    \n.filtr-s{\n    position:absolute;\n    top:2%;\n    right:5%;\n    width:300px;\n}\n.npimp{padding:0px !important;}\n.mxheit{max-height:85vh;overflow-y: auto;}\n.psabbtn{position: absolute;right:1.5%;top:-40px;z-index:9;}\n.mpinf{\n    position: absolute;\n    top: 1%;\n    width: 75%;\n    left: 18%;\n    height: 150px;\n    z-index: 10;\n    color: #000;\n    padding:10px;\n}\n.mpinfbg{position:absolute;width:100%;height:100%;background:#fff;opacity:0.8;top:0;left:0;box-shadow:0 0 20px #000;}\n.lodr{\n    position:fixed;\n    width:100%;\n    height:100%;\n    top:0;\n    left:0;\n    z-index:20;\n    background:#000;\n    opacity: 0.8;\n}\n.loaderdiv{\n    position: fixed;\n    width:100%;\n    height: 100%;\n    top:0;\n    left:0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index:21;\n  }\n.ldrtext{\n    position: fixed;\n    width:100%;\n    height: 100%;\n    top:0;\n    left:0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index:21;\n    margin-top:5%;\n    text-align: center;\n    color:#fff;\n    font-size:30px;\n}\n.loaderwave {\n    width: 5px;\n    height: 100px;\n    background: linear-gradient(45deg, rgb(214, 218, 12), #fff);\n    margin: 10px;\n    animation: loaderwave 1s linear infinite;\n    border-radius: 20px;\n  }\n  .loaderwave:nth-child(2) {\n    animation-delay: 0.1s;\n  }\n  .loaderwave:nth-child(3) {\n    animation-delay: 0.2s;\n  }\n  .loaderwave:nth-child(4) {\n    animation-delay: 0.3s;\n  }\n  .loaderwave:nth-child(5) {\n    animation-delay: 0.4s;\n  }\n  .loaderwave:nth-child(6) {\n    animation-delay: 0.5s;\n  }\n  .loaderwave:nth-child(7) {\n    animation-delay: 0.6s;\n  }\n  .loaderwave:nth-child(8) {\n    animation-delay: 0.7s;\n  }\n  .loaderwave:nth-child(9) {\n    animation-delay: 0.8s;\n  }\n  .loaderwave:nth-child(10) {\n    animation-delay: 0.9s;\n  }\n  \n  @keyframes loaderwave {\n    0% {\n      transform: scale(0);\n    }\n    50% {\n      transform: scale(1);\n    }\n    100% {\n      transform: scale(0);\n    }\n  }\n.menuic{background:transparent;border:0px;color:#fff;font-size:25px;font-weight: 600;margin-right:10px;position: absolute;top:5px;}\n.wrap {\n\tperspective: 800px;\n\tperspective-origin: 50% 100px;\n}\n.cube {\n\tposition: relative;\n\twidth: 200px;\n\ttransform-style: preserve-3d;\n}\n.cube div {\n\tposition: absolute;\n\twidth: 200px;\n\theight: 200px;\n}\n\n.back {\n\ttransform: translateZ(-100px) rotateY(180deg);\n}\n.right {\n\ttransform: rotateY(-270deg) translateX(100px);\n\ttransform-origin: top right;\n}\n.left {\n\ttransform: rotateY(270deg) translateX(-100px);\n\ttransform-origin: center left;\n}\n.top {\n\ttransform: rotateX(-90deg) translateY(-100px);\n\ttransform-origin: top center;\n}\n.bottom {\n\ttransform: rotateX(90deg) translateY(100px);\n\ttransform-origin: bottom center;\n}\n.front {\n\ttransform: translateZ(100px);\n}\n.ctbl table tr td,.ctbl table tr th{padding: 0.45em;border:1px solid #4d4d4d; font-family: 'Roboto-Regular';}\n.cutometheme-ico{\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  width:60px;\n  height: 60px;\n  border: 1px solid red;\n  cursor: pointer;\n}\n.fblack{color:#000;}\n.animatenow{position:absolute;top:0;left:0;width:100%;height:100%;background-color:#fff;z-index:9;}\n.pp-h{position:absolute;top:40px;left:35%;font-size:40px;}\n.dinf{font-weight:700;}\n\n.hovered {\n  cursor: help;\n}\n\n.label {\n  color: #fff;\n  font-family: sans-serif;\n  padding: 2px;\n}\n/* canvas{width:1300px !important;height:900px !important;position:absolute;top:17%;left:0;} */\n.border1-white{font-family: \"Roboto-Regular\";border-right:1px solid #333;border-top:1px solid #333;padding:0px 15px 0px 15px;background:rgba(237,237,237,0.3);}\n\n\n\n/*--====== Modal ======--*/\n.modal {\n  background-color: rgba(0, 0, 0, 0.3);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 99;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.3s ease, visibility 0.2s ease;\n}\n\n/* when Modal has open class */\n.modal.open {\n  pointer-events: all;\n  opacity: 1;\n  visibility: visible;\n}\n\n.modal_wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 1.5rem;\n  min-height: calc(100% - 3rem);\n}\n\n@media (max-width: 575.98px) {\n  .modal_wrapper {\n      margin: 0.5rem;\n      min-height: calc(100% - 1rem);\n  }\n}\n\n.modal_content {\n  position: relative;\n  background-color: var(--bg-color);\n  box-shadow: var(--shadow);\n  width: 100vw;\n  max-width: 800px;\n  padding: 4rem;\n  border-radius: 10px;\n  text-align: center;\n  overflow: hidden;\n  transform: scale(0);\n  transition: transform 0.4s ease;\n}\n\n/* when Modal is open then modal-content will... */\n.modal.open .modal_content {\n  transform: scale(1);\n}\n\n.modal_body {\n  margin: 2rem 0 3rem;\n}\n\n.modal_body p {\n  font-size: 1.2rem;\n  line-height: 1.6;\n  letter-spacing: 0.8px;\n}\n\n.close_btn {\n  font-size: 1.2rem;\n}\n\n.card-color-0{\n  background-color: #62bace !important;\n  border-radius: 4px;\n}\n.card-color-1{\n  background-color: #a19cc2 !important;\n  border-radius: 4px;\n}\n.card-color-2{\n  background-color: #b08ebc !important;\n  border-radius: 4px;\n}\n.card-color-3{\n  background-color: #6477b5 !important;\n  border-radius: 4px;\n}\n.pickupdrop-modelClass{\n  width: 80%;\n  border-radius: 4px !important ;\n  background: linear-gradient(#e2e3ee, #e2e3ee) !important;\n}\nlabel.c-lbl{margin-top:5px;font-size:0.9rem;}\n.redColor{color:#FF0000;font-size:12px;}\n.cancel-btn{\n  width: 100px !important;\n  margin-right: 10px;\n  padding-top: .375rem;\n  padding-bottom: .375rem;\n  padding-left: 1.25rem;\n  padding-right: 1.75rem;\n  background-color: #ccc !important;\n}\n.save-btn{\n  background-color: #20749b !important;\n  color: whitesmoke !important;\n  width: 100px !important;\n}\n.text-color{\n  color: whitesmoke !important;\n}\n.react-timerange-picker__inputGroup__input{\n  color: whitesmoke !important;\n}\n.react-timerange-picker__inputGroup__amPm option{\n  color: #000 !important;\n}\n.control-padding{\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n}\n.control-padding-right{\n  padding-right: 0px !important;\n}\n\n.number input::-webkit-outer-spin-button,\n.number input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.font-bold{\n  font-weight: bold;\n}\n\n\n.dropdown .ag-ltr .ag-select-list{\n  height: 150px;\n}\n\n.vehicle-time .react-timerange-picker__inputGroup__input{\n  color: #000 !important;\n}\n\n.vehicle-time .react-timerange-picker__wrapper{\n  border: 0px !important;\n}\n\n.disable-field{\n  background-color: #d5d5d5 !important;\n  cursor:not-allowed;\n}\n\n.disable-field-time {\n  background-color: white !important;\n  cursor:not-allowed;\n}\n.d-tabs{padding-left:0;margin: 0;}\n.d-tabs li{display: inline;border:1px solid #fff;}\n.activet{background:#20749b !important;color:#fff !important;margin:0px;}\n.lttabs{background:#ccc;padding:13px 4px 10px 4px; color:#333;}\n.lttabs button{background:transparent;color:#333;font-weight: 600;}\n.lttabs .btn.focus, .lttabs .btn:focus{box-shadow: none;}\n.lttabs.activet button{color:#fff;}\n.mt-20per{margin-top:2%}\n.fw-600{font-weight: 600;}\n.fw-800{font-weight: 800;}\n.txt-center{text-align: center;}\n.w-100{width:100%}\n.theme-clr{color:#20749b !important}\n.brd-right{border-right: 1px solid #ccc;}\n.hr-dashed{\n   margin:2% 0 2% 0;\n   border-bottom:1px dotted #ccc;\n}\n.ml-2per{margin-left: 2%;}\n.ml-3per{margin-left: 3%;}\n.ml-6per{margin-left: 6%;}\n.ml-9per{margin-left: 9%;}\ninput:disabled{cursor: not-allowed;background-color: #d5d5d5 !important;}\n.react-timerange-picker--disabled{background-color:#f0f0f0 !important}\n.pd-rt-6{padding-right: 6%;}\n.bgn{position: fixed;\n  top:67px;\n  right: 0px;\n  bottom: 0px;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  /* opacity: 0.8; */\n}\n.bgi{background-image: url(\"../images/rando3.jpg\") !important;    background-size: cover !important;background-repeat: no-repeat !important;background-position: right !important;}\n.main-menu{\n  position: fixed;\n  height: 100%;\n  width: 150px;\n  top: 0;\n  background: #f7f4fa;\n  z-index: 1;\n  transition: all .2s ease;\n  box-shadow: rgb(0 0 0 / 22%) 0px 25.6px 57.6px 0px, rgb(0 0 0 / 18%) 0px 4.8px 14.4px 0px;\n  -webkit-animation-duration: .18s;\n  animation-duration: .18s;\n  -webkit-animation-timing-function: ease;\n  animation-timing-function: ease;\n}\n.close-toggle{\n  font-size: 20px;\n  cursor: pointer;\n}\n.font-white{\n  color:#fff;\n}\n#menu_toggle{\n  cursor:pointer;\n}\n.pad-left-5per{padding-left:5%;}\n.pad-left-10per{padding-left:10%;}\n/* .m_content{\n    position: relative;\n    width: 100%;\n    margin-bottom: 10px;\n    padding: 10px 17px;\n} */\n\n#sceneAppend canvas{position: absolute;left:0;top:0;}\n\n.pad-left{\n  padding-left: 3px !important;\n}\n\n.react-timerange-picker__range-divider{\n  color: #000 !important;\n}\n.react-time-picker__inputGroup__divider{\ncolor: #000 !important;\n}\n.timer-width{\n  width: 105% !important;\n}\n.dataLoadpage{position:absolute;top:0;left:0;width:100%;height:100%;background:#fff;z-index:10;opacity: 0.5;}\n.overlay{position: fixed;width:100%;height:100%;top:0;left:0;z-index:7;background:#fff;opacity:0.5;}\n.overlay-part{position: fixed;width:100%;height:100%;top:0;left:0;z-index:999999;background:#fff;opacity:0.5;}\n.summaryDetailsTitle{\n  color: #000;\n  font-weight: 600;\n  font-size: 17px;\n}\n.module-header-text{\n  text-align: center;\n  margin-top: 3%;\n}\n\n.react-timerange-picker__inputGroup__leadingZero{\n  color: #000 !important;\n}\n\n.legend-height{\n  height: 24px;\n}\n#legend {\n  font-weight: 600;\n  margin-right: 10px;\n}\n\n.hide {\n  display: none;\n}\n\n.show-config-info:hover + .hide {\n  display: block;\n  color: red;\n}\n\n.vehiclepriority-modelClass{\n  width: 50%;\n  border-radius: 4px !important ;\n  background: linear-gradient(#e2e3ee, #e2e3ee) !important;\n}\n.trucks-dropdown {\n  background: white;\n  height: 18em;\n  width: 22.3em;\n  position: absolute;\n  overflow-y: scroll;\n  left: 21px;\n  z-index: 1000;\n  top: 70px;\n  border-radius: 5px;\n  border: 0.1px solid cornflowerblue;\n}\n.trucks-dropdown>ul{\n  padding-left: 0;\n}\n.trucks-dropdown>ul>li {\n  padding: 10px;\n  padding-left: 13px;\n  list-style: none;\n}\n.trucks-dropdown>ul>li:hover {\n  background: #e4e4e4;\n}\n\n.btn-index{\n  position: relative;\n  z-index: 1;\n}\n\n.num-color{\n  color: #26B99A;\n}\n/* .border-color{\n  border-color: #26B99A !important ;\n} */\n.cursorPointer{\n  cursor: pointer;\n}\n\n.txt-black{color: #000000}\n\n.txt-success-light{color: #00f0b5}\n.txt-success-medium{color: #00dea7}\n.txt-success-dark{color: #00d09c}\n\n.txt-primary-light{color: #d8caf3}\n.txt-primary-medium{color: #c6b1ed}\n.txt-primary-dark{color: #b99fe8}\n\n.txt-secondary-light{color: #a9e8f0}\n.txt-secondary-medium{color: #67d7ef}\n.txt-secondary-dark{color: #4dd0e1}\n\n.txt-info-light{color: #c0ddff}\n.txt-info-medium{color: #8dc2ff}\n.txt-info-dark{color: #66adff}\n\n.txt-warning-light{color: #fff28d}\n.txt-warning-medium{color: #ffec50}\n.txt-warning-dark{color: #ffe622}\n\n.txt-grey-light{color: #bebebe}\n.txt-grey-medium{color: #9f9f9f}\n.txt-grey-dark{color: #888888}\n\n.txt-pink-light{color: #f69ebd}\n.txt-pink-medium{color: #f16696}\n.txt-pink-dark{color: #ed3c7a}\n\n.txt-danger-light{color: #ffb9c5}\n.txt-danger-medium{color: #ff90a3}\n.txt-danger-dark{color: #ff7289 !important}\n.txt-orange-dark{color: orange}\n.countertxt{font-weight:bold}\n.countertxt-new{color:#000}\n.crm-numbers{box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;border-top:3px solid #09c7ac;}\n\n\n\n.cirlce-d{text-align: center;border-right:0px solid #ccc;}\n.cirlce-d:last-child{border-right:0;}\n.form-inputbox{border:1px solid #b5b5b5;font-size:0.9rem;border-radius:0px}\n.forminp{\n  padding-top: 5px;\n  padding-bottom: 5px;\n  padding-left: 9px;\n  border-radius:4px;\n  border:1px solid #c5c5c5;\n  font-size:16px !important;\n  font-family: 'Roboto-Regular';\n  width:100%;\n  color:#000000 !important;\n}\n\n.bx-sh{\n  background-color: white;\n  /* box-shadow: 0 0 8px #ccc; */\n  /* margin:10px; */\n  text-align: center;\n  padding:10px 0px;\n  /* border-radius:15px; */\n  border-right: 1px  solid #b2b1e1;\n}\n\n.redbg{background-color: #ff8fa3;}\n.greenbg{background-color: #00dea8;}\n.orangebg{background-color: #fdc958;}\n.chat-discussion-module{position:fixed;right: 10px;bottom: 10px;z-index:999;}\n.chat-box-users-layout{height:80vh;overflow-y: auto;position:relative;\n  /* box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px; */\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;\n  \n}\n.htClse{cursor: pointer;}\n.closeChatUser{position: absolute;right:0;top:0;}\n.chat-box{width:450px;height:100%;background-color: #fff;border: 0px solid #333;\n  /* box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px; */\n  /* box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px; */\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;\n  /* background-image: url(\"../images/coming-soon-bg.jpg\"); */\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.chat-box-header h4{background-color: #169F85;color:#ffffff;font-size:15px;padding:10px;}\n.chat-box-body{height:50vh;max-height:50vh;overflow-y:auto;overflow-x:hidden; color:#000;font-size:12px;}\n.chat-box-body img{width:30px;}\n.chat-box-even{background-color: #e4ffd1; padding:10px 15px 20px 15px;margin:0;margin-top:10px;}\n.chat-box-odd{background-color: #f8f8f8; padding:10px 15px 20px 15px;margin:0;margin-top:10px;}\n.chat-box-input{padding:10px;font-size:12px;}\n.chat-box-input button{border-radius:0px;font-size:12px; padding:10px 10px;}\n.unread-cls{font-weight: bold;color:#000;}\n.unread-cls h6{font-weight: bold;color:#000;}\n.chat-box-textarea{border: 1px solid #bbb;}\n.chat-item-current{text-align: right;}\n.avatr-user{position:absolute;right:-27px;padding: 5px 5px;\n  border-radius: 100%;\n  font-size: 12px;\n  border: 1px solid #ccc;\n  font-weight: bold;}\n\n.discussBox{\n  width:80%;\n  margin: 60px auto;\n  background: #fff;\n  padding: 0;\n  border-radius: 7px;\n}\n.chatlist{background:#fff;height:90vh;overflow-y:auto;overflow-x:hidden;}\n.chat-panel{min-height:70vh;max-height:70vh;overflow-y:auto;overflow-x:hidden;padding-bottom:60px;}\n.chat-ps{position:absolute;bottom:0px;height:80px;width:100%;background:#eee;}\n.chat-timer{color:#757575;font-size:11px;}\n.luerpos{position:absolute;bottom: -15px; right:10px;}\n.cuerpos{position:absolute;bottom: -15px; left:10px;}\n.profile-image {\n  width: 50px;\n  height: 50px;\n  border-radius: 40px;\n}\n.bshadow{box-shadow:0 0 10px #000;}\n.settings-tray {\n  background: #eee;\n  padding: 10px 15px;\n  border-radius: 0px;\n}\n.settings-tray .no-gutters {\n  padding: 0;\n}\n.settings-tray--right {\n  float: right;\n}\n.settings-tray--right i {\n  margin-top: 10px;\n  font-size: 25px;\n  color: grey;\n  margin-left: 14px;\n  transition: 0.3s;\n}\n.settings-tray--right i:hover {\n  color: #74b9ff;\n  cursor: pointer;\n}\n\n.search-box {\n  background: #fafafa;\n  padding: 10px 13px;\n}\n.search-box .input-wrapper {\n  background: #fff;\n  border-radius: 40px;\n}\n.search-box .input-wrapper i {\n  color: grey;\n  margin-left: 7px;\n  vertical-align: middle;\n}\n\ninput.chatInp {\n  border: none;\n  border-radius: 0px;\n  width: 80%;\n}\ninput.chatInp::placeholder {\n  color: #e3e3e3;\n  font-weight: 300;\n  margin-left: 20px;\n}\ninput.chatInp:focus {\n  outline: none;\n}\n\n.friend-drawer {\n  padding: 10px 15px;\n  display: flex;\n  vertical-align: baseline;\n  /* background: #fff; */\n  transition: 0.3s ease;\n  border-bottom:1px dotted #e3d4d4;\n}\n.friend-drawer--grey {\n  background: #eee;\n}\n.friend-drawer .text {\n  margin-left: 12px;\n  width: 70%;\n}\n.friend-drawer .text h6 {\n  margin-top: 6px;\n  margin-bottom: 0;\n  font-size:12px;\n}\n.friend-drawer .text p {\n  margin: 0;\n}\n.friend-drawer .time {\n  color: grey;\n}\n.friend-drawer--onhover:hover {\n  background: #74b9ff;\n  cursor: pointer;\n}\n.friend-drawer--onhover:hover p,\n.friend-drawer--onhover:hover h6,\n.friend-drawer--onhover:hover .time {\n  color: #fff !important;\n}\n\nhr {\n  margin: 5px auto;\n  width: 60%;\n}\n.tc{margin:10px 15px;text-align:center;}\n.chat-bubble {\n  padding: 10px 14px;\n  background: #eee;\n  margin: 10px 30px 10px 10px;\n  border-radius: 9px;\n  position: relative;\n  animation: fadeIn 1s ease-in;\n}\n.chat-bubble:after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  width: 0;\n  height: 0;\n  border: 20px solid transparent;\n  border-bottom: 0;\n  margin-top: -10px;\n}\n.chat-bubble--left:after {\n  left: 0;\n  border-right-color: #eee;\n  border-left: 0;\n  margin-left: -20px;\n}\n.chat-bubble--right:after {\n  right: 0;\n  border-left-color: #74b9ff;\n  border-right: 0;\n  margin-right: -20px;\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.offset-md-2 .chat-bubble {\n  background: #74b9ff;\n  color: #fff;\n}\n\n.chat-box-tray {\n  background: #eee;\n  display: flex;\n  align-items: baseline;\n  padding: 10px 15px;\n  align-items: center;\n  margin-top: 10px;\n  bottom: 0;\n}\n.chat-box-tray input {\n  margin: 0 10px;\n  padding: 6px 15px;\n  height:45px;\n}\n.chat-box-tray i {\n  color: grey;\n  font-size: 30px;\n  vertical-align: middle;\n}\n.chat-box-tray i:last-of-type {\n  margin-left: 25px;\n}\n\n.beffect{\n\topacity: 0;\n\tanimation-name: bounceIn;\n  animation-duration: 450ms;\n  animation-timing-function: linear;\n  animation-fill-mode: forwards;\n}\n.beffect:nth-child(2){animation-delay: 0.3s;}\n.beffect:nth-child(3){animation-delay: 0.6s;}\n.beffect:nth-child(4){animation-delay: 0.9s;}\n#counterCardBody{\n  padding: 15px 16px;\n}\n.bfnt{font-size:25px;margin-top:50px;color:#000;}\n.bfnt span{font-weight:bold;}\n.chatlistBox{position:absolute;left:0;top:0;}\n\n.sh-users{position:absolute;left:-9%;top:0%;}\n.chatNowBtn{\n    /* display: flex; */\n    align-items: center;\n    font-family: inherit;\n    font-weight: 500;\n    font-size: 16px;\n    padding: 0.7em 1.4em 0.7em 1.1em;\n    color: white;\n    background: #ad5389;\n    background: linear-gradient(0deg, rgba(20,167,62,1) 0%, rgba(102,247,113,1) 100%);\n    border: none;\n    box-shadow: 0 0.7em 1.5em -0.5em #14a73e98;\n    letter-spacing: 0.05em;\n    border-radius: 20em;\n    cursor: pointer;\n    user-select: none;\n    -webkit-user-select: none;\n    touch-action: manipulation;\n  }\n  \n.chatNowBtn:hover {\n    box-shadow: 0 0.5em 1.5em -0.5em #14a73e98;\n    background: linear-gradient(0deg,  rgb(37, 180, 49) 0%, rgba(20,167,62,1) 100%);\n    color:#fff;\n  }\n  \n.chatNowBtn:active {\n    box-shadow: 0 0.3em 1em -0.5em #14a73e98;\n    color:#fff;\n  }\n.btn-chat-users{\n  background: #006dff;\n    color: #7c7a7a;\n    background-image: linear-gradient(#f3f3f3, white, #e6e6e6);\n    border-radius: 0;\n    border: 1px solid #ccc;\n}\n.chat-users{\n  position: absolute;\n  left: 0px;\n  z-index: 99;\n  width: 0;\n  transition: all 0.2s ease-in-out;\n  transform: translateX(0 0);\n  height: 45vh;\n  background: #fff;\n  top: 40px;\n  /* box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px; */\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;\n  border: 0px solid red;\n  overflow-y: auto;\n}\n.chat-user-slide{width: 200px;transform: translateX(20%);left:-205px;}\n.chat-users::-webkit-scrollbar, .chat-box-users-layout::-webkit-scrollbar {\n  width: 5px;\n}\n\n/* Track */\n.chat-users::-webkit-scrollbar-track, .chat-box-users-layout::-webkit-scrollbar-track {\n  background: #cccccc; \n}\n \n/* Handle */\n.chat-users::-webkit-scrollbar-thumb, .chat-box-users-layout::-webkit-scrollbar-thumb {\n  background: #7e7e7e; \n}\n\n/* Handle on hover */\n.chat-users::-webkit-scrollbar-thumb:hover, .chat-box-users-layout::-webkit-scrollbar-thumb {\n  background: #7e7e7e; \n}\n.unredCount{\n  position: absolute;\n    top: -19px;\n    right: 9px;\n    background: #001bec;\n    color: #fff;\n    width: auto;\n    height: auto;\n    border-radius: 100%;\n    padding: 5px 10px;\n    font-size: 10px;\n    font-weight: bold;\n}\n.chartLoading{position: absolute;top:0px;left:0px;width:100%;height: 100%;background:#fff;opacity:1;z-index:1}\n.loaderpos{position: absolute;top:30%;left:40%;z-index:2}\n.loaderpos img{width:120px;}\n\n\n\n/* Media query for 125% scaling and 1920x1080 resolution */\n@media (min-resolution: 125dpi) and (min-width: 1536px) and (min-height: 700px) {\n  .countertxt{font-size:11px !important;}\n}\n/* Media query for 125% scaling and 1920x1080 resolution */\n@media (min-resolution: 125dpi) and (min-width: 1536px) and (min-height: 864px) {\n  .countertxt{font-size:11px !important;}\n}\n\n/* Media query for 150% scaling and 1920x1080 resolution */\n@media (min-resolution: 150dpi) and (min-width: 1280px) and (min-height: 720px) {\n  .countertxt{font-size:11px !important;}\n}\n\n/* Media query for 200% scaling and 1920x1080 resolution */\n@media (min-resolution: 200dpi) and (min-width: 960px) and (min-height: 540px) {\n  .countertxt{font-size:11px !important;}\n}\n\n/* Media query for 100% scaling and 1366x768 resolution */\n@media (max-resolution: 96dpi) and (max-width: 1366px) and (max-height: 768px) {\n  .countertxt{font-size:11px !important;}\n}\n\n/* Media query for 125% scaling and 1366x768 resolution */\n@media (max-resolution: 120dpi) and (max-width: 1093px) and (max-height: 615px) {\n  .countertxt{font-size:11px !important;}\n}\n\n/* Media query for 150% scaling and 1366x768 resolution */\n@media (max-resolution: 144dpi) and (max-width: 912px) and (max-height: 513px) {\n  .countertxt{font-size:11px !important;}\n}\n\n/* 1. scale and layout setting at 100% */\n@media (resolution: 1dppx) {\n  \n  @media screen and (min-width: 1440px) and (max-width: 1500px) and (min-height: 900px) {\n    /* Your CSS styles and rules for 1440x900 resolution */\n    #counterCardBody{\n      /* min-height:125px; */\n    }\n    .cirlce-d{padding:7px;}\n    .f13{font-size:12px;}\n    .f30{font-size:26px;}\n  }\n\n}\n\n\n/* 2. scale and layout setting at 125% */\n@media (resolution: 1.25dppx) {\n  .countertxt{font-size:10px !important;}\n\n  \n  @media screen and (min-width: 1440px) and (max-width: 1500px) and (min-height: 900px) {\n    /* Your CSS styles and rules for 1440x900 resolution */\n    #counterCardBody{\n      /* min-height:125px; */\n    }\n    .cirlce-d{padding:7px;}\n    .f13{font-size:12px;}\n    .f30{font-size:26px;}\n  }\n\n}\n\n\n/* 2. scale and layout setting at 110% */\n@media (resolution: 1.1dppx) {\n  .countertxt{font-size:12px !important;}\n\n  \n  @media screen and (min-width: 1440px) and (max-width: 1500px) and (min-height: 900px) {\n    /* Your CSS styles and rules for 1440x900 resolution */\n    #counterCardBody{\n      /* min-height:125px; */\n    }\n    .cirlce-d{padding:7px;}\n    .f13{font-size:12px;}\n    .f30{font-size:26px;}\n  }\n\n}\n\n\n/* 3. scale and layout setting at 150% */\n@media (resolution: 1.5dppx) {\n  .countertxt{font-size:8px !important;}\n  .f30{font-size:20px;}\n  body{font-size:10px;}\n}\n\n\n/* 4. scale and layout setting at 175% */\n@media (resolution: 1.75dppx) {\n  \n}\n\n.avator{\n  padding: 5px 5px;\n  border-radius: 100%;\n  font-size: 12px;\n  border: 1px solid #ccc;\n  font-weight: bold;\n  width:30px;\n}\n.even-txt{background:#e4ffd1}\n.odd-txt{background:#f8f8f8}\n.filterSelectI{position: absolute;right:10px;top:10px;z-index:999;}\n.filterSelectII{position: absolute;right:17%;top:10px;z-index:999;}\n\n.xtooltip {\n  position: relative;\n  left:100%;\n  top:0%;\n  display: inline-block;\n  border-bottom: 1px dotted black;\n}\n\n.xtooltip .xtooltiptext {\n  display:  none;\n  width: 140px;\n  background-image : linear-gradient(#fdfdfd, #ededed, #ffffff);\n  color: #000;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;\n  /* Position the tooltip */\n  position: absolute;\n  z-index: 1;\n}\n\n.xtooltip .xtooltiptextR {\n  display:  none;\n  width: 240px;\n  background-image : linear-gradient(#fdfdfd, #ededed, #ffffff);\n  color: #000;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  right:20px;\n  top:2px;\n  /* Position the tooltip */\n  position: absolute;\n  z-index: 1;\n}\n\n.xtooltip:hover .xtooltiptext, .xtooltip:hover .xtooltiptextR {\n  display: block;\n}\n\n\n.xatooltip {\n  position: static;\n  right:0%;\n  top:0px;\n  margin-left: 10px;\n  display: inline-block;\n  border-bottom: 1px dotted black;\n}\n\n.xatooltip .xtooltiptext {\n  display:  none;\n  width: 300px;\n  background-image : linear-gradient(#fdfdfd, #ededed, #ffffff);\n  color: #333;\n  text-align: justify;\n  line-height:1.6em;\n  border-radius: 6px;\n  padding: 5px 5px;\n  font-size:12px;\n  font-weight:normal;\n  /* Position the tooltip */\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;\n  position: absolute;\n  z-index: 1;\n}\n\n.xatooltip .xtooltiptextR {\n  display:  none;\n  width: 240px;\n  background-image : linear-gradient(#fdfdfd, #ededed, #ffffff);\n  color: #000;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  right:20px;\n  top:2px;\n  /* Position the tooltip */\n  position: absolute;\n  z-index: 1;\n}\n\n.xatooltip:hover .xtooltiptext, .xatooltip:hover .xtooltiptextR {\n  display: block;\n}\n\n.ytooltip {\n  background-color: #ffaffc;\n  border-radius: 10px;\n  padding: 10px 15px;\n  position: relative;\n  margin: 15px;\n  text-align: center;\n}\n\n.ytooltip::after {\n  background-color: #333;\n  border-radius: 10px;\n  color: #b254ff;\n  display: none;\n  padding: 10px 15px;\n  position: absolute;\n  text-align: center;\n  z-index: 999;\n}\n\n.ytooltip.top::after {\n  content: 'top';\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, calc(-100% - 10px));\n}\n\n.ytooltip.bottom::after {\n  content: 'bottom';\n  bottom: 0;\n  left: 50%;\n  transform: translate(-50%, calc(100% + 10px));\n}\n\n.ytooltip.right::after {\n  content: 'right';\n  top: 0;\n  right: 0;\n  transform: translateX(calc(100% + 10px));\n}\n\n.ytooltip.left::after {\n  content: 'left';\n  top: 0;\n  left: 0;\n  transform: translateX(calc(-100% - 10px));\n}\n\n.ytooltip:hover::after {\n  display: block;\n}\n\n.ytooltip::before {\n  background-color: #333;\n  content: ' ';\n  display: none;\n  position: absolute;\n  width: 15px;\n  height: 15px;\n  z-index: 999;\n}\n\n.ytooltip:hover::before {\n  display: block;\n}\n\n.ytooltip.top::before {\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, calc(-100% - 5px)) rotate(45deg);\n}\n\n.ytooltip.bottom::before {\n  bottom: 0;\n  left: 50%;\n  transform: translate(-50%, calc(100% + 5px)) rotate(45deg);\n}\n\n.ytooltip.right::before {\n  top: 50%;\n  right: 0;\n  transform: translate(calc(100% + 5px), -50%) rotate(45deg);\n}\n\n.ytooltip.left::before {\n  top: 50%;\n  left: 0;\n  transform: translate(calc(-100% - 5px), -50%) rotate(45deg);\n}\n#webpack-dev-server-client-overlay{display:none !important;}\n\n\n/* JQUery UI Sytles Start */\n\n.ui-helper-hidden {\n\tdisplay: none;\n}\n.ui-helper-hidden-accessible {\n\tborder: 0;\n\tclip: rect(0 0 0 0);\n\theight: 1px;\n\tmargin: -1px;\n\toverflow: hidden;\n\tpadding: 0;\n\tposition: absolute;\n\twidth: 1px;\n}\n.ui-helper-reset {\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tline-height: 1.3;\n\ttext-decoration: none;\n\tfont-size: 100%;\n\tlist-style: none;\n}\n.ui-helper-clearfix:before,\n.ui-helper-clearfix:after {\n\tcontent: \"\";\n\tdisplay: table;\n\tborder-collapse: collapse;\n}\n.ui-helper-clearfix:after {\n\tclear: both;\n}\n.ui-helper-zfix {\n\twidth: 100%;\n\theight: 100%;\n\ttop: 0;\n\tleft: 0;\n\tposition: absolute;\n\topacity: 0;\n\t-ms-filter: \"alpha(opacity=0)\"; /* support: IE8 */\n}\n\n.ui-front {\n\tz-index: 100;\n}\n\n\n/* Interaction Cues\n----------------------------------*/\n.ui-state-disabled {\n\tcursor: default !important;\n\tpointer-events: none;\n}\n\n\n/* Icons\n----------------------------------*/\n.ui-icon {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-top: -.25em;\n\tposition: relative;\n\ttext-indent: -99999px;\n\toverflow: hidden;\n\tbackground-repeat: no-repeat;\n}\n\n.ui-widget-icon-block {\n\tleft: 50%;\n\tmargin-left: -8px;\n\tdisplay: block;\n}\n\n/* Misc visuals\n----------------------------------*/\n\n/* Overlays */\n.ui-widget-overlay {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n}\n.ui-accordion .ui-accordion-header {\n\tdisplay: block;\n\tcursor: pointer;\n\tposition: relative;\n\tmargin: 2px 0 0 0;\n\tpadding: .5em .5em .5em .7em;\n\tfont-size: 100%;\n}\n.ui-accordion .ui-accordion-content {\n\tpadding: 1em 2.2em;\n\tborder-top: 0;\n\toverflow: auto;\n}\n.ui-autocomplete {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tcursor: default;\n}\n.ui-menu {\n\tlist-style: none;\n\tpadding: 0;\n\tmargin: 0;\n\tdisplay: block;\n\toutline: 0;\n}\n.ui-menu .ui-menu {\n\tposition: absolute;\n}\n.ui-menu .ui-menu-item {\n\tmargin: 0;\n\tcursor: pointer;\n\t/* support: IE10, see #8844 */\n\tlist-style-image: url(\"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7\");\n}\n.ui-menu .ui-menu-item-wrapper {\n\tposition: relative;\n\tpadding: 3px 1em 3px .4em;\n}\n.ui-menu .ui-menu-divider {\n\tmargin: 5px 0;\n\theight: 0;\n\tfont-size: 0;\n\tline-height: 0;\n\tborder-width: 1px 0 0 0;\n}\n.ui-menu .ui-state-focus,\n.ui-menu .ui-state-active {\n\tmargin: -1px;\n}\n\n/* icon support */\n.ui-menu-icons {\n\tposition: relative;\n}\n.ui-menu-icons .ui-menu-item-wrapper {\n\tpadding-left: 2em;\n}\n\n/* left-aligned */\n.ui-menu .ui-icon {\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: .2em;\n\tmargin: auto 0;\n}\n\n/* right-aligned */\n.ui-menu .ui-menu-icon {\n\tleft: auto;\n\tright: 0;\n}\n.ui-button {\n\tpadding: .4em 1em;\n\tdisplay: inline-block;\n\tposition: relative;\n\tline-height: normal;\n\tmargin-right: .1em;\n\tcursor: pointer;\n\tvertical-align: middle;\n\ttext-align: center;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\n\t/* Support: IE <= 11 */\n\toverflow: visible;\n}\n\n.ui-button,\n.ui-button:link,\n.ui-button:visited,\n.ui-button:hover,\n.ui-button:active {\n\ttext-decoration: none;\n}\n\n/* to make room for the icon, a width needs to be set here */\n.ui-button-icon-only {\n\twidth: 2em;\n\tbox-sizing: border-box;\n\ttext-indent: -9999px;\n\twhite-space: nowrap;\n}\n\n/* no icon support for input elements */\ninput.ui-button.ui-button-icon-only {\n\ttext-indent: 0;\n}\n\n/* button icon element(s) */\n.ui-button-icon-only .ui-icon {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\tmargin-top: -8px;\n\tmargin-left: -8px;\n}\n\n.ui-button.ui-icon-notext .ui-icon {\n\tpadding: 0;\n\twidth: 2.1em;\n\theight: 2.1em;\n\ttext-indent: -9999px;\n\twhite-space: nowrap;\n\n}\n\ninput.ui-button.ui-icon-notext .ui-icon {\n\twidth: auto;\n\theight: auto;\n\ttext-indent: 0;\n\twhite-space: normal;\n\tpadding: .4em 1em;\n}\n\n/* workarounds */\n/* Support: Firefox 5 - 40 */\ninput.ui-button::-moz-focus-inner,\nbutton.ui-button::-moz-focus-inner {\n\tborder: 0;\n\tpadding: 0;\n}\n.ui-controlgroup {\n\tvertical-align: middle;\n\tdisplay: inline-block;\n}\n.ui-controlgroup > .ui-controlgroup-item {\n\tfloat: left;\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n.ui-controlgroup > .ui-controlgroup-item:focus,\n.ui-controlgroup > .ui-controlgroup-item.ui-visual-focus {\n\tz-index: 9999;\n}\n.ui-controlgroup-vertical > .ui-controlgroup-item {\n\tdisplay: block;\n\tfloat: none;\n\twidth: 100%;\n\tmargin-top: 0;\n\tmargin-bottom: 0;\n\ttext-align: left;\n}\n.ui-controlgroup-vertical .ui-controlgroup-item {\n\tbox-sizing: border-box;\n}\n.ui-controlgroup .ui-controlgroup-label {\n\tpadding: .4em 1em;\n}\n.ui-controlgroup .ui-controlgroup-label span {\n\tfont-size: 80%;\n}\n.ui-controlgroup-horizontal .ui-controlgroup-label + .ui-controlgroup-item {\n\tborder-left: none;\n}\n.ui-controlgroup-vertical .ui-controlgroup-label + .ui-controlgroup-item {\n\tborder-top: none;\n}\n.ui-controlgroup-horizontal .ui-controlgroup-label.ui-widget-content {\n\tborder-right: none;\n}\n.ui-controlgroup-vertical .ui-controlgroup-label.ui-widget-content {\n\tborder-bottom: none;\n}\n\n/* Spinner specific style fixes */\n.ui-controlgroup-vertical .ui-spinner-input {\n\n\t/* Support: IE8 only, Android < 4.4 only */\n\twidth: 75%;\n\twidth: calc( 100% - 2.4em );\n}\n.ui-controlgroup-vertical .ui-spinner .ui-spinner-up {\n\tborder-top-style: solid;\n}\n\n.ui-checkboxradio-label .ui-icon-background {\n\tbox-shadow: inset 1px 1px 1px #ccc;\n\tborder-radius: .12em;\n\tborder: none;\n}\n.ui-checkboxradio-radio-label .ui-icon-background {\n\twidth: 16px;\n\theight: 16px;\n\tborder-radius: 1em;\n\toverflow: visible;\n\tborder: none;\n}\n.ui-checkboxradio-radio-label.ui-checkboxradio-checked .ui-icon,\n.ui-checkboxradio-radio-label.ui-checkboxradio-checked:hover .ui-icon {\n\tbackground-image: none;\n\twidth: 8px;\n\theight: 8px;\n\tborder-width: 4px;\n\tborder-style: solid;\n}\n.ui-checkboxradio-disabled {\n\tpointer-events: none;\n}\n.ui-datepicker {\n\twidth: 17em;\n\tpadding: .2em .2em 0;\n\tdisplay: none;\n}\n.ui-datepicker .ui-datepicker-header {\n\tposition: relative;\n\tpadding: .2em 0;\n}\n.ui-datepicker .ui-datepicker-prev,\n.ui-datepicker .ui-datepicker-next {\n\tposition: absolute;\n\ttop: 2px;\n\twidth: 1.8em;\n\theight: 1.8em;\n}\n.ui-datepicker .ui-datepicker-prev-hover,\n.ui-datepicker .ui-datepicker-next-hover {\n\ttop: 1px;\n}\n.ui-datepicker .ui-datepicker-prev {\n\tleft: 2px;\n}\n.ui-datepicker .ui-datepicker-next {\n\tright: 2px;\n}\n.ui-datepicker .ui-datepicker-prev-hover {\n\tleft: 1px;\n}\n.ui-datepicker .ui-datepicker-next-hover {\n\tright: 1px;\n}\n.ui-datepicker .ui-datepicker-prev span,\n.ui-datepicker .ui-datepicker-next span {\n\tdisplay: block;\n\tposition: absolute;\n\tleft: 50%;\n\tmargin-left: -8px;\n\ttop: 50%;\n\tmargin-top: -8px;\n}\n.ui-datepicker .ui-datepicker-title {\n\tmargin: 0 2.3em;\n\tline-height: 1.8em;\n\ttext-align: center;\n}\n.ui-datepicker .ui-datepicker-title select {\n\tfont-size: 1em;\n\tmargin: 1px 0;\n}\n.ui-datepicker select.ui-datepicker-month,\n.ui-datepicker select.ui-datepicker-year {\n\twidth: 45%;\n}\n.ui-datepicker table {\n\twidth: 100%;\n\tfont-size: .9em;\n\tborder-collapse: collapse;\n\tmargin: 0 0 .4em;\n}\n.ui-datepicker th {\n\tpadding: .7em .3em;\n\ttext-align: center;\n\tfont-weight: bold;\n\tborder: 0;\n}\n.ui-datepicker td {\n\tborder: 0;\n\tpadding: 1px;\n}\n.ui-datepicker td span,\n.ui-datepicker td a {\n\tdisplay: block;\n\tpadding: .2em;\n\ttext-align: right;\n\ttext-decoration: none;\n}\n.ui-datepicker .ui-datepicker-buttonpane {\n\tbackground-image: none;\n\tmargin: .7em 0 0 0;\n\tpadding: 0 .2em;\n\tborder-left: 0;\n\tborder-right: 0;\n\tborder-bottom: 0;\n}\n.ui-datepicker .ui-datepicker-buttonpane button {\n\tfloat: right;\n\tmargin: .5em .2em .4em;\n\tcursor: pointer;\n\tpadding: .2em .6em .3em .6em;\n\twidth: auto;\n\toverflow: visible;\n}\n.ui-datepicker .ui-datepicker-buttonpane button.ui-datepicker-current {\n\tfloat: left;\n}\n\n/* with multiple calendars */\n.ui-datepicker.ui-datepicker-multi {\n\twidth: auto;\n}\n.ui-datepicker-multi .ui-datepicker-group {\n\tfloat: left;\n}\n.ui-datepicker-multi .ui-datepicker-group table {\n\twidth: 95%;\n\tmargin: 0 auto .4em;\n}\n.ui-datepicker-multi-2 .ui-datepicker-group {\n\twidth: 50%;\n}\n.ui-datepicker-multi-3 .ui-datepicker-group {\n\twidth: 33.3%;\n}\n.ui-datepicker-multi-4 .ui-datepicker-group {\n\twidth: 25%;\n}\n.ui-datepicker-multi .ui-datepicker-group-last .ui-datepicker-header,\n.ui-datepicker-multi .ui-datepicker-group-middle .ui-datepicker-header {\n\tborder-left-width: 0;\n}\n.ui-datepicker-multi .ui-datepicker-buttonpane {\n\tclear: left;\n}\n.ui-datepicker-row-break {\n\tclear: both;\n\twidth: 100%;\n\tfont-size: 0;\n}\n\n/* RTL support */\n.ui-datepicker-rtl {\n\tdirection: rtl;\n}\n.ui-datepicker-rtl .ui-datepicker-prev {\n\tright: 2px;\n\tleft: auto;\n}\n.ui-datepicker-rtl .ui-datepicker-next {\n\tleft: 2px;\n\tright: auto;\n}\n.ui-datepicker-rtl .ui-datepicker-prev:hover {\n\tright: 1px;\n\tleft: auto;\n}\n.ui-datepicker-rtl .ui-datepicker-next:hover {\n\tleft: 1px;\n\tright: auto;\n}\n.ui-datepicker-rtl .ui-datepicker-buttonpane {\n\tclear: right;\n}\n.ui-datepicker-rtl .ui-datepicker-buttonpane button {\n\tfloat: left;\n}\n.ui-datepicker-rtl .ui-datepicker-buttonpane button.ui-datepicker-current,\n.ui-datepicker-rtl .ui-datepicker-group {\n\tfloat: right;\n}\n.ui-datepicker-rtl .ui-datepicker-group-last .ui-datepicker-header,\n.ui-datepicker-rtl .ui-datepicker-group-middle .ui-datepicker-header {\n\tborder-right-width: 0;\n\tborder-left-width: 1px;\n}\n\n/* Icons */\n.ui-datepicker .ui-icon {\n\tdisplay: block;\n\ttext-indent: -99999px;\n\toverflow: hidden;\n\tbackground-repeat: no-repeat;\n\tleft: .5em;\n\ttop: .3em;\n}\n.ui-dialog {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tpadding: .2em;\n\toutline: 0;\n}\n.ui-dialog .ui-dialog-titlebar {\n\tpadding: .4em 1em;\n\tposition: relative;\n}\n.ui-dialog .ui-dialog-title {\n\tfloat: left;\n\tmargin: .1em 0;\n\twhite-space: nowrap;\n\twidth: 90%;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n.ui-dialog .ui-dialog-titlebar-close {\n\tposition: absolute;\n\tright: .3em;\n\ttop: 50%;\n\twidth: 20px;\n\tmargin: -10px 0 0 0;\n\tpadding: 1px;\n\theight: 20px;\n}\n.ui-dialog .ui-dialog-content {\n\tposition: relative;\n\tborder: 0;\n\tpadding: .5em 1em;\n\tbackground: none;\n\toverflow: auto;\n}\n.ui-dialog .ui-dialog-buttonpane {\n\ttext-align: left;\n\tborder-width: 1px 0 0 0;\n\tbackground-image: none;\n\tmargin-top: .5em;\n\tpadding: .3em 1em .5em .4em;\n}\n.ui-dialog .ui-dialog-buttonpane .ui-dialog-buttonset {\n\tfloat: right;\n}\n.ui-dialog .ui-dialog-buttonpane button {\n\tmargin: .5em .4em .5em 0;\n\tcursor: pointer;\n}\n.ui-dialog .ui-resizable-n {\n\theight: 2px;\n\ttop: 0;\n}\n.ui-dialog .ui-resizable-e {\n\twidth: 2px;\n\tright: 0;\n}\n.ui-dialog .ui-resizable-s {\n\theight: 2px;\n\tbottom: 0;\n}\n.ui-dialog .ui-resizable-w {\n\twidth: 2px;\n\tleft: 0;\n}\n.ui-dialog .ui-resizable-se,\n.ui-dialog .ui-resizable-sw,\n.ui-dialog .ui-resizable-ne,\n.ui-dialog .ui-resizable-nw {\n\twidth: 7px;\n\theight: 7px;\n}\n.ui-dialog .ui-resizable-se {\n\tright: 0;\n\tbottom: 0;\n}\n.ui-dialog .ui-resizable-sw {\n\tleft: 0;\n\tbottom: 0;\n}\n.ui-dialog .ui-resizable-ne {\n\tright: 0;\n\ttop: 0;\n}\n.ui-dialog .ui-resizable-nw {\n\tleft: 0;\n\ttop: 0;\n}\n.ui-draggable .ui-dialog-titlebar {\n\tcursor: move;\n}\n.ui-draggable-handle {\n\t-ms-touch-action: none;\n\ttouch-action: none;\n}\n.ui-resizable {\n\tposition: relative;\n}\n.ui-resizable-handle {\n\tposition: absolute;\n\tfont-size: 0.1px;\n\tdisplay: block;\n\t-ms-touch-action: none;\n\ttouch-action: none;\n}\n.ui-resizable-disabled .ui-resizable-handle,\n.ui-resizable-autohide .ui-resizable-handle {\n\tdisplay: none;\n}\n.ui-resizable-n {\n\tcursor: n-resize;\n\theight: 7px;\n\twidth: 100%;\n\ttop: -5px;\n\tleft: 0;\n}\n.ui-resizable-s {\n\tcursor: s-resize;\n\theight: 7px;\n\twidth: 100%;\n\tbottom: -5px;\n\tleft: 0;\n}\n.ui-resizable-e {\n\tcursor: e-resize;\n\twidth: 7px;\n\tright: -5px;\n\ttop: 0;\n\theight: 100%;\n}\n.ui-resizable-w {\n\tcursor: w-resize;\n\twidth: 7px;\n\tleft: -5px;\n\ttop: 0;\n\theight: 100%;\n}\n.ui-resizable-se {\n\tcursor: se-resize;\n\twidth: 12px;\n\theight: 12px;\n\tright: 1px;\n\tbottom: 1px;\n}\n.ui-resizable-sw {\n\tcursor: sw-resize;\n\twidth: 9px;\n\theight: 9px;\n\tleft: -5px;\n\tbottom: -5px;\n}\n.ui-resizable-nw {\n\tcursor: nw-resize;\n\twidth: 9px;\n\theight: 9px;\n\tleft: -5px;\n\ttop: -5px;\n}\n.ui-resizable-ne {\n\tcursor: ne-resize;\n\twidth: 9px;\n\theight: 9px;\n\tright: -5px;\n\ttop: -5px;\n}\n.ui-progressbar {\n\theight: 2em;\n\ttext-align: left;\n\toverflow: hidden;\n}\n.ui-progressbar .ui-progressbar-value {\n\tmargin: -1px;\n\theight: 100%;\n}\n.ui-progressbar .ui-progressbar-overlay {\n\tbackground: url(\"data:image/gif;base64,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\");\n\theight: 100%;\n\t-ms-filter: \"alpha(opacity=25)\"; /* support: IE8 */\n\topacity: 0.25;\n}\n.ui-progressbar-indeterminate .ui-progressbar-value {\n\tbackground-image: none;\n}\n.ui-selectable {\n\t-ms-touch-action: none;\n\ttouch-action: none;\n}\n.ui-selectable-helper {\n\tposition: absolute;\n\tz-index: 100;\n\tborder: 1px dotted black;\n}\n.ui-selectmenu-menu {\n\tpadding: 0;\n\tmargin: 0;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tdisplay: none;\n}\n.ui-selectmenu-menu .ui-menu {\n\toverflow: auto;\n\toverflow-x: hidden;\n\tpadding-bottom: 1px;\n}\n.ui-selectmenu-menu .ui-menu .ui-selectmenu-optgroup {\n\tfont-size: 1em;\n\tfont-weight: bold;\n\tline-height: 1.5;\n\tpadding: 2px 0.4em;\n\tmargin: 0.5em 0 0 0;\n\theight: auto;\n\tborder: 0;\n}\n.ui-selectmenu-open {\n\tdisplay: block;\n}\n.ui-selectmenu-text {\n\tdisplay: block;\n\tmargin-right: 20px;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n.ui-selectmenu-button.ui-button {\n\ttext-align: left;\n\twhite-space: nowrap;\n\twidth: 14em;\n}\n.ui-selectmenu-icon.ui-icon {\n\tfloat: right;\n\tmargin-top: 0;\n}\n.ui-slider {\n\tposition: relative;\n\ttext-align: left;\n}\n.ui-slider .ui-slider-handle {\n\tposition: absolute;\n\tz-index: 2;\n\twidth: 1.2em;\n\theight: 1.2em;\n\tcursor: pointer;\n\t-ms-touch-action: none;\n\ttouch-action: none;\n}\n.ui-slider .ui-slider-range {\n\tposition: absolute;\n\tz-index: 1;\n\tfont-size: .7em;\n\tdisplay: block;\n\tborder: 0;\n\tbackground-position: 0 0;\n}\n\n/* support: IE8 - See #6727 */\n.ui-slider.ui-state-disabled .ui-slider-handle,\n.ui-slider.ui-state-disabled .ui-slider-range {\n\tfilter: inherit;\n}\n\n.ui-slider-horizontal {\n\theight: .8em;\n}\n.ui-slider-horizontal .ui-slider-handle {\n\ttop: -.3em;\n\tmargin-left: -.6em;\n}\n.ui-slider-horizontal .ui-slider-range {\n\ttop: 0;\n\theight: 100%;\n}\n.ui-slider-horizontal .ui-slider-range-min {\n\tleft: 0;\n}\n.ui-slider-horizontal .ui-slider-range-max {\n\tright: 0;\n}\n\n.ui-slider-vertical {\n\twidth: .8em;\n\theight: 100px;\n}\n.ui-slider-vertical .ui-slider-handle {\n\tleft: -.3em;\n\tmargin-left: 0;\n\tmargin-bottom: -.6em;\n}\n.ui-slider-vertical .ui-slider-range {\n\tleft: 0;\n\twidth: 100%;\n}\n.ui-slider-vertical .ui-slider-range-min {\n\tbottom: 0;\n}\n.ui-slider-vertical .ui-slider-range-max {\n\ttop: 0;\n}\n.ui-sortable-handle {\n\t-ms-touch-action: none;\n\ttouch-action: none;\n}\n.ui-spinner {\n\tposition: relative;\n\tdisplay: inline-block;\n\toverflow: hidden;\n\tpadding: 0;\n\tvertical-align: middle;\n}\n.ui-spinner-input {\n\tborder: none;\n\tbackground: none;\n\tcolor: inherit;\n\tpadding: .222em 0;\n\tmargin: .2em 0;\n\tvertical-align: middle;\n\tmargin-left: .4em;\n\tmargin-right: 2em;\n}\n.ui-spinner-button {\n\twidth: 1.6em;\n\theight: 50%;\n\tfont-size: .5em;\n\tpadding: 0;\n\tmargin: 0;\n\ttext-align: center;\n\tposition: absolute;\n\tcursor: default;\n\tdisplay: block;\n\toverflow: hidden;\n\tright: 0;\n}\n/* more specificity required here to override default borders */\n.ui-spinner a.ui-spinner-button {\n\tborder-top-style: none;\n\tborder-bottom-style: none;\n\tborder-right-style: none;\n}\n.ui-spinner-up {\n\ttop: 0;\n}\n.ui-spinner-down {\n\tbottom: 0;\n}\n.ui-tabs {\n\tposition: relative;/* position: relative prevents IE scroll bug (element with position: relative inside container with overflow: auto appear as \"fixed\") */\n\tpadding: .2em;\n}\n.ui-tabs .ui-tabs-nav {\n\tmargin: 0;\n\tpadding: .2em .2em 0;\n}\n.ui-tabs .ui-tabs-nav li {\n\tlist-style: none;\n\tfloat: left;\n\tposition: relative;\n\ttop: 0;\n\tmargin: 1px .2em 0 0;\n\tborder-bottom-width: 0;\n\tpadding: 0;\n\twhite-space: nowrap;\n}\n.ui-tabs .ui-tabs-nav .ui-tabs-anchor {\n\tfloat: left;\n\tpadding: .5em 1em;\n\ttext-decoration: none;\n}\n.ui-tabs .ui-tabs-nav li.ui-tabs-active {\n\tmargin-bottom: -1px;\n\tpadding-bottom: 1px;\n}\n.ui-tabs .ui-tabs-nav li.ui-tabs-active .ui-tabs-anchor,\n.ui-tabs .ui-tabs-nav li.ui-state-disabled .ui-tabs-anchor,\n.ui-tabs .ui-tabs-nav li.ui-tabs-loading .ui-tabs-anchor {\n\tcursor: text;\n}\n.ui-tabs-collapsible .ui-tabs-nav li.ui-tabs-active .ui-tabs-anchor {\n\tcursor: pointer;\n}\n.ui-tabs .ui-tabs-panel {\n\tdisplay: block;\n\tborder-width: 0;\n\tpadding: 1em 1.4em;\n\tbackground: none;\n}\n.ui-tooltip {\n\tpadding: 8px;\n\tposition: absolute;\n\tz-index: 9999;\n\tmax-width: 300px;\n}\nbody .ui-tooltip {\n\tborder-width: 2px;\n}\n/* Component containers\n----------------------------------*/\n.ui-widget {\n\tfont-family: Arial,Helvetica,sans-serif;\n\tfont-size: 1em;\n}\n.ui-widget .ui-widget {\n\tfont-size: 1em;\n}\n.ui-widget input,\n.ui-widget select,\n.ui-widget textarea,\n.ui-widget button {\n\tfont-family: Arial,Helvetica,sans-serif;\n\tfont-size: 1em;\n}\n.ui-widget.ui-widget-content {\n\tborder: 1px solid #c5c5c5;\n}\n.ui-widget-content {\n\tborder: 1px solid #dddddd;\n\tbackground: #ffffff;\n\tcolor: #333333;\n}\n.ui-widget-content a {\n\tcolor: #333333;\n}\n.ui-widget-header {\n\tborder: 1px solid #dddddd;\n\tbackground: #e9e9e9;\n\tcolor: #333333;\n\tfont-weight: bold;\n}\n.ui-widget-header a {\n\tcolor: #333333;\n}\n\n/* Interaction states\n----------------------------------*/\n.ui-state-default,\n.ui-widget-content .ui-state-default,\n.ui-widget-header .ui-state-default,\n.ui-button,\n\n/* We use html here because we need a greater specificity to make sure disabled\nworks properly when clicked or hovered */\nhtml .ui-button.ui-state-disabled:hover,\nhtml .ui-button.ui-state-disabled:active {\n\tborder: 1px solid #c5c5c5;\n\tbackground: #f6f6f6;\n\tfont-weight: normal;\n\tcolor: #454545;\n}\n.ui-state-default a,\n.ui-state-default a:link,\n.ui-state-default a:visited,\na.ui-button,\na:link.ui-button,\na:visited.ui-button,\n.ui-button {\n\tcolor: #454545;\n\ttext-decoration: none;\n}\n.ui-state-hover,\n.ui-widget-content .ui-state-hover,\n.ui-widget-header .ui-state-hover,\n.ui-state-focus,\n.ui-widget-content .ui-state-focus,\n.ui-widget-header .ui-state-focus,\n.ui-button:hover,\n.ui-button:focus {\n\tborder: 1px solid #cccccc;\n\tbackground: #ededed;\n\tfont-weight: normal;\n\tcolor: #2b2b2b;\n}\n.ui-state-hover a,\n.ui-state-hover a:hover,\n.ui-state-hover a:link,\n.ui-state-hover a:visited,\n.ui-state-focus a,\n.ui-state-focus a:hover,\n.ui-state-focus a:link,\n.ui-state-focus a:visited,\na.ui-button:hover,\na.ui-button:focus {\n\tcolor: #2b2b2b;\n\ttext-decoration: none;\n}\n\n.ui-visual-focus {\n\tbox-shadow: 0 0 3px 1px rgb(94, 158, 214);\n}\n.ui-state-active,\n.ui-widget-content .ui-state-active,\n.ui-widget-header .ui-state-active,\na.ui-button:active,\n.ui-button:active,\n.ui-button.ui-state-active:hover {\n\tborder: 1px solid #003eff;\n\tbackground: #007fff;\n\tfont-weight: normal;\n\tcolor: #ffffff;\n}\n.ui-icon-background,\n.ui-state-active .ui-icon-background {\n\tborder: #003eff;\n\tbackground-color: #ffffff;\n}\n.ui-state-active a,\n.ui-state-active a:link,\n.ui-state-active a:visited {\n\tcolor: #ffffff;\n\ttext-decoration: none;\n}\n\n/* Interaction Cues\n----------------------------------*/\n.ui-state-highlight,\n.ui-widget-content .ui-state-highlight,\n.ui-widget-header .ui-state-highlight {\n\tborder: 1px solid #dad55e;\n\tbackground: #fffa90;\n\tcolor: #777620;\n}\n.ui-state-checked {\n\tborder: 1px solid #dad55e;\n\tbackground: #fffa90;\n}\n.ui-state-highlight a,\n.ui-widget-content .ui-state-highlight a,\n.ui-widget-header .ui-state-highlight a {\n\tcolor: #777620;\n}\n.ui-state-error,\n.ui-widget-content .ui-state-error,\n.ui-widget-header .ui-state-error {\n\tborder: 1px solid #f1a899;\n\tbackground: #fddfdf;\n\tcolor: #5f3f3f;\n}\n.ui-state-error a,\n.ui-widget-content .ui-state-error a,\n.ui-widget-header .ui-state-error a {\n\tcolor: #5f3f3f;\n}\n.ui-state-error-text,\n.ui-widget-content .ui-state-error-text,\n.ui-widget-header .ui-state-error-text {\n\tcolor: #5f3f3f;\n}\n.ui-priority-primary,\n.ui-widget-content .ui-priority-primary,\n.ui-widget-header .ui-priority-primary {\n\tfont-weight: bold;\n}\n.ui-priority-secondary,\n.ui-widget-content .ui-priority-secondary,\n.ui-widget-header .ui-priority-secondary {\n\topacity: .7;\n\t-ms-filter: \"alpha(opacity=70)\"; /* support: IE8 */\n\tfont-weight: normal;\n}\n.ui-state-disabled,\n.ui-widget-content .ui-state-disabled,\n.ui-widget-header .ui-state-disabled {\n\topacity: .35;\n\t-ms-filter: \"alpha(opacity=35)\"; /* support: IE8 */\n\tbackground-image: none;\n}\n.ui-state-disabled .ui-icon {\n\t-ms-filter: \"alpha(opacity=35)\"; /* support: IE8 - See #6059 */\n}\n\n/* Icons\n----------------------------------*/\n\n/* states and images */\n.ui-icon {\n\twidth: 16px;\n\theight: 16px;\n}\n.ui-icon,\n.ui-widget-content .ui-icon {\n\tbackground-image: url(\"../images/ui-icons_444444_256x240.png\");\n}\n.ui-widget-header .ui-icon {\n\tbackground-image: url(\"../images/ui-icons_444444_256x240.png\");\n}\n.ui-state-hover .ui-icon,\n.ui-state-focus .ui-icon,\n.ui-button:hover .ui-icon,\n.ui-button:focus .ui-icon {\n\tbackground-image: url(\"../images/ui-icons_555555_256x240.png\");\n}\n.ui-state-active .ui-icon,\n.ui-button:active .ui-icon {\n\tbackground-image: url(\"../images/ui-icons_ffffff_256x240.png\");\n}\n.ui-state-highlight .ui-icon,\n.ui-button .ui-state-highlight.ui-icon {\n\tbackground-image: url(\"../images/ui-icons_777620_256x240.png\");\n}\n.ui-state-error .ui-icon,\n.ui-state-error-text .ui-icon {\n\tbackground-image: url(\"../images/ui-icons_cc0000_256x240.png\");\n}\n.ui-button .ui-icon {\n\tbackground-image: url(\"../images/ui-icons_777777_256x240.png\");\n}\n\n/* positioning */\n/* Three classes needed to override `.ui-button:hover .ui-icon` */\n.ui-icon-blank.ui-icon-blank.ui-icon-blank {\n\tbackground-image: none;\n}\n.ui-icon-caret-1-n { background-position: 0 0; }\n.ui-icon-caret-1-ne { background-position: -16px 0; }\n.ui-icon-caret-1-e { background-position: -32px 0; }\n.ui-icon-caret-1-se { background-position: -48px 0; }\n.ui-icon-caret-1-s { background-position: -65px 0; }\n.ui-icon-caret-1-sw { background-position: -80px 0; }\n.ui-icon-caret-1-w { background-position: -96px 0; }\n.ui-icon-caret-1-nw { background-position: -112px 0; }\n.ui-icon-caret-2-n-s { background-position: -128px 0; }\n.ui-icon-caret-2-e-w { background-position: -144px 0; }\n.ui-icon-triangle-1-n { background-position: 0 -16px; }\n.ui-icon-triangle-1-ne { background-position: -16px -16px; }\n.ui-icon-triangle-1-e { background-position: -32px -16px; }\n.ui-icon-triangle-1-se { background-position: -48px -16px; }\n.ui-icon-triangle-1-s { background-position: -65px -16px; }\n.ui-icon-triangle-1-sw { background-position: -80px -16px; }\n.ui-icon-triangle-1-w { background-position: -96px -16px; }\n.ui-icon-triangle-1-nw { background-position: -112px -16px; }\n.ui-icon-triangle-2-n-s { background-position: -128px -16px; }\n.ui-icon-triangle-2-e-w { background-position: -144px -16px; }\n.ui-icon-arrow-1-n { background-position: 0 -32px; }\n.ui-icon-arrow-1-ne { background-position: -16px -32px; }\n.ui-icon-arrow-1-e { background-position: -32px -32px; }\n.ui-icon-arrow-1-se { background-position: -48px -32px; }\n.ui-icon-arrow-1-s { background-position: -65px -32px; }\n.ui-icon-arrow-1-sw { background-position: -80px -32px; }\n.ui-icon-arrow-1-w { background-position: -96px -32px; }\n.ui-icon-arrow-1-nw { background-position: -112px -32px; }\n.ui-icon-arrow-2-n-s { background-position: -128px -32px; }\n.ui-icon-arrow-2-ne-sw { background-position: -144px -32px; }\n.ui-icon-arrow-2-e-w { background-position: -160px -32px; }\n.ui-icon-arrow-2-se-nw { background-position: -176px -32px; }\n.ui-icon-arrowstop-1-n { background-position: -192px -32px; }\n.ui-icon-arrowstop-1-e { background-position: -208px -32px; }\n.ui-icon-arrowstop-1-s { background-position: -224px -32px; }\n.ui-icon-arrowstop-1-w { background-position: -240px -32px; }\n.ui-icon-arrowthick-1-n { background-position: 1px -48px; }\n.ui-icon-arrowthick-1-ne { background-position: -16px -48px; }\n.ui-icon-arrowthick-1-e { background-position: -32px -48px; }\n.ui-icon-arrowthick-1-se { background-position: -48px -48px; }\n.ui-icon-arrowthick-1-s { background-position: -64px -48px; }\n.ui-icon-arrowthick-1-sw { background-position: -80px -48px; }\n.ui-icon-arrowthick-1-w { background-position: -96px -48px; }\n.ui-icon-arrowthick-1-nw { background-position: -112px -48px; }\n.ui-icon-arrowthick-2-n-s { background-position: -128px -48px; }\n.ui-icon-arrowthick-2-ne-sw { background-position: -144px -48px; }\n.ui-icon-arrowthick-2-e-w { background-position: -160px -48px; }\n.ui-icon-arrowthick-2-se-nw { background-position: -176px -48px; }\n.ui-icon-arrowthickstop-1-n { background-position: -192px -48px; }\n.ui-icon-arrowthickstop-1-e { background-position: -208px -48px; }\n.ui-icon-arrowthickstop-1-s { background-position: -224px -48px; }\n.ui-icon-arrowthickstop-1-w { background-position: -240px -48px; }\n.ui-icon-arrowreturnthick-1-w { background-position: 0 -64px; }\n.ui-icon-arrowreturnthick-1-n { background-position: -16px -64px; }\n.ui-icon-arrowreturnthick-1-e { background-position: -32px -64px; }\n.ui-icon-arrowreturnthick-1-s { background-position: -48px -64px; }\n.ui-icon-arrowreturn-1-w { background-position: -64px -64px; }\n.ui-icon-arrowreturn-1-n { background-position: -80px -64px; }\n.ui-icon-arrowreturn-1-e { background-position: -96px -64px; }\n.ui-icon-arrowreturn-1-s { background-position: -112px -64px; }\n.ui-icon-arrowrefresh-1-w { background-position: -128px -64px; }\n.ui-icon-arrowrefresh-1-n { background-position: -144px -64px; }\n.ui-icon-arrowrefresh-1-e { background-position: -160px -64px; }\n.ui-icon-arrowrefresh-1-s { background-position: -176px -64px; }\n.ui-icon-arrow-4 { background-position: 0 -80px; }\n.ui-icon-arrow-4-diag { background-position: -16px -80px; }\n.ui-icon-extlink { background-position: -32px -80px; }\n.ui-icon-newwin { background-position: -48px -80px; }\n.ui-icon-refresh { background-position: -64px -80px; }\n.ui-icon-shuffle { background-position: -80px -80px; }\n.ui-icon-transfer-e-w { background-position: -96px -80px; }\n.ui-icon-transferthick-e-w { background-position: -112px -80px; }\n.ui-icon-folder-collapsed { background-position: 0 -96px; }\n.ui-icon-folder-open { background-position: -16px -96px; }\n.ui-icon-document { background-position: -32px -96px; }\n.ui-icon-document-b { background-position: -48px -96px; }\n.ui-icon-note { background-position: -64px -96px; }\n.ui-icon-mail-closed { background-position: -80px -96px; }\n.ui-icon-mail-open { background-position: -96px -96px; }\n.ui-icon-suitcase { background-position: -112px -96px; }\n.ui-icon-comment { background-position: -128px -96px; }\n.ui-icon-person { background-position: -144px -96px; }\n.ui-icon-print { background-position: -160px -96px; }\n.ui-icon-trash { background-position: -176px -96px; }\n.ui-icon-locked { background-position: -192px -96px; }\n.ui-icon-unlocked { background-position: -208px -96px; }\n.ui-icon-bookmark { background-position: -224px -96px; }\n.ui-icon-tag { background-position: -240px -96px; }\n.ui-icon-home { background-position: 0 -112px; }\n.ui-icon-flag { background-position: -16px -112px; }\n.ui-icon-calendar { background-position: -32px -112px; }\n.ui-icon-cart { background-position: -48px -112px; }\n.ui-icon-pencil { background-position: -64px -112px; }\n.ui-icon-clock { background-position: -80px -112px; }\n.ui-icon-disk { background-position: -96px -112px; }\n.ui-icon-calculator { background-position: -112px -112px; }\n.ui-icon-zoomin { background-position: -128px -112px; }\n.ui-icon-zoomout { background-position: -144px -112px; }\n.ui-icon-search { background-position: -160px -112px; }\n.ui-icon-wrench { background-position: -176px -112px; }\n.ui-icon-gear { background-position: -192px -112px; }\n.ui-icon-heart { background-position: -208px -112px; }\n.ui-icon-star { background-position: -224px -112px; }\n.ui-icon-link { background-position: -240px -112px; }\n.ui-icon-cancel { background-position: 0 -128px; }\n.ui-icon-plus { background-position: -16px -128px; }\n.ui-icon-plusthick { background-position: -32px -128px; }\n.ui-icon-minus { background-position: -48px -128px; }\n.ui-icon-minusthick { background-position: -64px -128px; }\n.ui-icon-close { background-position: -80px -128px; }\n.ui-icon-closethick { background-position: -96px -128px; }\n.ui-icon-key { background-position: -112px -128px; }\n.ui-icon-lightbulb { background-position: -128px -128px; }\n.ui-icon-scissors { background-position: -144px -128px; }\n.ui-icon-clipboard { background-position: -160px -128px; }\n.ui-icon-copy { background-position: -176px -128px; }\n.ui-icon-contact { background-position: -192px -128px; }\n.ui-icon-image { background-position: -208px -128px; }\n.ui-icon-video { background-position: -224px -128px; }\n.ui-icon-script { background-position: -240px -128px; }\n.ui-icon-alert { background-position: 0 -144px; }\n.ui-icon-info { background-position: -16px -144px; }\n.ui-icon-notice { background-position: -32px -144px; }\n.ui-icon-help { background-position: -48px -144px; }\n.ui-icon-check { background-position: -64px -144px; }\n.ui-icon-bullet { background-position: -80px -144px; }\n.ui-icon-radio-on { background-position: -96px -144px; }\n.ui-icon-radio-off { background-position: -112px -144px; }\n.ui-icon-pin-w { background-position: -128px -144px; }\n.ui-icon-pin-s { background-position: -144px -144px; }\n.ui-icon-play { background-position: 0 -160px; }\n.ui-icon-pause { background-position: -16px -160px; }\n.ui-icon-seek-next { background-position: -32px -160px; }\n.ui-icon-seek-prev { background-position: -48px -160px; }\n.ui-icon-seek-end { background-position: -64px -160px; }\n.ui-icon-seek-start { background-position: -80px -160px; }\n/* ui-icon-seek-first is deprecated, use ui-icon-seek-start instead */\n.ui-icon-seek-first { background-position: -80px -160px; }\n.ui-icon-stop { background-position: -96px -160px; }\n.ui-icon-eject { background-position: -112px -160px; }\n.ui-icon-volume-off { background-position: -128px -160px; }\n.ui-icon-volume-on { background-position: -144px -160px; }\n.ui-icon-power { background-position: 0 -176px; }\n.ui-icon-signal-diag { background-position: -16px -176px; }\n.ui-icon-signal { background-position: -32px -176px; }\n.ui-icon-battery-0 { background-position: -48px -176px; }\n.ui-icon-battery-1 { background-position: -64px -176px; }\n.ui-icon-battery-2 { background-position: -80px -176px; }\n.ui-icon-battery-3 { background-position: -96px -176px; }\n.ui-icon-circle-plus { background-position: 0 -192px; }\n.ui-icon-circle-minus { background-position: -16px -192px; }\n.ui-icon-circle-close { background-position: -32px -192px; }\n.ui-icon-circle-triangle-e { background-position: -48px -192px; }\n.ui-icon-circle-triangle-s { background-position: -64px -192px; }\n.ui-icon-circle-triangle-w { background-position: -80px -192px; }\n.ui-icon-circle-triangle-n { background-position: -96px -192px; }\n.ui-icon-circle-arrow-e { background-position: -112px -192px; }\n.ui-icon-circle-arrow-s { background-position: -128px -192px; }\n.ui-icon-circle-arrow-w { background-position: -144px -192px; }\n.ui-icon-circle-arrow-n { background-position: -160px -192px; }\n.ui-icon-circle-zoomin { background-position: -176px -192px; }\n.ui-icon-circle-zoomout { background-position: -192px -192px; }\n.ui-icon-circle-check { background-position: -208px -192px; }\n.ui-icon-circlesmall-plus { background-position: 0 -208px; }\n.ui-icon-circlesmall-minus { background-position: -16px -208px; }\n.ui-icon-circlesmall-close { background-position: -32px -208px; }\n.ui-icon-squaresmall-plus { background-position: -48px -208px; }\n.ui-icon-squaresmall-minus { background-position: -64px -208px; }\n.ui-icon-squaresmall-close { background-position: -80px -208px; }\n.ui-icon-grip-dotted-vertical { background-position: 0 -224px; }\n.ui-icon-grip-dotted-horizontal { background-position: -16px -224px; }\n.ui-icon-grip-solid-vertical { background-position: -32px -224px; }\n.ui-icon-grip-solid-horizontal { background-position: -48px -224px; }\n.ui-icon-gripsmall-diagonal-se { background-position: -64px -224px; }\n.ui-icon-grip-diagonal-se { background-position: -80px -224px; }\n\n\n/* Misc visuals\n----------------------------------*/\n\n/* Corner radius */\n.ui-corner-all,\n.ui-corner-top,\n.ui-corner-left,\n.ui-corner-tl {\n\tborder-top-left-radius: 3px;\n}\n.ui-corner-all,\n.ui-corner-top,\n.ui-corner-right,\n.ui-corner-tr {\n\tborder-top-right-radius: 3px;\n}\n.ui-corner-all,\n.ui-corner-bottom,\n.ui-corner-left,\n.ui-corner-bl {\n\tborder-bottom-left-radius: 3px;\n}\n.ui-corner-all,\n.ui-corner-bottom,\n.ui-corner-right,\n.ui-corner-br {\n\tborder-bottom-right-radius: 3px;\n}\n\n/* Overlays */\n.ui-widget-overlay {\n\tbackground: #aaaaaa;\n\topacity: .3;\n\t-ms-filter: Alpha(Opacity=30); /* support: IE8 */\n}\n.ui-widget-shadow {\n\t-webkit-box-shadow: 0px 0px 5px #666666;\n\tbox-shadow: 0px 0px 5px #666666;\n}\n\n/* Jquery UI Styles End */\n\n.getBtn{    margin: 30px 0 0 0;\n  padding: 5px;\n  height: 35px;\n}\n.getBtn38{    \n  margin: 38px 0 0 0;\n  padding: 5px;\n  height: 35px;\n}\n.headerColorForGrid {\n  background-color: #cb7f66;\n  color: #000000;\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.ag-center-header .ag-header-cell-label {\n  justify-content: center;\n  padding-left: 14px;\n}\n.ag-header-cell.headerColorForGrid:hover {\n  background-color: transparent !important; /* Set to transparent or your preferred color */\n}\n.legend-container{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.color-indicator-box{\n  display: flex;\n  align-items: center;\n  margin-right: 30px;\n}\n.color-box{\n  width: 15px;\n  height: 15px;\n  margin-right: 5px;\n  border-radius: 7.5px;\n}\n.exact{\n  background-color:rgb(37, 180, 49)\n}\n.excess{\n  background-color: orange;\n}\n.under{\n  background-color: rosybrown;\n}\n.logout-icon {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.popup {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background-color: #F5F5F5;\n  border: 1px solid #ccc;\n  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\n  z-index: 1;\n  width: 200px;\n  padding: 10px;\n  border-radius: 10px;\n}\n\n.popup ul {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n.popup li {\n  padding: 5px;\n  text-decoration: none;\n  color: #070000;\n  display: block;\n  font-weight: bold\n}\n\n.popup li a {\n  text-decoration: none;\n  color: #070000;\n  display: block;\n  font-weight: bold\n}\n\n.popup li a:hover {\n  color: green;\n}\n.popup li:hover {\n  color: green;\n}\n.password-input{\n  margin-bottom: 10px;\n}\n.password-label{\n  margin: 0px;\n}\n.err-msg{\n  color: red;\n}\n.loader-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n}\n\n.loader-spinner {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-top: 4px solid #3498db; /* Blue color for the spinner */\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loader-label {\n  margin-top: 10px;\n  font-size: 16px;\n  color: #333;\n}\n.app {\n  text-align: center;\n  margin-top: 50px;\n}\n\n.delete-popup {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 999; /* Ensure it's on top */\n}\n\n.delete-content {\n  background-color: white;\n  width: 400px;\n  padding: 30px;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  text-align: center; /* Center the content */\n}\n\n.popup-buttons {\n  display: flex;\n  justify-content: center;\n  margin-top: 30px;\n}\n\n/* Style for close (X) button */\n.close-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n}\n#testGrid .ag-header.ag-pivot-off{\n  /* background:#c86544; */\n  color:\"#000000\";\n  font-weight: bold;\n  cursor: default !important;\n}\n#testGrid .ag-header-cell:hover {\n  background-color: #c86544!important; /* or any specific color you want */\n  /* Add any other styles you want to modify on hover */\n}\n.ag-cell.no-pointer {\n  cursor: default !important; /* Use the default arrow cursor */\n}\n#testGrid .ag-cell-value:hover{\n  cursor: pointer;\n}\n.your-row-class:hover {\n  background-color: #bcc3c0 !important;\n  z-index: 1; /* Change this to your desired background color */\n}\n#myGrid1 .ag-header.ag-pivot-off{\nbackground:#beddeb;\ncolor:black;\nfont-weight: bolder;\nfont-size: 14px;\n}\n.nsaibg{\nbackground-color: #809fff\n}\n.pobg{\n  background-color: #00cccc\n}\n.s-aibg{\n  background-color: #66ff99\n}\n.etpbg{\n  background-color: #66ff99\n}\n.espbg{\n  background-color: #ff8fa3\n}\n.upbg{\n  background-color: #fdc958\n}\n.ag-theme-balham .ag-header.row {\n  background-color: \"blue\" !important;\n}\n.counter-header-color{\n  color: black;\n}\n.counter-card-plate{\n  /* background-color: blue; */\n  height: 120px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  color: black;\n  padding: 0px;\n  border-right: 1px solid #9a8c98;\n}\n.counter-pointer{\n  cursor: pointer;\n}\n\n.column-header-style{\n  font-weight: bold;\n  color: black;\n}\n.info-icon {\n  position: absolute;\n  top: -20px; /* Adjust top position as needed */\n  right: 3px; /* Adjust right position as needed */\n  cursor: pointer;\n}\n\n\n/* Tooltip Styling (Initially Hidden) */\n.info-tooltip {\n  position: absolute;\n  top: 20px;\n  \n  right: 50%; /* Adjust as needed to position the tooltip correctly */\n  background-color: #f9f9f9;\n  opacity: 0.9;\n  color: black;;\n  padding: 10px;\n  border-radius: 5px;\n  display: none;\n  width: 300px;\n  font-weight: bold;\n  z-index: 9999;\n}\n.info-tooltip-new {\n  position: absolute;\n  top: 20px;\n  left: 50%;\n  right: 50%; /* Adjust as needed to position the tooltip correctly */\n  background-color: #f9f9f9;\n  opacity: 0.9;\n  color: black;\n  padding: 10px;\n  border-radius: 5px;\n  display: none;\n  width: 300px;\n  font-weight: bold;\n  z-index: 9999;\n}\n\n/* Tooltip Appearance on Hover */\n.info-icon:hover .info-tooltip {\n  display: block;\n}\n.info-icon:hover .info-tooltip-new {\n  display: block;\n}\n.no-margin{\n  margin: 0px;\n}\n\n:root {\n  --bar-color: #168aad;\n  --ball-color: #80ed99;\n  --bg-color: rgb(68, 206, 125);\n}\n\n#loader {\n  position: fixed;\n  top: 50%;\n  left: 53%;\n  transform: translate(-50%, -50%);\n  width: 150px;\n  height: 100px;\n}\n\n.loader__bar {\n  position: absolute;\n  bottom: 0;\n  width: 13px;\n  height: 59%;\n  background: var(--bar-color); /* Replace with your desired color value */\n  transform-origin: center bottom;\n  box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);\n}\n\n/* Generate .loader__bar styles and animations */\n.loader__bar:nth-child(1) {\n  left: 0;\n  transform: scale(1, 0.2);\n  animation: barUp1 4s infinite;\n}\n\n.loader__bar:nth-child(2) {\n  left: 15px;\n  transform: scale(1, 0.4);\n  animation: barUp2 4s infinite;\n}\n\n.loader__bar:nth-child(3) {\n  left: 30px;\n  transform: scale(1, 0.6);\n}\n\n.loader__bar:nth-child(4) {\n  left: 45px;\n  transform: scale(1, 0.8);\n  animation: barUp4 4s infinite;\n}\n\n.loader__bar:nth-child(5) {\n  left: 60px;\n  transform: scale(1, 1);\n  animation: barUp5 4s infinite;\n}\n\n.loader__ball {\n  position: absolute;\n  bottom: 10px;\n  left: 0;\n  width: 13px;\n  height: 13px;\n  background: var(--ball-color); /* Replace with your desired color value */\n  border-radius: 50%;\n  animation: ball 4s infinite;\n}\n@keyframes ball {\n  0% {\n    transform: translate(0, 0);\n  }\n  5% {\n    transform: translate(8px, -14px);\n  }\n  10% {\n    transform: translate(15px, -10px)\n  }\n  17% {\n    transform: translate(23px, -24px)\n  }\n  20% {\n    transform: translate(30px, -20px)\n  }\n  27% {\n    transform: translate(38px, -34px)\n  }\n  30% {\n    transform: translate(45px, -30px)\n  }\n  37% {\n    transform: translate(53px, -44px)\n  }\n  40% {\n    transform: translate(60px, -40px)\n  }\n  50% {\n    transform: translate(60px, 0)\n  }\n  57% {\n    transform: translate(53px, -14px)\n  }\n  60% {\n    transform: translate(45px, -10px)\n  }\n  67% {\n    transform: translate(37px, -24px)\n  }\n  70% {\n    transform: translate(30px, -20px)\n  }\n  77% {\n    transform: translate(22px, -34px)\n  }\n  80% {\n    transform: translate(15px, -30px)\n  }\n  87% {\n    transform: translate(7px, -44px)\n  }\n  90% {\n    transform: translate(0, -40px)\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n@keyframes barUp1 { \n  0% {\n    transform: scale(1, .2);\n  }\n  40%{\n    transform: scale(1, .2);\n  }\n  50% {\n    transform: scale(1, 1);\n  }\n  90% {\n    transform: scale(1,1);\n  }\n  100% {\n    transform: scale(1,.2);\n  }\n}\n@keyframes barUp2 { \n  0% {\n    transform: scale(1, .4);\n  }\n  40% {\n    transform: scale(1, .4);\n  }\n  50% {\n    transform: scale(1, .8);\n  }\n  90% {\n    transform: scale(1, .8);\n  }\n  100% {\n    transform: scale(1, .4);\n  }\n}\n@keyframes barUp3 { \n  0% {\n    transform: scale(1, .6);\n  }\n  100% {\n    transform: scale(1, .6);\n  }\n}\n@keyframes barUp4 { \n  0% {\n    transform: scale(1, .8);\n  }\n  40% {\n    transform: scale(1, .8);\n  }\n  50% {\n    transform: scale(1, .4);\n  }\n  90% {\n    transform: scale(1, .4);\n  }\n  100% {\n    transform: scale(1, .8);\n  }\n}\n@keyframes barUp5 { \n  0% {\n    transform: scale(1, 1);\n  }\n  40% {\n    transform: scale(1, 1);\n  }\n  50% {\n    transform: scale(1, .2);\n  }\n  90% {\n    transform: scale(1, .2);\n  }\n  100% {\n    transform: scale(1, 1);\n  }\n}\n\n.new-loader {\n  top: 48%;\n  left: 51%;\n  transform: translate(-50%, -50%);\n  position: absolute;\n}\n.bar {\n  width: 20px;\n  height: 90px;\n  /* background: #fff; */\n  display: inline-block;\n  transform-origin: bottom center;\n  border-top-right-radius: 20px;\n  border-top-left-radius: 20px;\n  /*   box-shadow:5px 10px 20px inset rgba(255,23,25.2); */\n  animation: loader 1.2s linear infinite;\n}\n.bar1 {\n  animation-delay: 0.1s;\n}\n.bar2 {\n  animation-delay: 0.2s;\n}\n.bar3 {\n  animation-delay: 0.3s;\n}\n.bar4 {\n  animation-delay: 0.4s;\n}\n.bar5 {\n  animation-delay: 0.5s;\n}\n.bar6 {\n  animation-delay: 0.6s;\n}\n.bar7 {\n  animation-delay: 0.7s;\n}\n.bar8 {\n  animation-delay: 0.8s;\n}\n\n@keyframes loader {\n  0% {\n    transform: scaleY(0.1);\n    background: #168aad;\n  }\n  50% {\n    transform: scaleY(1);\n    background: #80ed99;\n  }\n  100% {\n    transform: scaleY(0.1);\n    background: blueviolet;\n  }\n}\n#sidebar {\n  height: 100%;\n  position: fixed;\n  top: 0;\n}\n#top-navbar {\n  height: 100%;\n  position: sticky;\n  top: 0;\n  /* z-index: 10000; */\n}\n.slider-z-index{\n  z-index: 10001;\n}\n\n.sliderbg {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5); /* Adjust the last value (0.7) for opacity */\n  z-index: 10003; /* Ensure the overlay is on top of other content */\n}\n.result-summary-table{\n  width: 100%;\n  height: 277px;\n  font-size: 13px!important;\n  font-weight: bold;\n}\n.result-summary-html-table{\n  font-size: 15px;\n  color: black;\n}\n.sidebar-txt{\n  font-size: 10px!important;\n}\n@media screen and (min-width: 1920px) {\n  /* Your styles for screens with a width of at least 1920 pixels go here */\n  .f14{font-size: 17px;}\n  .f15{font-size: 19px;}\n  .f17{font-size: 20px;}\n  .f19{font-size: 23px;}\n  .f20{font-size: 25px;}\n  .f35{font-size: 40px;}\n  .f23{font-size: 27px;}\n  .counter-card-plate{\n    /* background-color: blue; */\n    height: 150px;\n  }\n  .info-icon{\n    font-size: 15px;\n  }\n  .info-tooltip{\n    width: 400px;\n    font-size: 17px;\n    padding-bottom: 0px;\n  }\n  .mt-5p{\n    margin-top: 10px;\n  }\n  .custom-col {\n    flex: 0 0 12.5%;\n    max-width: 12.5%;\n  }\n  .headerColorForGrid {\n    font-size: 17px;\n  }\n  .result-summary-table{\n    width: 100%;\n    height: 277px;\n    font-size: 15px!important;\n    font-weight: bold;\n  }\n  .result-summary-html-table{\n    font-size: 17px;\n  }\n  .sidebar-txt{\n    font-size: 13px!important;\n  }\n  #myGrid1{\n    font-size: 14px!important;\n  }\n}\n.new-popup-bg-container{\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 10000; /* Ensure it's on top */\n}\n.new-popup-container{\n  background-color: #f9f9f9;\n  padding: 20px;\n  width: 400px;\n  border-radius: 10px;\n  text-align: center;\n}\n.new-loader-container{\nposition: absolute;\nz-index: 1001;\n}\n.new-overlay {\n  position: absolute;\n  background: rgba(255, 255, 255, 0.7); /* Semi-transparent white overlay */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000; /* Adjust as needed to make sure it's above other elements */\n}\n.new-label{\n  font-size: 15px;\n  color: #555;\n  font-weight: bold;\n  margin-bottom: 0px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
